// ─── EscContentCreatorPro v223 — Slim Orchestrator (UI-only) ───────────────────────────
// Phase 10: Thin wiring layer — delegates all logic to hooks and all UI to steps.
// [FEAT-v223] Superadmin «Piani» (/admin/plans) in SOLA LETTURA: i piani raggruppati per famiglia (dalla griglia
//   GET /admin/plan-features, ordinate dal piano più economico), con prezzo senza valuta («non in vendita» se nullo),
//   crediti per periodo, periodo, workspace e utenti del piano, self-serve, stato (nessuna colonna funzioni); sotto,
//   la griglia famiglie × funzioni con i nomi confermati («Generazione Contenuti», «Blog SEO»…). Eliminati PlanModal e
//   adminCreatePlan / adminUpdatePlan (rispondevano sempre 422): i piani si modificano dal team tecnico via CLI.
//   Errori formulati da adminErrorText, mai il testo del server. Nessuna modifica al backend.
// [FEAT-v222] La casella dei Termini anche su OGNI cambio di piano («Passa ora» e cambio programmato; handoff BE
//   2026-11-03, backend ≥ d208cb9, abbinamento RIGIDO: quel backend rifiuta un /change-plan senza i campi). La conferma
//   legge GET /legal/current, il pulsante resta disabilitato finché non si spunta, /change-plan riceve le versioni
//   mostrate; un 409 TERMS_VERSION_CHANGED tiene aperta la conferma (il quote non è consumato), un nuovo quote tiene
//   la spunta. Nessuna casella se manca una carta utilizzabile (il pulsante apre il portale). Sopra la casella, dal
//   `terms` di GET /billing/subscription (accettazioni di CHI chiede): «Hai già accettato queste versioni…» (info) o
//   «…sono cambiati dall'ultima volta che li hai accettati…» (ambra); nessuna frase alla prima accettazione o se
//   illeggibile. /change-plan/preview resta {plan_id}.
// [FEAT-v221] Accettazione di Termini di servizio e Informativa privacy (handoff BE 2026-10-29 § 1, backend ≥ 04b820f,
//   abbinamento RIGIDO in entrambe le direzioni). /set-password e i due acquisti (piano, pacchetto) leggono a ogni
//   apertura GET /legal/current (src/legal/) e mostrano la casella obbligatoria «Accetto i Termini di servizio e ho
//   letto l'Informativa privacy» con i link https della versione (+ PDF); il corpo rimanda esattamente le versioni
//   mostrate (null compreso). Un 409 TERMS_VERSION_CHANGED prende i nuovi testi dal corpo, toglie la spunta e mostra
//   l'avviso ambra (il link di /set-password resta valido; la conferma d'acquisto resta aperta). Lettura fallita →
//   «Riprova», niente invio. /set-password chiama anche POST /auth/set-password/info: un link non valido mostra
//   subito il pannello; la casella facoltativa delle comunicazioni commerciali (testo SEGNAPOSTO) appare e si invia
//   solo se il backend lo chiede. AuthNotice ha il tono «warning» (ambra); BillingConfirmDialog ha confirmDisabled.
// [FEAT-v220] Blog SEO → la scheda dell'output segue il Figma «Content Generator 1.1» (components/outputs/blogSeo/):
//   renderResultEntry manda un'entry del costruttore blog-seo a BlogSeoResultEntry, gli altri formati restano su
//   PiecesResultEntry. Card principale con linguette Testo | HTML | META (SegmentedTabs: tablist vero, frecce):
//   Testo = H1, H2 nell'accento, ogni H3 col suo contenuto in un blocco rientrato con bordo a sinistra, elenchi
//   veri, FAQ e «Fonti citate» solo se presenti (dai pezzi strutturati, mai da body_html); HTML = riquadri «H1 /
//   Titolo», «Corpo» (body_html aperto, scorrevole), «FAQ» e le card «Internal links», ognuno col suo «Copia» (solo
//   testo); META = title page, meta title (60), meta description (160) e URL slug con etichetta, contatore e «Copia»
//   (solo testo). «Copia» in testata copia la linguetta attiva (Testo: testo + HTML pulito, id
//   "all-<entry>" per l'avviso di uscita; HTML e META solo testo). «Scarica tutto» porta nella card il catalogo di
//   publish/downloads.js, anche nel generatore; il «Dettaglio generazione» nasconde il suo «Scarica» per il blog.
//   Il pannello laterale Qualità | Fonti del Figma NON è disegnato (tolto per ora): sotto la card restano
//   «Affermazioni nel testo» e «Fonti consultate» di prima; la regola «Influenza delle fonti» per famiglia di
//   `kind` resta pronta e testata in blogSeo/sourceInfluence.js. Una selezione a mano nella linguetta Testo
//   copia senza stili (cleanCopy.js ammette anche h1). «Segnala un errore» è
//   disabilitato: l'unico endpoint (POST /pipeline/run/{id}/review) è un APPROVE / REJECT che cambia lo stato del
//   run.
// [FEAT-v219] Console superadmin → nuova voce «Configurazione» (impostazioni di SISTEMA, ultima, dopo un separatore)
//   → /admin/settings, scheda «TOS & Privacy» (admin/settings/SystemSettingsLayout, admin/legal/*): riepilogo della
//   versione in vigore di Termini di servizio e Privacy policy (avviso se nessuna, con quella programmata), tabella
//   delle versioni (Stato In vigore / Programmata / Sostituita, link pagina·PDF, copia PDF di Brian scaricabile,
//   impronta SHA-256 abbreviata e copiabile), «Nuova versione» (multipart, Subito / Da una data, conferma sui due
//   effetti) e «Correggi» (solo se il backend dice correctable; invia solo ciò che cambia). Esito in OutcomeDialog
//   dopo la rilettura. Backend ≥ 6991a98 (+ location nginx 6 MB).
// [FEAT-v219] La vecchia «Configurazione» (file del tenant, /admin/context-settings) esce dalla barra laterale e
//   diventa «Configurazione tenant» (scheda e titolo); EN "Tenant settings", voce file EN "Tenant options".
// [FIX-v218] Output → copia/incolla (work item 44 «Controllo degli output», fasi 1–3). Gli elenchi mostrano di
//   nuovo i puntini / i numeri (BlocksView: list-style-type inline, il preflight di Tailwind li toglieva). Gli
//   hashtag e i tag selezionati a mano si copiano con il separatore («#a #b», «a, b» per YouTube: TagChips
//   `separator`). Una selezione a mano dentro il riquadro di un pezzo copia pulito (pieces/cleanCopy.js: tag
//   consentiti, nessuno stile, nessun riquadro grigio né testo viola in Word / Gmail; il pezzo HTML e una
//   selezione che parte fuori dal riquadro restano al browser). I pezzi di sezione della Landing (hero,
//   problema, soluzione, caratteristiche, social proof, CTA finale) diventano `rich`: il loro «Copia» porta
//   l'HTML e in Word restano grassetto e paragrafi. «Copia tutto» di un post social (LinkedIn, Facebook,
//   Instagram, Pinterest) mette negli appunti solo testo (publish/downloads.js :: copyAllHtml): LinkedIn
//   appiattiva l'HTML e perdeva gli a capo. v216–v217 sono del ramo feature/hubspot-integration.
// [FEAT-v215] Superadmin → Utenti: la scheda di una persona ha la sezione «Aziende» (GET /admin/users/{id}/customers:
//   azienda con link, ruolo, stato), perché un amministratore d'azienda accede a TUTTI i tenant dell'azienda senza
//   comparire nella lista «Tenant». «Rimuovi da tenant» su un tenant di un'azienda che la persona amministra avvisa
//   che l'accesso resta; il blocco «ultimo amministratore» di «Elimina definitivamente…» nomina le aziende
//   (preview `last_admin_of[]`) con un link ciascuna. La pagina Tenant dice sotto «Utenti di …» che gli
//   amministratori dell'azienda proprietaria accedono anche loro. Un backend precedente (404, campo assente): nessuna
//   sezione, la frase generica di prima. [ZERO-BREAK]
// [FEAT-v214] Output → la scheda del generatore perde il pulsante «Scarica» (il catalogo dei file resta nel
//   «Dettaglio generazione» dello Storico); «Copia per pubblicare» diventa «Copia tutto» e copia in un colpo solo
//   TUTTI i pezzi con la loro etichetta (publish/downloads.js :: allPiecesText / allPiecesHtml, testo e HTML),
//   cioè quello che i «Copia» delle singole sezioni copiano uno alla volta, meta title / description / slug /
//   hashtag compresi; il contatore resta sul pezzo principale. Il «Copia» di ogni sezione resta. L'avviso prima
//   di una nuova generazione conta un output come conservato dopo «Copia tutto» (id "all-<entryId>") e dice
//   «Copia i contenuti…».
// [FEAT-v213] Blog SEO → la voce «Fonti citate» (pezzo sources di publish/pieces/blogSeo.js) si costruisce da
//   content.references + sources_consulted (claimsModel.resolveReferences, backend ≥ e162398): «[N] titolo — url»
//   con il link solo http(s), «(non apribile dai lettori)» per una fonte senza link, «fonte non indicata» senza
//   titolo. Il backend non invia più results.sources.cited: via SourcesCitedBlock (la riga del pezzo è l'unica
//   lista a schermo) e i pezzi SeoReferences / seoReferences della v208, assorbiti dal costruttore; i marcatori
//   «[N]» restano nel testo quando la voce esiste. Il campione publish/__fixtures__/blog-seo.json porta i due
//   campi; entryFromSample usa la mappatura condivisa utils/runResults.js.
// [ARCH-v213] Output → pulizia: eliminati i renderer per formato (LinkedIn, Social, Email, Ads, CaseStudy, Blog,
//   Carousel, Seo, Newsletter, Instagram, Facebook, YouTube, Pinterest, Landing) con CtaUrlBlock, FactCheckPanel,
//   ui/CopyButton e i loro test; tolti gli helper senza consumatori (getBlogHtml / getBlogHtmlForEntry,
//   getCopyPayload / getCopyPayloadForEntry, copyPayloadForEntry di publish/downloads.js, sanitizeHtml, i rami per
//   i vecchi campi fullPost / slides / subjectLine di getFullOutputTextForEntry: lo storico vive solo in memoria e
//   nessun modulo lo riidrata; useHistory salva con publish/downloads.js :: downloadBlob, senza copia privata); chiavi i18n morte
//   rimosse (outputs: i gruppi dei renderer, export.*; wizard: step3.downloadAll, step3.dlGroups). Il brief
//   fixture blogSeoMocks resta per admin/mockRuns.js.
// [FEAT-v213] Storico Generazioni → «Scarica» anche nel «Dettaglio generazione» (admin/pages/RunDetailPage.jsx, le
//   due console): stesso catalogo e stesso menu del generatore, offerto solo a run completata con un risultato;
//   un file che non si costruisce non salva e non dice nulla. Il menu è components/outputs/DownloadMenu.jsx
//   (estratto da Step3History, didascalie dei gruppi in outputs:downloads.groups.*); il salvataggio è
//   publish/downloads.js :: downloadBlob, unico per generatore e console.
// [FEAT-v213] Output → UN solo schermo per ogni formato: il corpo della scheda in cronologia è
//   components/outputs/PiecesResultEntry.jsx, disegnato dalla lista dei pezzi (Qualità → «Pronto da pubblicare» con
//   l'UNICO pulsante «Copia per pubblicare» e il contatore → una riga per ogni altro pezzo con etichetta,
//   destinazione, contatore e «Copia» → parole / lettura → Fonti). L'email ha così la sua schermata (oggetto,
//   bottone, firma, PS). La testata della scheda perde il pulsante di copia e tiene «Scarica». Nessun
//   dangerouslySetInnerHTML: i blocchi diventano elementi React (pieces/BlocksView.jsx). Il «Dettaglio generazione»
//   della console usa lo stesso corpo col tema chiaro.
// [ARCH-v213] Output → modulo src/publish/ (proposta plans/2026-10-05-1833-output-structure-proposal.md): ogni formato
//   in vendita ha la sua lista di PEZZI (piece.js, pieces/<formato>.js: pezzo principale pronto da incollare + i
//   pezzi di contorno), costruita dai campi strutturati del backend e normalizzata una volta sola (normalize.js: HTML
//   inline, grassetti Markdown, marcatori «[N]» → blocchi e run), e i serializzatori testo / Markdown / HTML / CSV /
//   .docx / .pdf (serialize/). È l'UNICO lettore dei campi di contenuto per schermo, copia e download; content.full_text
//   non è mai la sorgente finché esistono i campi strutturati: lo leggono solo, come ULTIMO ripiego, il costruttore
//   generico (pieces/generic.js, senza body né hook) e getFullOutputTextForEntry (voce senza pezzi). Funzioni pure,
//   fissate sui campioni della proposta (publish/__fixtures__).
// [FEAT-v213] Output → «Copia tutto» diventa «Copia per pubblicare»: negli appunti va il SOLO pezzo principale
//   (title del pulsante = il nome del pezzo); per i formati ricchi (newsletter, blog, email, landing) la copia è
//   formattata (text/html + text/plain). I marcatori «[N]» restano nel testo solo se l'output elenca le fonti.
// [FEAT-v213] Output → «Scarica» è un catalogo per formato (publish/downloads.js, 9 voci in tre gruppi): «Pronto da
//   pubblicare» .txt (tutti) / .html (formati ricchi); «Tutti i pezzi» .txt (tutti), .md (newsletter, blog), .html
//   (ricchi), .docx e .pdf (youtube, carosello, ricchi); «Slide (.csv)» (carosello, una riga per slide per Canva /
//   PowerPoint); «Brief (.json)» (tutti). I file di contenuto portano SOLO i pezzi — un titolo (quello del contenuto,
//   non l'argomento del brief), poi un'intestazione per pezzo — senza dati della run, riepilogo del brief né
//   marcatore ESC_INPUT_DATA_V1: il brief ha il suo file «<stem>_brief.json» (lo stesso payload che Step 1 reimporta;
//   i vecchi file con il marcatore nel testo si importano ancora). Nomi: publish/fileName.js
//   («<piattaforma>-<formato>_<slug>_<data>»). Il backend non sa nulla del catalogo.
// [FEAT-v213] Output → .docx vero (libreria docx: Titolo 1-3, grassetto / corsivo, link, elenchi puntati e numerati,
//   slide = titolo + paragrafi, FAQ = domanda in grassetto + risposta, codice in monospazio) e .pdf di solo testo
//   selezionabile (jsPDF, API testo: A4, margini, a capo, titoli, elenchi, link sottolineati, cambio pagina) costruiti
//   dai blocchi, caricati su richiesta: html2pdf.js rimosso. La finestra rapida della console (RunDetailModal) mostra
//   TUTTI i pezzi (getFullOutputTextForEntry = ogni pezzo in testo semplice), non il solo pezzo principale. Un
//   download conta come fatto (per l'avviso «output non scaricato») solo se il file è stato davvero salvato.
// [FEAT-v212] Console superadmin → «Aziende» (admin/pages/CompanyListPage, CompanyDetailPage): elenco con ricerca
//   per nome o partita IVA, filtri «Disattivate» e «Senza tenant», numero di tenant; dettaglio con dati, piano,
//   tenant (link alla pagina Tenant, ?tenant=) e persone; «Disattiva» / «Riattiva»; «Elimina definitivamente…»
//   solo per un'azienda disattivata con tutti i tenant ritirati. Eliminazione (admin/companies/CompanyPurgeDialog):
//   nessuna modalità preselezionata — «Chiusura» (lo storico di fatturazione resta 10 anni) o «Cancellazione
//   totale» (solo dati di prova; grigia con dati Stripe reali); anteprima a parole nostre, ID digitato, «può
//   richiedere qualche minuto», errore di rete = «non sappiamo se è terminata». Un'eliminazione avviata e non
//   terminata si completa dalla pagina dell'azienda. Backend ≥ 289980e.
// [FEAT-v212] Tenant e persona: anteprima ed esito nominano l'azienda che resta senza tenant, con «Apri l'azienda»;
//   pagina Tenant: «Apri azienda». Il rifiuto «ultimo amministratore» rimanda alla pagina Aziende.
// [FEAT-v211] Generatore e dettaglio generazione: «Affermazioni e fonti» diventa due pannelli richiudibili, ciascuno
//   con una riga che dice a cosa serve. «Affermazioni nel testo»: un blocco per sezione (fascia con il tipo —
//   Sezione, Sottosezione, FAQ… — il titolo e quante affermazioni contiene); la nota sulle affermazioni controllate
//   che non sono più nel testo finale riguarda tutto il testo, sta in fondo ed è riformulata. «Fonti consultate»:
//   chiuso all'apertura, conteggio per tipo nell'intestazione, un blocco per tipo (link del brief, file, documenti,
//   sito, ricerca web). Componenti condivisi: components/claims/CollapsiblePanel, GroupBlock.
// [FIX-v210] Avviso REFERENCES_UNAVAILABLE (blog-seo, backend e46a3cd) a parole nostre: «Riferimenti non
//   disponibili» — l'articolo è completo ma senza riferimenti numerati alle fonti. Solo testo (outputs.json it/en,
//   warningCopy.js). [ZERO-BREAK]
// [FIX-v209] Tenant eliminato (410 TENANT_PURGED): il tenant da togliere si legge dal campo tenant_id della risposta,
//   non più dedotto dalla richiesta (un 410 rimasto in cache del browser per A non fa più sparire B; anche quando la
//   richiesta non nominava un tenant). Backend senza il campo: si deduce dalla richiesta come prima.
// [FIX-v209] Console superadmin: «È in corso un'altra eliminazione…» (409 PURGE_IN_PROGRESS) e «L'account è stato
//   eliminato…» (409 USER_PURGED) con una frase loro invece del codice; un'anteprima bloccata ha «Riprova». L'account
//   anonimizzato si riconosce da purged_at (vecchio backend: l'indirizzo @purged.invalid).
// [FEAT-v208] Generatore → «Affermazioni e fonti» (backend e162398): un solo pannello (components/claims/) al posto
//   delle tabelle «Verifica» e «Fonti di ricerca»: per ogni affermazione del testo finale lo stato a parole nostre
//   (Dal brief, Dai dati aziendali, Trovato in una fonte, Corrisponde in parte, In contrasto, Nessuna fonte trovata,
//   Non controllato — mai «Verificato»), la frase con il dato evidenziato, fonte, citazione, valore corretto; sotto,
//   le fonti consultate (link solo http/https). Aperto se c'è qualcosa da sistemare. Anche nel dettaglio della
//   generazione (RunDetailPage). Generazioni precedenti, Pinterest e YouTube: nessun pannello.
// [FEAT-v208] Avvisi della generazione a parole nostre e colorati per gravità (components/warnings/): rosso per le
//   regole del brand violate (BRAND_TABOO_IN_TEXT: frase evidenziata e dove si trova) e gli errori, ambra per gli
//   avvisi, neutro per i suggerimenti; termini da sostituire con «Usa: …»; codice ignoto → codice stampato, mai il
//   testo del server. La metrica Fact-Check segue l'esito del controllo (disattivato o fallito → «N/A»).
// [FEAT-v208] Blog SEO → «Riferimenti» sotto il testo (content.references): [N] e titolo della fonte, con link se
//   apribile; inclusi nella copia del tab Testo. Via il blocco «FONTI CITATE» da tutti i formati (il backend non lo
//   invia più) e il codice morto (FactCheckPanel, BlogResultEntry). Dettaglio generazione: i dati grezzi (JSON) solo
//   per i superadmin.
// [FIX-v207] Console superadmin: il rifiuto «ultimo amministratore dell'azienda» (CANNOT_REMOVE_LAST_CUSTOMER_ADMIN,
//   eliminazione o disattivazione di una persona) non consiglia più azioni che la console non ha: dice che l'altro
//   amministratore lo nomina la persona (Gestione Workspace → Utenti) o un operatore (customer-add-user --role admin),
//   oppure che l'azienda va disattivata dal backend. Solo testo (admin.json it/en). [ZERO-BREAK]
// [FEAT-v206] Console superadmin → Tenant: l'elenco mostra anche i tenant ritirati («— ritirato»), l'ID del tenant
//   (copiabile), lo stato, «Ritira»/«Riattiva» (conferma → esito dalla risposta) ed «Elimina definitivamente…»
//   (grigio finché il tenant è attivo): anteprima del backend in parole nostre (contenuti, knowledge base, Brand
//   Voice, membri con il loro destino, cosa resta, cosa è fuori portata), conferma digitando l'ID, esito. Dopo
//   l'eliminazione la selezione si azzera PRIMA di rileggere e le pagine della console dimenticano il tenant salvato
//   (nessun 410 e nessun avviso «eliminato» dopo la propria eliminazione). admin/purge/*, admin/adminErrorCopy.js.
// [FEAT-v206] Console superadmin → Utente: «Elimina definitivamente…» (grigio per sé stessi e per un superadmin),
//   anteprima, conferma digitando l'email; account eliminato → «OK» torna all'elenco, anonimizzato → la pagina
//   mostra «Account eliminato». Gli account anonimizzati (…@purged.invalid) hanno il loro segno e nessuna azione,
//   anche nell'elenco utenti.
// [FIX-v206] Console superadmin → Tenant, Utenti, Utente: nessun testo del server negli errori (adminApi lancia
//   errori con codice; frasi nostre dal codice, codice stampato se sconosciuto, riferimento sui 5xx).
// [FEAT-v205] Workspace eliminato definitivamente (backend 554ad59): una risposta 410 TENANT_PURGED toglie QUEL
//   workspace da questo browser (elenco, workspace attivo, e `auth_purged_tenants` così un ricaricamento non lo fa
//   ricomparire da /auth/me fino al prossimo accesso — auth/tenantPurged.js) e, se era quello attivo, porta alla
//   scelta del workspace (mai una selezione automatica), a /no-access se non ne resta nessuno, alla console per un
//   superadmin. Un superadmin nella console va su /admin/tenants con un avviso; le pagine della console dimenticano
//   il tenant salvato. Mai «autorizzazioni cambiate», mai testo del server. Anche i client con fetch diretto
//   (generazione, personas/obiettivi/toni, caricamento file, lettura delle applicazioni) segnalano il 410.
// [FIX-v205] Console superadmin: gli avvisi (anche «I superadmin non utilizzano le applicazioni») compaiono a ogni
//   navigazione, non solo al primo ingresso nella console.
// [FIX-v205] Dopo la prova manuale (2026-10-10): il browser conservava la risposta 410 di un workspace eliminato e la
//   riusava per un ALTRO workspace sulle letture che lo indicano solo nell'intestazione X-Tenant-Id (personas,
//   obiettivi, toni, file caricati…): quel workspace veniva tolto per errore. Ora le richieste che indicano il
//   workspace SOLO nell'intestazione non usano mai la cache HTTP (`cache: 'no-store'`, in apiFetch e nelle letture
//   dirette); gli URL con `?tenant=` mantengono la cache voluta dal backend (crediti, statistiche: 60 s).
// [FEAT-v204] Abbonamento → «Passa ora» chiede PRIMA al backend quanto addebiterà (POST /billing/change-plan/preview,
//   billing/useChangeNow.js): la conferma mostra la tabella dell'importo (prezzo del nuovo piano, parte non usata del
//   piano attuale, IVA, totale — components/billing/ChargeSummary.jsx, cifre di Stripe stampate e mai calcolate,
//   billing/money.js), la carta («Verranno addebitati … sulla carta Visa che termina con 4242», nuovo codice
//   CHARGED_TO_SAVED_CARD) e il pulsante «Paga {totale} e passa a {piano}». Il cambio parte con il `quote` del preview:
//   se l'importo è cambiato o sono passati 5 minuti il preview si ripete e la conferma si riapre («L'importo è stato
//   ricalcolato…»). Senza una carta valida il pulsante apre l'aggiornamento del metodo di pagamento. Mai un addebito
//   senza preview (nessun ripiego se il preview manca). PERIOD_RESTARTS_TODAY non parla più di «momento del pagamento».
// [FEAT-v204] Abbonamento → 3-D Secure: 402 PAYMENT_ACTION_REQUIRED ha il suo esito (scadenza, «Conferma il
//   pagamento» apre la pagina di Stripe in una NUOVA scheda — solo link https, billing/stripeLink.js; al ritorno la
//   pagina attende che il pagamento risulti). `payment_pending` del backend → avviso nella riga del piano (cambio in
//   attesa della banca, rinnovo in attesa della banca, rinnovo rifiutato) e «Disdici» nascosto mentre un cambio
//   attende; righe del piano «in attesa della conferma della banca». Rifiuto della carta, cambio in attesa e 502
//   CHANGE_FAILED_CHANGE_RELEASED rileggono la pagina PRIMA dell'esito, che nomina il cambio programmato annullato
//   prima dell'addebito (`released_scheduled_plan_id`, non torna). Richiede backend ≥ 0d75469.
// [FIX-v204] Abbonamento → dopo la prova sul VPS (2026-10-10): «Aggiorna il metodo di pagamento» (verde) e «Disdici»
//   (neutro) sono chip accanto al titolo (components/billing/BillingTitleChips.jsx, slot `titleAside` di SectionCard); «Aggiorna il metodo di pagamento» apre il
//   portale Stripe in una NUOVA scheda (aperta vuota nel clic, poi indirizzata; se bloccata, stessa scheda) e al ritorno
//   la pagina rilegge; rifiuto della carta = «Il pagamento **non è andato a buon fine**. Aggiorna…» (grassetto: OutcomeDialog
//   rende `<b>…</b>` del nostro testo come elementi, mai HTML); «Passa ora» riprova il preventivo fino a 3 volte (il
//   totale si muove di ~1 centesimo ogni pochi minuti); testi «Passaggio immediato al piano …», «Verranno addebitati …».
// [FEAT-v203] Piani → ogni acquisto, cambio, disdetta, ripresa e «Annulla il cambio» si conferma in una finestra
//   (components/billing/BillingConfirmDialog.jsx, fuoco su «Indietro», Esc = Indietro) con le NOSTRE frasi dai
//   `disclosure_codes` del backend (billing/disclosureCopy.js; PLAN_CREDITS_RESTART non dice nulla; codice ignoto →
//   una frase generica); nessun importo. La sessione Stripe si apre SOLO dopo la conferma; se risponde con codici
//   diversi la conferma si riapre («Le condizioni sono cambiate…»). Esiti in OutcomeDialog, scritti dalla risposta.
// [FEAT-v203] Piani → «Disdici» chiede il motivo (facoltativo, 5 voci + commento ≤ 1000 caratteri), salvato dal
//   backend. Dopo disdetta / ripresa / cambio immediato la pagina rilegge ogni 3 s per ~30 s (azioni bloccate,
//   «Aggiornamento in corso…»; billing/useSubscriptionRead.js); se resta indietro mostra «Le modifiche possono
//   impiegare qualche minuto a comparire.»
// [FIX-v203] Piani → nessun testo del server (motivi delle righe, messaggi di /cancel /resume /cancel-change);
//   errori con riferimento per i 5xx; «Fino a N utenti» (il limite è per azienda); niente «Reindirizzamento…» sui
//   cambi; chiavi morte rimosse; ConfirmDisclosure.jsx eliminato. /billing/return non dice più «pagamento
//   ricevuto», nomina il piano e dalla console riporta nella console. «Piani» nel menu dell'avatar è grigio per chi
//   non è amministratore dell'azienda (auth/canBuyPlans.js); i link ai piani nei blocchi (crediti esauriti, prova
//   finita) solo per chi può acquistare.
// [FIX-v203] Piani → testi della conferma rivisti dopo la prova (2026-10-08): titolo «Acquista il piano {piano}»;
//   CURRENT_PLAN_CREDITS_END = «Il piano verrà attivato al momento del pagamento.»; PURCHASED_CREDITS_KEPT = «I crediti
//   extra che hai acquistato in precedenza restano disponibili nel nuovo piano.», detto SOLO se /credits/balance
//   mostra crediti acquistati > 0 (letto una volta per workspace; ignoto → detto; saldo negativo → non detto); tolta
//   da tutte le conferme la nota «Vale per l'intera azienda…» (chiave confirm.scope rimossa: lo dice già il
//   sottotitolo della pagina).
// [FIX-v203] Piani → schede: il pulsante del primo acquisto dice «Acquista» (era «Abbonati»); il nome del piano è la
//   riga grande e centrata (22px), il prezzo quella più piccola (16px). La scheda dei crediti extra ha lo stesso
//   aspetto: titolo «Crediti extra» (nuova chiave packs.cardTitle), prezzo, e sotto il numero di crediti.
//   Prezzi centrati su entrambe le schede; la scheda segnaposto (combinazione non disponibile) usa lo stesso nome
//   grande e centrato; il motivo «nessun abbonamento» dei crediti extra dice «acquista prima un piano».
// [FIX-v203] Piani → aspetto delle altre schede di Gestione Workspace: una SectionCard con icona, «Piani e
//   abbonamento» e il sottotitolo «Piano aziendale condiviso da tutti i workspace.»; dentro, periodicità e workspace
//   centrati sopra le schede. Tolto il riquadro «Il tuo piano» (e «Questo piano è gestito dal tuo amministratore.»):
//   resta una riga sottile solo quando serve — «Piano attuale: X» se il piano non ha una scheda (Free, Special),
//   «Aggiorna il metodo di pagamento» / «Disdici» se si paga con Stripe, cambio programmato, disdetta, aggiornamento in
//   corso. «Crediti extra» è una seconda SectionCard. Sulla scheda del piano attuale offerta come primo acquisto (piano
//   assegnato dall'operatore) il pulsante dice «Attiva il pagamento».
// [FIX-v203] Piani → le schede della griglia prendono il nome della FAMIGLIA («Starter», «Pro», «Full»): periodicità e
//   workspace li dicono già gli interruttori, e i nomi del server portano «(yearly)» / «Bundle» (le righe fuori
//   griglia, Free / Special, tengono il loro nome). Rinomina dei piani annuali chiesta al backend (handoff
//   plans/2026-10-08-1139-be-handoff-yearly-plan-names.md). Sottotitolo dei crediti extra riscritto. Finestra di
//   conferma: titolo, frasi e pulsanti centrati (il modulo del motivo di disdetta resta allineato a sinistra).
// [FIX-v203] Piani → le schede dei piani e quelle dei crediti extra usano la stessa griglia
//   (components/billing/cardGrid.js: minimo 260px, spazio 16px): a finestra stretta una scheda pacchetto non è più
//   larga metà di una scheda piano.
// [FIX-v203] La pagina «Piani» si chiama «Abbonamento» (EN «Subscription») ovunque l'utente ne legge il nome: menu
//   dell'avatar, scheda di Gestione Workspace, titolo della pagina, link «Abbonamento» in Crediti, «Vai
//   all'abbonamento» nella scheda Crediti, «Torna all'abbonamento» al ritorno dal pagamento, «scegline uno in
//   «Abbonamento»» e «Crediti e abbonamento seguono il workspace attivo». Percorsi e nomi nel codice invariati
//   (/billing, /tenant-admin/manage/plans, Piani.jsx).
// [FIX-v203] Piani → il pulsante del primo acquisto sulla scheda del piano dice «Attiva»; nella conferma (piano e
//   crediti extra) il pulsante che porta a Stripe dice «Acquista» (era «Vai al pagamento»). La scheda dei crediti
//   extra resta «Acquista», quella del piano attuale assegnato dall'operatore «Attiva il pagamento».
//   Il segno sulla scheda del piano in vigore dice «Abbonamento attuale» (era «Piano attuale»), e così la riga in alto
//   per un piano senza scheda («Abbonamento attuale: Free»); l'interruttore dei
//   workspace si chiama «Workspace inclusi».
// [FEAT-v202] Gestione Workspace → l'esito di ogni azione (Utenti, Workspace, Membri azienda) non è più un riquadro
//   sopra l'elenco ma una finestra con «OK» (nuovo components/ui/OutcomeDialog.jsx: icona e colore dal tono
//   info/successo/attenzione, nessun titolo, «OK» già a fuoco — Invio, Esc e un clic sullo sfondo valgono OK). L'azione
//   suggerita dall'esito («Reinvia invito» dopo una correzione d'indirizzo, «Accedi di nuovo» dopo la creazione di un
//   workspace — che DISCONNETTE) è un secondo pulsante, mai predefinito né raggiunto da Esc; cliccarlo chiude la
//   finestra ed esegue l'azione. Portalled su document.body, entra in modalStack (Esc chiude solo lei), Tab resta
//   dentro, alla chiusura il fuoco torna dov'era se l'elemento esiste ancora. Testi invariati. NoticeBanner rimosso
//   (e la chiave admin tenantUsers.dismissWarning); nuova chiave common:actions.ok.
// [FIX-v202] Gestione Workspace → l'esito si apre DOPO la rilettura dell'elenco (rimozione, reinvio, correzione
//   indirizzo su Utenti e Membri, rinomina): prima veniva impostato mentre il dialogo dell'azione era ancora aperto.
//   Su Utenti cambiare workspace chiude l'esito rimasto aperto; una risposta che arriva DOPO un cambio di workspace
//   (Utenti: riattiva, cambio ruolo) o di azienda (Membri: aggiungi, cambio ruolo; Workspace: crea) non apre esiti né
//   rilegge sopra quello nuovo. Un esito che ne sostituisce un altro (es. «Reinvia invito» su un indirizzo già al
//   limite) è una nuova finestra, annunciata di nuovo, con «OK» a fuoco.
// [FEAT-v202] Utenti → «Disattiva» chiede conferma con il ConfirmDialog dell'app («Disattiva utente» / «Disattivare
//   l'utente {email}?», pulsante rosso) invece di window.confirm; i rifiuti si leggono dentro il dialogo, che resta
//   aperto. Il rifiuto di un cambio di ruolo apre la finestra d'esito invece di alert(). Nuova chiave admin
//   tenantUsers.deactivateTitle. Le azioni che oggi riescono in silenzio restano silenziose.
// [FIX-v202] Utenti → testi: l'esito «ha già un account: gli è stato inviato un invito…» perde la frase sul nome
//   («Il nome eventualmente inserito non viene applicato a un account esistente.»). «Correggi email» parla dello
//   stato della persona: attiva/disattivata → «Da ora la persona accederà con il nuovo indirizzo. Brian non le invia
//   nessuna email: avvisala tu.» (esito: «…Da ora la persona accede con il nuovo indirizzo: avvisala tu, Brian non le
//   invia nessuna email.»); invitata → l'invito al vecchio indirizzo smette di funzionare (esito: «L'invito inviato a
//   {vecchio} non funziona più: usa «Reinvia invito» per mandarne uno nuovo a {nuovo}.»). Verificato sul BE: la
//   correzione non invia email e il link emesso per il vecchio indirizzo viene rifiutato. Membri azienda non sa se un
//   membro è ancora invitato: usa sempre il testo «attiva». Chiave tolta: manage.correctEmailInvited; nuove:
//   manage.correctEmailHintInvited, manage.correctEmailDoneInvited.
// [FIX-v202] Utenti → la conferma di «Rimuovi» dice cosa succede davvero (verificato sul BE: si toglie solo
//   l'appartenenza al workspace, l'account resta; una sessione aperta vede il workspace fino alla scadenza del suo
//   accesso; nessuna route elimina un account che ha già fatto l'accesso). Persona attiva/disattivata: «{email} non
//   potrà più usare il workspace {ws}. L'account resta: potrai invitare di nuovo questa persona quando vuoi. Se in
//   questo momento è collegata, potrebbe continuare a vedere il workspace fino alla scadenza del suo accesso.»
//   Persona invitata (l'account può sparire con la rimozione, e non ha mai fatto l'accesso): «{email} non entrerà nel
//   workspace {ws}: l'invito a questo workspace viene ritirato. Potrai invitarla di nuovo quando vuoi.» Nuova chiave
//   admin tenantUsers.removeMessageInvited.
// [FIX-v202] Accesso → niente più «tenant» nei testi che vede un utente normale: /no-access «Nessun tenant
//   assegnato» → «Nessun workspace assegnato»; la scelta dopo il login (più workspace) «Seleziona tenant» / «Scegli
//   l'organizzazione con cui vuoi lavorare» → «Scegli il workspace» / «Seleziona il workspace in cui vuoi lavorare.».
//   I testi della sola modalità superadmin restano.
// [FIX-v202] Accesso, recupero password, accettazione invito, Profilo → mai più testo del server: nuovo
//   auth/authErrorCopy.js (stessa forma `(t, err)` di userActionError.js / siteErrorCopy.js) parla dal codice. Login:
//   422 → «Controlla l'indirizzo email: non sembra valido.»; 5xx con request_id → «Il servizio non ha risposto
//   correttamente… riferisci questo codice all'assistenza: {ref}.»; 5xx senza (pagina del proxy) → «Il servizio non è
//   raggiungibile in questo momento…»; codice sconosciuto → «Accesso non riuscito. … {code}.» (spariti il messaggio
//   inglese e il «(ref: …)» non tradotto). Recupero / imposta password: il fallback stampa il codice (o il riferimento)
//   nella propria frase; accetta invito: un 5xx con request_id mostra il riferimento invece di INTERNAL_ERROR.
//   Profilo: nome e password parlano dal codice; ⭐ una password ATTUALE sbagliata (401 AUTH_INVALID_CURRENT_PASSWORD)
//   non disconnette più l'utente — apiFetch lascia passare quel 401 — e dice «La password attuale non è corretta.».
//   updateMe / changeOwnPassword lanciano buildApiError. Chiavi tolte: errors:auth.generic, auth:passwordForm.genericError.
// [FIX-v202] Knowledge Base e Buyer Personas → mai più testo del server. Nuovo context/contextErrorCopy.js (il
//   nucleo di siteErrorCopy, che ora lo usa con le sue tre frasi): un codice noto tiene la sua frase italiana, un 403
//   semplice «solo amministratori», un 5xx con request_id il riferimento, nessuna risposta la rete, il resto la frase
//   dell'azione con il codice. Documenti: elenco, esito per file del caricamento, «Reindicizza», eliminazione (dentro
//   la conferma) e download («Download non riuscito: <motivo>» per un codice noto, altrimenti il codice). Personas:
//   elenco e interruttore attiva/disattiva. Scheda del sito sulla pagina KB: siteErrorCopy. Nuove chiavi context
//   fallback.server/network, documents.errors.*, personas.errors.loadFailed/toggleFailed; il «tenant» diventa
//   «workspace» in errors:context.adminOnly e RESOURCE_NOT_FOUND. Le frasi del DocumentPicker e del Site Manager
//   restano (si allineano nella revisione della pagina KB).
// [FIX-v202] Knowledge Base → il rifiuto di «Reindicizza» non era MAI visibile: la rilettura dell'elenco che lo
//   seguiva azzerava l'errore. Ora l'errore si imposta dopo la rilettura.
// [FEAT-v202] Knowledge Base → il perché di un aggiornamento fallito (kb-status.failure_code, BE 5cd9175), nuovo
//   context/site/kbFailureCopy.js, sulla scheda e in «Gestisci»: DISCOVERY_FOUND_NOTHING «Brian non ha trovato pagine
//   sul sito: controlla l'indirizzo con «Modifica»…»; SITE_APEX_CONFLICT «Il sito è cambiato mentre l'aggiornamento era
//   in corso: avvia di nuovo…»; DISCOVERY_REFUSED «Non è stato possibile leggere il sito: controlla che sia disponibile…»;
//   CREDITS_UNAVAILABLE «I crediti dell'azienda sono finiti…»; INDEX_REFUSED/INTERRUPTED/INTERNAL_ERROR/STALE «L'ultimo
//   aggiornamento non è stato completato: avvia di nuovo «Rileggi tutto il Sito».»; null/sconosciuto → la frase generica.
//   Il rimedio è sempre «Rileggi tutto il Sito» (l'unico pulsante della vista base; copre anche il [Reindex] del contratto).
// [FEAT-v202] 422 WEBSITE_UNRESOLVABLE (indirizzo che non esiste) → «Questo indirizzo non risulta esistente: controlla
//   di averlo scritto correttamente.», sotto il campo in «Gestisci» → «Modifica» (errors:context, via siteErrorCopy) e
//   sotto il campo sito del modulo di personalizzazione (sparisce quando lo si modifica).
// [FIX-v202] «Gestisci» → l'avviso della bozza (`draft_pending`) NON si mostra più: risposta del BE (7f7f18e,
//   docs/frontend/2026-10-07-url-list-draft-handoff.md) al nostro handoff 2026-10-07-1315 — una bozza viene solo da un
//   intervento eccezionale da riga di comando, un amministratore di workspace non può farci nulla; il campo resta nell'API
//   per l'assistenza. Chiave tolta: site.modal.banners.draftPending.
// [FEAT-v202] «Annulla la nuova lettura» → con `list_restored: true` la lista delle pagine di prima è tornata: la si
//   rilegge e si dice «Nuova lettura annullata: Brian continua a usare le informazioni della precedente lettura del
//   sito.». Se la lista tornata è di un ALTRO dominio (tutte le righe `off_apex` rispetto al sito collegato — la
//   risposta non ha un flag) l'avviso, arancione: «…ATTENZIONE: L'URL registrata è ora quella del nuovo sito! Correggi
//   l'URL del sito con «Modifica» oppure avvia di nuovo «Rileggi tutto il Sito».». Senza ripristino: frase invariata.
//   Avviso «Stai cambiando dominio»: tolta la frase finale «a quel punto ti verrà chiesto di sostituire l'intera lista».
// [FIX-v202] Knowledge Base → dopo aver salvato di nuovo l'indirizzo del sito, le due frasi d'errore che parlano
//   dell'indirizzo (DISCOVERY_FOUND_NOTHING «…controlla l'indirizzo con «Modifica»…», DISCOVERY_REFUSED) non si
//   mostrano più, sulla scheda e in «Gestisci», fino al prossimo aggiornamento (lo stato «Errore» resta: è vero).
//   La scheda tiene il flag (kbFailureCopy.showKbFailure); «Gestisci» lo riceve e segnala il salvataggio riuscito.
// [FIX-v202] DISCOVERY_FOUND_NOTHING non dà più la colpa al solo indirizzo (un sito vero senza sitemap né link interni
//   non dà pagine: la scoperta del BE non conta la home page): «Brian non ha trovato pagine da leggere sul sito: controlla
//   che l'indirizzo sia giusto e che il sito sia raggiungibile. Non sono stati usati crediti e le pagine già lette restano
//   com'erano.». Handoff al BE: plans/2026-10-07-1848-be-handoff-discovery-skips-the-home-page.md.
// [FIX-v202] Knowledge Base → una sola serie di frasi di ripiego: DocumentPicker e «Gestisci» usano fallback.server /
//   fallback.network; codice sconosciuto «Caricamento non riuscito. …» / «Operazione non riuscita. …» con il codice.
// [FIX-v202] Documenti → niente parole tecniche: «Reindicizza» → «Rileggi il documento», colonna «Indicizzato» → «Letto
//   il», stati «indicizzazione…» / «da indicizzare» → «in lettura…» / «da leggere», esito «caricato, Brian lo sta
//   leggendo», avviso «Brian sta ancora leggendo il documento…», conferma di sostituzione «…il file e le informazioni
//   lette da Brian verranno sostituite…», chip del sito «Lettura delle pagine…». TOLTI i conteggi dei chunk (totale e
//   per riga). Il banner del lavoro in corso segue il chip: «Indicizzazione in corso» / passo «Indicizzazione» →
//   «Lettura delle pagine in corso» / «Lettura delle pagine»; avviso esclusioni illeggibili «…Ogni scansione
//   reindicizza…» → «…rilegge…»; conferma di «Modifica» → «Modifica l'URL del sito collegato al workspace; la lista
//   delle pagine e i contenuti letti da Brian restano quelli attuali fino a quando non avvierai «Rileggi tutto il Sito».».
//   Chiavi tolte: documents.chunkTotal, documents.meta, documents.columns.chunk, site.modal.errors.server/
//   network, documents.picker.errors.server/network.
// [FEAT-v202] Gestione Workspace → la scheda «Membri azienda» diventa «Amministratori azienda» (titolo «Amministratori
//   dell'azienda», sottotitolo «Gestiscono l'azienda: dati di fatturazione, piano e acquisti, workspace e altri
//   amministratori. Sono anche amministratori di tutti i workspace dell'azienda.»). UN SOLO ruolo: chi viene aggiunto è
//   sempre `admin` — tolti il selettore del ruolo (che PARTIVA da «Solo lettura») e la colonna «Ruolo». Verificato sul BE:
//   `viewer` non concede nulla (router.py CustomerInfo) ma occupa un posto. Testi: «Aggiungi amministratore», «{email} è
//   ora amministratore dell'azienda.», «…diventerà amministratore quando lo accetterà.», «Questa persona è già
//   amministratore dell'azienda.», conferma «Rimuovi amministratore» / «{email} non sarà più amministratore
//   dell'azienda. Resta nei workspace di cui è membro.», blocchi «Non puoi rimuovere te stesso.» / «È l'unico
//   amministratore dell'azienda: non può essere rimosso.»; il blocco amministratori di Utenti rimanda alla nuova scheda.
//   Chiavi tolte: manage.members.roleAdmin/roleViewer/viewerHint; nuove: manage.members.subtitle/removeDialogTitle.
// [FEAT-v202] Gestione Workspace → gli amministratori dell'azienda si gestiscono DENTRO «Utenti», sotto gli utenti del
//   workspace (nuovo tenantAdmin/components/CompanyAdminsSection.jsx; la scheda «Amministratori azienda» e la sua route
//   sono TOLTE — niente redirect, non siamo in produzione). La sezione agisce sull'azienda del workspace SELEZIONATO
//   (nuovo hooks/useWorkspaceCompany.js: una GET /credits/balance?tenant= per selezione, perché i claim non dicono a
//   quale azienda appartiene un workspace) e appare solo a chi amministra QUELL'azienda; un semplice amministratore
//   di workspace continua a vedere il blocco in sola lettura («Gestiscono tutti i workspace dell'azienda.»).
//   «Aggiungi amministratore» apre un dialogo con il solo indirizzo (nuovo AddCompanyAdminDialog.jsx, pulsante
//   «Aggiungi»; i rifiuti restano nel dialogo). Aggiungere o rimuovere un amministratore rilegge posti ed elenco utenti.
//   Mentre l'azienda del workspace si sta ancora cercando lo spazio resta vuoto (né sezione né blocco: niente cambio
//   di modalità a ogni cambio di workspace); la risposta è ricordata per workspace; una ricerca fallita → blocco.
//   Limite noto: un amministratore d'azienda senza workspace amministrati non ha la scheda Utenti (azienda senza
//   workspace attivi). Chiave tolta: manage.tabs.members; nuova: manage.members.addSubmit.
//   Colonna «Nome» nella tabella degli amministratori (nome + cognome, «—» se assenti). I nomi arrivano dal BE 56664fc
//   (risposta al nostro handoff 2026-10-07-1640), anche sulle righe `via: "customer"` del blocco in sola lettura. Tolto dalla scheda dei posti il testo lungo
//   «Un posto è una PERSONA dell'azienda: …» (chiave seats.rule).
// [FIX-v202] Utenti → i dialoghi «Crea nuovo utente» e «Modifica utente» entrano in modalStack: Esc li chiude solo se
//   sono in cima (prima il primo si chiudeva anche con un'altra finestra sopra).
// [FEAT-v201] Buyer Personas → «Scrivila tu» e l'editor: ogni casella vuota mostra un esempio («Es.: …»), la stessa
//   persona (titolare di studio dentistico) del modulo «Generala con l'aiuto di Brian» — Nome e Descrizione ne
//   riusano i `createPlaceholders`, il resto è `personas.placeholders.*`. L'esempio segue la lingua della METÀ
//   (la metà inglese ha esempi in inglese), nessuno in sola lettura; la casella cresce fino a contenerlo
//   (`PersonaHalfForm`, `CreateIdentityStep`). [ZERO-BREAK] per la pipeline.
// [FEAT-v201] Buyer Personas → «Scrivila tu»: l'identificativo non si vede MAI e il passo «Identità» non ha più
//   «Avanzate». È sempre generato (`personaModel.uniquePersonaId`): lo slug del nome («persona» per un nome senza
//   lettere utili) o, se preso, il primo libero «-2», «-3»… entro 50 caratteri. Un 412 PERSONA_ALREADY_EXISTS
//   (id preso fuori dall'elenco: persona di piattaforma, creata nel frattempo) fa riprovare da solo col successivo,
//   fino a 3 volte, sempre create-only (nulla viene sovrascritto); poi un errore semplice
//   (`personas.create.idExhausted`). Resta bloccato un NOME già usato (`isNameTaken`: maiuscole, accenti e spazi non
//   contano). Tolti campo id, `idBad`, e il ritorno al passo Identità sul 412. La revisione di una creazione AI resta
//   com'era (id sotto Avanzate).
// [FIX-v201] Knowledge Base → sottotitolo dei Connettori: «Il sito web che Brian leggerà per documentarsi nel processo
//   di scrittura dei testi.» (`site.subtitle`), spostato accanto a «Sito aziendale», sopra il sito; la scheda non ha
//   più sottotitolo (`SiteConnectorCard`). Il modale «Gestisci» → «Sito aziendale» non ha più il sottotitolo «Scelta
//   delle pagine del sito…» (`SiteManagerModal`, chiave `site.modal.subtitle` rimossa).
// [FEAT-v201] Knowledge Base → modale «Gestisci»: la seconda parte (ricerca, tabella delle URL, paginazione,
//   «Aggiungi URL») è una parte «Avanzate» (`useAdvancedView('kb-site', userKey)` + `AdvancedToggle`, subito dopo
//   sito, stato e pulsanti); le modifiche non salvate si contano sull'interruttore chiuso e «Salva» / «Chiudi»
//   restano sempre. `userKey` scende da KnowledgeBasePage / TenantKnowledgeBasePage / KnowledgeBase.
// [FEAT-v201] Knowledge Base → i due pulsanti parlano di QUANDO usarli: «Ricarica contenuti» → «Rileggi tutto il Sito»
//   (base: mappa il sito e rilegge tutte le pagine — il caso sicuro, il rescan non tocca pagine mantenute, esclusioni
//   o pagine aggiunte a mano), «Reindicizza» → «Aggiorna contenuti esistenti» (spostato in Avanzate: rilegge solo le
//   pagine già note, senza mappa, più rapido). Nuovi tooltip, conferme (costo, Brian resta utilizzabile, esito
//   «Pronto» / «Da rivedere»), spiegazione «?» e testi che citavano i vecchi nomi (`failedHint`, cambio sito).
//   Due «?»: accanto a «Rileggi tutto il Sito» spiega solo quell'operazione e rimanda ad «Avanzate»
//   (`site.modal.helpBase`, senza la frase su pagine mantenute / escluse, che stanno in Avanzate); il confronto fra
//   le due sta accanto ad «Aggiorna contenuti esistenti», in Avanzate, senza l'introduzione su costo e durata (già
//   nella conferma di ogni pulsante: chiave `help.intro` rimossa).
//   Suggerimento della colonna «Escludi»: «… e non sarà più letta.» (era «indicizzata»); quello di «×»: «Perché il suo
//   contenuto non venga più letto, usa «Escludi».» (era «Per non indicizzarla mai più…»).
// [FEAT-v201] Knowledge Base → TOLTO «Mantieni» dal modale (colonna e scelta in «Aggiungi URL»): il BE non conserva
//   il contenuto di una pagina mantenuta che non si legge più, e la sua differenza reale era solo «vince sulle
//   esclusioni». Il dato resta nel BE; escludere una pagina ancora mantenuta la smantiene anche (altrimenti verrebbe
//   letta comunque) — una sola modifica per l'utente (`countPending` conta PAGINE), e il riepilogo non nomina
//   «mantenute». Una URL aggiunta non è più mantenuta.
// [FIX-v201] tenant-admin Knowledge Base, Brand Voice e Buyer Personas: il sottotitolo non ripete più il nome del
//   workspace («… — <workspace>», «… per <workspace>»; chiave `personas.subtitleFor` rimossa).
//   Sottotitolo di Brand Voice: «… con cui Brian scrive per il tuo workspace» (era «l'IA»).
//   Sottotitolo della Knowledge Base: «Le informazioni su cui Brian si basa per scrivere i testi» (era «Documenti di
//   riferimento»), allineato a Brand Voice e Buyer Personas.
// [FIX-v201] Intestazione delle pagine (`PageBand`): il badge «Personalizzazione: …» sta all'estremità destra della
//   riga del titolo, a sinistra dell'utente — un punto fisso su ogni pagina, non più subito dopo il titolo (che lo
//   spostava a seconda della lunghezza). Nella console, prima del selettore dell'azienda.
// [FIX-v201] Header della shell: l'avatar resta sulla riga del titolo su ogni pagina (prima la riga centrava le due
//   metà sull'altezza intera, e con sottotitolo + schede — Brand Voice — l'avatar scendeva). `.shell-header` allinea
//   in alto; avatar e riga del titolo condividono `HEADER_ROW_HEIGHT` (38px, PageBand.jsx), il titolo vi è centrato
//   (`PAGE_TITLE`), quindi titolo, badge e avatar stanno su una linea — anche nel Content Generator.
// [FIX-v201] Knowledge Base → il riquadro «Da rivedere» parla come i pulsanti: «Lettura del sito da confermare»,
//   cosa è successo (molto meno contenuto o molte pagine non lette: Brian continua a usare la lettura precedente) e
//   cosa fare; «Usa la nuova lettura» / «Annulla la nuova lettura» (erano «Accetta comunque» / «Annulla
//   ricostruzione»), senza «ricostruzione» né conteggi di frammenti. Anche il suggerimento sulla scheda.
// [FIX-v201] Knowledge Base → il modale «Gestisci» non mostra più il messaggio del server (`err.message`, inglese
//   per i codici non noti) in sei punti: nuovo `site/siteErrorCopy.js` (codice noto → errors.json; 403 semplice →
//   «riservata agli amministratori»; 5xx → riferimento; nessuna risposta → rete; altrimenti il codice). Restano, da
//   contratto, CONTEXT_URL_DELTA_REFUSED e CONTEXT_EXCLUDE_FILE_INVALID (il testo nomina URL / file, sotto il nostro
//   titolo).
// [FEAT-v200] Brand Voice → la scheda «Personalità» esce dalla divisione base / «Avanzate» (supera la v199 su questo
//   punto): mostra sempre tutti gli assi della voce e lo switch Italiano / English, e l'interruttore non compare su
//   questa scheda. Tolta la riga «Arriva agli agenti insieme ai Principi…».
//   Nuova intro della scheda: «La personalità con cui il tuo Brand scrive.» (la precedente diceva, a torto, che vale
//   solo «quando non scegli un tono»: il BE la invia sempre; un tono diverso da «Voce del brand» ne sovrascrive lo stile).
//   Tolta la nota «non viene tradotta automaticamente…» (l'onboarding crea anche l'inglese) e «Al salvataggio … l'IA non
//   la aggiornerà più» → «Puoi modificare la versione italiana e quella inglese.»; l'interruttore «Aggiorna anche
//   l'inglese» non compare su Personalità (traduce solo i campi del documento: `PUT /context/brand-voice` non traduce).
// [FEAT-v200] Brand Voice → «Principi» senza parte «Avanzate» (nessun campo avanzato): niente interruttore
//   Avanzate né «Aggiorna anche l'inglese», stato dell'inglese e «Traduci ora» sempre visibili, e una modifica ai
//   Principi è sempre tradotta (`alwaysTranslates`; il flag è unico per il PUT, quindi vale per tutto il salvataggio).
//   Nuova intro: «I principi di comunicazione da usare nella scrittura.» (chiave `principlesIntro`).
// [FIX-v200] Brand Voice → l'intro di ogni scheda sta in cima (`tabs.js :: tabIntroKey`); l'interruttore «Avanzate»
//   è disegnato da `DocFields` subito dopo l'ULTIMO campo base, dove compaiono i campi avanzati (sostituisce il
//   divisore «Avanzate»: tolti `brandVoice.advanced.divider` e `FieldRow.noTopBorder`). Una scheda senza campi
//   avanzati non lo mostra.
// [FEAT-v200] Brand Voice → «Terminologia»: intro «Parole e definizioni che preferisci.»; la colonna «Nota» dei Termini
//   preferiti è base (non più Avanzate), segnaposto «Nota (facoltativa): cosa significa, quando usarlo, cosa
//   sostituisce»; «Termini da evitare» resta in Avanzate senza la riga «Guardrail · parole · letto da: …» (resta il
//   bordo). Il BE traduce dei Termini preferiti solo la nota: il termine è copiato identico nell'inglese.
// [FIX-v200] Tolta OVUNQUE la riga «Guardrail · <livello> · letto da: …» (Termini / Frasi da evitare, Claim da non fare
//   mai; chiavi `brandVoice.guardrail.*` rimosse); resta il bordo di avviso. Principi, Terminologia ed Esempi di stile
//   traducono sempre (`advancedModel.ALWAYS_TRANSLATE_TABS`): niente «Aggiorna anche l'inglese», stato dell'inglese
//   sempre visibile. Intro di Esempi di stile: «Frasi che mostrano lo stile di comunicazione del tuo Brand.».
// [FEAT-v200] Brand Voice → «Claim verificati» (ora «Fatti») in AREE (`widgets/ClaimsEditor.jsx` + nuovo
//   `widgets/ClaimTable.jsx`; ordine finale sotto); colonne da `claim_fields`, nessuna riga di intestazione: ogni
//   segnaposto nomina la sua colonna e poi un esempio per categoria («Etichetta*: es. Clienti attivi», «Fonte (opz.): es. …»; `brandVoice.claimPlaceholder.*`).
//   Un'area di più categorie mostra i nomi delle categorie, un'area di una sola il proprio titolo (`claimArea.*`).
//   Ogni cella è una casella a una riga che cresce, anche col segnaposto quando è vuota (`GrowingTextarea`
//   `fitPlaceholder`). «Fonte» è base; «Aggiornato al» non è più mostrato ma è conservato a ogni modifica (arriva
//   ancora ai prompt). Niente conteggio righe, niente «Caso anonimo?»; una categoria vuota mostra una riga vuota (solo
//   vista); il pulsante «aggiungi» è un'icona sull'ultima riga, come «×» solo su una riga con del testo
//   (`listStyles.ADD_ICON`; glifo provvisorio `ArrowDown`, lo sceglie il design). La riga del campo non mostra «Claim
//   verificati» né «Da completare» (`FieldRow`).
//   Intro: «Dati e fatti dimostrabili sul tuo Brand.». Nessuna parte Avanzate → niente interruttore; traduce sempre.
//   La scheda si chiama «Fatti» (anche l'etichetta del campo, `brandVoice.tabs/fields.verified_claims`); la categoria
//   `facts` si chiama «Dati qualitativi» (fatti verificabili non numerici: sede, settori serviti, partnership…) ed è
//   l'ULTIMA area: Metriche · Risultati con i clienti · Credenziali e clienti · Dati qualitativi.
// [FIX-v200] Brand Voice → «Messaging»: intro «Come il tuo Brand si presenta e cosa vuole comunicare.».
// [FEAT-v200] Brand Voice → TOLTO l'interruttore «Aggiorna anche l'inglese» (anche da Messaging, l'ultima scheda che
//   lo aveva): ogni salvataggio traduce (`translate: true`), e lo stato dell'inglese con «Traduci ora» si vede in
//   ogni vista (tolto il filtro `ctx.english` di `FieldRow`). Rimossi `advancedModel.ALWAYS_TRANSLATE_TABS` /
//   `alwaysTranslates*`, le prop dell'interruttore di `SaveBar` e la chiave `brandVoice.save.translate`.
// [FEAT-v200] Brand Voice → segnaposto parlanti su Principi, Terminologia, Esempi di stile e Messaging, come in Fatti:
//   il nome della casella e un esempio («Termine*: es. clienti», «Motivo (opz.): es. …», «Frase: es. …»), per campo
//   (`brandVoice.fieldPlaceholder.<field_path>[.<colonna>]`, nuovo `widgets/fieldPlaceholder.js`; il segnaposto
//   generico resta come ripiego). La colonna inglese di una lista «da evitare» ha i segnaposto in inglese. Ogni
//   casella delle liste è una casella a una riga che cresce, anche col segnaposto (`GrowingTextarea fitPlaceholder`).
//   Anche Posizionamento, USP e UVP hanno un segnaposto con esempio («Posizionamento*: es. …», «USP (opz.): es. …»),
//   e USP / UVP una breve descrizione accanto al nome (`brandVoice.fieldDescription.<field_path>`, `FieldRow`).
// [ARCH-v200] `advancedModel`: tolti `visibleField` e le colonne nascoste (nessuna colonna è più avanzata);
//   `ALWAYS_TRANSLATE_TABS` = tutte le schede documento tranne Messaging.
// [FEAT-v200] Content Generator → il tono predefinito è «Voce del brand» (`initialState.tone: 'brand-voice'`, prima
//   'professional-conversational'): di default il run usa la personalità del workspace così com'è (tone_hint
//   "brand-voice" → nessun override di stile nel BE).
// [FIX-v200] Il «Nome» della voce non è più mostrato (una sola personalità per workspace): ogni salvataggio della
//   voce lo compila per entrambe le lingue (`advancedModel.voiceLabelForSave`, sostituisce `firstSaveLabel`): un nome
//   vuoto, o quello della piattaforma su una voce ancora `source: 'global'`, diventa «<workspace> — voce» /
//   «<workspace> — voice» (chiavi `brandVoice.voice.workspaceLabel` / `workspaceLabelEn`); un nome esistente resta.
// [ARCH-v200] `advancedModel`: tolti `isAdvancedVoiceKey` e il conteggio voce di `hiddenAttention` (l'interruttore
//   conta solo campi del documento nascosti). Nessuna dipendenza nuova dal BE. [ZERO-BREAK] per la pipeline.
// [FEAT-v199] Brand Voice → vista BASE / «AVANZATE» (un solo interruttore per pagina,
//   `useAdvancedView('brand-voice')` + `AdvancedToggle`, in alto a destra nella scheda, nello stesso punto su ogni
//   scheda, ricordato per utente e per browser): tutte e sei le schede restano; in base niente campi bilingui né inglese (le tre liste «da evitare»,
//   Differenziatori, USP, UVP, la voce inglese, «Traduci ora» e «Aggiorna anche l'inglese» sono avanzati), la nota
//   dei termini preferiti e fonte / alla data dei claim sono colonne avanzate; la Personalità mostra in base TUTTI
//   gli assi della voce (solo il «Nome» e la voce inglese sono avanzati). I campi avanzati stanno in fondo a ogni
//   scheda sotto un divisore «Avanzate»; il «Nome» della voce sta sotto gli assi anche con Avanzate attivo.
// [FIX-v199] Il blocco richiudibile «Avanzate» USP/UVP della v189 è sostituito dall'interruttore di pagina. Un
//   problema, una modifica non salvata o un conflitto su un campo nascosto sono contati sull'interruttore, e un
//   nuovo problema su un campo nascosto (o un clic che porta a un campo nascosto) riapre Avanzate finché non lo si
//   richiude. In base la traduzione inglese al salvataggio è sempre attiva; al primo salvataggio sulla voce di
//   piattaforma il nome diventa «<workspace> — voce» (`useBrandSaveActions`, param `workspaceName`).
// [ARCH-v199] Nuovo `context/brandVoice/advancedModel.js` (regole pure: campi, colonne e chiavi di voce avanzati; conteggio
//   per l'interruttore; nome al primo salvataggio). `DocFields`, `VoiceForm`, `VoiceTab` prendono la prop
//   `advanced`; `FieldRow` nasconde badge inglese e «Traduci ora» con `ctx.english === false`. Nascondere non
//   cambia ciò che un salvataggio invia né ciò che i controlli coprono (`draftModel`, `wireShape`, `validateField`,
//   `saveBrandIdentity` invariati). Tolte le chiavi `brandVoice.advanced.title` / `filled`. Nessuna dipendenza
//   nuova dal BE. [ZERO-BREAK] per la pipeline.
// [FEAT-v198] «Buyer Personas» → OGNI AZIONE IN UNA FINESTRA MODALE (`persona/PersonaModal.jsx` su
//   `components/ui/WizardModal.jsx` + `ModalFooter`, barra dei passi `components/ui/StepBar.jsx`); niente più
//   moduli in linea nella lista. Processi e passi: Suggerisci = Descrivi → Proposte; Nuova persona = [Metodo →]
//   Nome e mercato → Profilo → Bisogni, oppure [Metodo →] Brief → Generazione → Revisione; Adatta = Indicazioni
//   → Generazione → Revisione; Modifica senza barra. La generazione resta in background: la finestra si può
//   chiudere, la scheda del job riapre la Revisione; a job completato la finestra passa da sola alla Revisione.
//   Le proposte di «Suggerisci» restano in memoria di pagina (chiudere e riaprire le ritrova). Con modifiche
//   non salvate, Esc / × chiedono «Chiudere senza salvare?». «Crea con l'AI» su una proposta è disabilitato
//   mentre un job è in corso (prima avrebbe solo ricevuto 409 PERSONA_JOB_ACTIVE).
// [FEAT-v198] Vista BASE / «AVANZATE» (`hooks/useAdvancedView.js` + `components/ui/AdvancedToggle.jsx`,
//   ricordata per pagina, per utente e per browser): base = mercato, nome, descrizione, linguaggio; Avanzate =
//   ruolo e contesto (nella stessa scheda «Chi è», `PersonaHalfForm` prop `show`), Pain & Gain,
//   identificativo, e nel brief AI genere / età / note. I campi avanzati restano OBBLIGATORI: un errore su un
//   campo nascosto riapre Avanzate; il toggle conta errori e avvisi nascosti. «Generala con l'AI» è la scelta
//   consigliata (prima, con il badge «Consigliato»).
// [FIX-v198] Esc in una conferma annidata chiude solo la conferma (`components/ui/modalStack.js`: pila delle
//   finestre, ordine preso al RENDER perché gli effetti girano dal figlio al padre; usata anche da `AdminModal`
//   → vale anche per «Gestisci» della Knowledge Base).
// [ARCH-v198] Mercato in sola lettura in Modifica e in Revisione (entrambe le pagine personas); «Annulla» diviso
//   in «Ripristina» e «Chiudi»; la creazione manuale salva solo l'italiano (nota nell'ultimo passo); aprire una
//   proposta non chiude più la scheda del job; `ProposePanel` diviso in `assist/ProposeStep` / `ProposalsStep`
//   (+ `GeneratingStep`, `JobCard` esporta `StartNotice`); `NewPersonaPanel` ridotto alla scelta del metodo;
//   nuova `CreateIdentityStep`; `PersonasView` prende `userKey` (dalle due pagine). Tolti gli stili
//   `editorPanel` / `editorEmbedded` / `stickyBar` e le chiavi `personas.create.submit` / `cancel`. Nessuna
//   dipendenza nuova dal BE. [ZERO-BREAK] per la pipeline.
// ⚠️ v197 — Da rilasciare INSIEME al BE c84cb07: le rotte `/api/v1/persona-assist/*`, `market: "any"` e
//   l'header `If-None-Match: *` sul PUT delle sezioni esistono solo da quel commit (nessun controllo nel FE).
// [FEAT-v197] «Buyer Personas» → TRE AIUTI DELL'AI, solo su `/tenant-admin/personas` (prop `assist` di
//   `PersonasView`, passata da `TenantPersonasPage`; il superadmin `/admin/personas` non la passa, per non
//   spendere i crediti di un workspace per sbaglio). «Suggerisci personas con l'AI» (`assist/ProposePanel`):
//   richiesta + documenti → fino a 8 proposte (nuova / da adattare / da tenere / da attivare) con il loro
//   pulsante; sincrono, POST /persona-assist/propose. «Generala con l'AI» (`assist/CreatePersonaForm`: nome,
//   mercato, genere, età, chi è, problemi e obiettivi, documenti) e «Adatta con l'AI» per riga
//   (`assist/PersonalizeControl`: indicazioni + documenti; cambia solo contesto e Pain & Gain) avviano un JOB
//   in background (POST /persona-assist/jobs). I tre moduli NON sono <form>: solo il pulsante avvia.
// [FEAT-v197] JOB RIPRESI. `assist/usePersonaJob` legge GET /persona-assist/jobs all'ingresso, interroga ogni
//   4 s finché il job è attivo e solo a pagina montata, e lo riprende al rientro. `assist/JobCard`: in corso /
//   «interrotto» (stale) / fallito (frase NOSTRA dal codice, «nulla è stato addebitato», Riprova) / pronto →
//   «Apri la proposta». «Rivedi l'ultima proposta» solo per il job completato PIÙ RECENTE e non ancora salvato
//   (create: `suggested_id` assente dalla lista; personalize: UNA GET delle sezioni, etag === `base_etag`);
//   «Ignora» lo nasconde per la sessione della pagina. Un 409 PERSONA_JOB_ACTIVE è «un'altra operazione è già
//   in corso» + il job in corso viene seguito, mai un errore. `refreshEntitlements()` dopo un Propose riuscito
//   e quando un job è VISTO passare a completed. Nessun testo sui costi; rifiuti di credito → RunRefusalNotice.
// [FEAT-v197] La proposta si apre nell'EDITOR esistente (`PersonaEditor` prop `proposal`): create → id
//   `suggested_id` modificabile e salvataggio create-only; personalize → If-Match = `base_etag`, nessuna GET
//   iniziale; un 412 CONTEXT_ETAG_MISMATCH rilegge la persona e dice «modificata nel frattempo». I numeri
//   inventati (`warnings`, metà italiana) compaiono SOTTO il loro campo (`PersonaHalfForm` prop `warnings`),
//   quelli su un campo non mostrato in una nota generale. Esito per documento (`assist/DocResults`) dopo un
//   Propose e dentro la proposta: letto / nessun testo / non trovato / … — parole nostre, i nomi dell'utente.
// [FEAT-v197] Mercato `any` («Qualsiasi mercato»): gruppo proprio nella lista (b2b · any · b2c · senza
//   mercato), nei select dell'editor e della creazione; formato a lista come il B2B. Il riconoscimento dei
//   file vecchi resta `market == null`.
// [FEAT-v197] OGNI CREAZIONE È CREATE-ONLY (manuale e AI, su entrambe le pagine): `putPersonaSections({…,
//   ifNoneMatch: true})` → `If-None-Match: *`; 412 PERSONA_ALREADY_EXISTS → «Esiste già…» (`create.idTaken`),
//   modulo conservato. L'editor in creazione mostra l'IDENTIFICATIVO modificabile (precompilato dallo slug o
//   dal `suggested_id`). `NewPersonaPanel` perde la GET di prova sulle sezioni (il controllo atomico lato
//   server copre anche gli id globali) e tiene il controllo istantaneo sulla lista, con la sua frase
//   (`create.nameTaken`). Con `assist`, «Nuova persona» offre «Scrivila tu» / «Generala con l'AI»; una
//   proposta «nuova» apre il percorso AI precompilato. `PERSONA_ID_RE` / `slugify` spostati in `personaModel`.
// [FIX-v197] TOLTA la scelta «l'AI continua ad aggiornarla»: niente più blocco «Dopo il salvataggio», niente
//   sblocco/blocco dopo il PUT né il «salvato ma ancora bloccata»; il salvataggio è UNA richiesta. Tolti i badge
//   della lista (incl. il lucchetto della v195) e il merge di provenienza in `handleToggle`; `allowDefault` /
//   `badgeKind` eliminati dal modello. Nessun processo dell'app aggiorna più le personas (il run di
//   personalizzazione non le tocca; resta solo la CLI dell'operatore).
// [FIX-v197] «RIVEDI L'ULTIMA PROPOSTA» NON RIPROPONE UNA CREAZIONE GIÀ SALVATA. `usePersonaJob` giudicava un
//   job `create` completato contro l'elenco delle personas nel momento in cui rispondeva GET /persona-assist/jobs —
//   di solito PRIMA dell'elenco, quindi contro una lista vuota: una persona già salvata veniva riproposta, e
//   salvarla di nuovo dava 412 → un altro id → una persona DUPLICATA. Ora il job resta in attesa e viene giudicato
//   solo a elenco CARICATO (`rowsReady`, passato da `PersonasView` = caricato e non vuoto), ricalcolato a ogni
//   cambio dell'elenco. Test: 2 nuovi (PersonasView, usePersonaJob) che falliscono senza la correzione.
// [ARCH-v197] `contextApi` perde le due chiamate di provenienza (POST …/unlock e …/lock); nuovo
//   `context/personaAssistApi.js` (4 chiamate, `?tenant=` esplicito, TypeError sincrono senza tenant). Nuova
//   cartella `context/persona/assist/` (assistModel puro, assistCopy, hook, card, pannelli). `DocumentPicker`
//   SPOSTATO da `onboarding/ui/` a `context/DocumentPicker.jsx` (+ prop `label`), i suoi helper in
//   `context/documentUpload.js`, la frase degli errori di upload in `context/documentPickerCopy.js`, le chiavi
//   in `context:documents.picker.*` con le STESSE frasi italiane; `onboarding/copy.js` perde `uploadErrorCopy`,
//   `onboardingModel.MAX_DOCUMENTS` è un alias del limite condiviso. [ZERO-BREAK] per la pipeline.
// ⚠️ v196 — Da rilasciare INSIEME al BE 571ac04 + 2ad8bdf: con il BE nuovo le rotte del vecchio form 1
//   (GET /onboarding/questions, POST /onboarding) rispondono 404/405 e lo stato perde `form.submitted_at`.
// [FEAT-v196] PERSONALIZZAZIONE → UN SOLO MODULO. `onboarding/ui/PersonalizationForm.jsx` sostituisce
//   Form1 + Form2 (+ FacetQuestion): nome del workspace · settore · documenti · sito web, in quest'ordine
//   (i documenti prima del sito: gli upload devono finire prima dell'invio). Il nome fa la PATCH solo se
//   cambiato e, se rifiutato, non parte altro; il SETTORE è precompilato UNA volta da `form.sector` dello
//   stato e inviato solo se diverso e non vuoto (svuotarlo mostra «il settore registrato resta in uso»);
//   il SITO è FACOLTATIVO. Serve almeno una fonte (sito valido o ≥ 1 documento spuntato). POST
//   /brand-identity/personalization con `{website?, sector?, documents?}` e nient'altro. L'unico avviso è
//   il dialogo «Avviare senza sito web?» (documenti sì, sito no, `allows_reruns === false`) — niente avviso
//   generale, niente costi. Nuovi rifiuti con frasi NOSTRE: NOTHING_TO_DO, DOCUMENT_NOT_FOUND (elenca i
//   nomi da `details.documents`, li toglie dalla selezione e ricarica la lista); ONBOARDING_INCOMPLETE
//   rimosso; `START_REASON` guadagna i due codici. Avanzamento su 4 FASI (CUSTOMIZING tolto, l'etichetta
//   resta per un run in volo durante il rilascio).
// [FEAT-v196] `onboarding/ui/DocumentPicker.jsx` — i documenti del modulo: upload di questa visita in cima
//   e SPUNTATI, poi gli altri del workspace NON spuntati e in ordine ALFABETICO (la lista non ha data di
//   caricamento); massimo 10; un nome che inizia con «.» si vede ma non si spunta; solo la casella —
//   niente elimina/reindicizza/scarica; ricerca oltre 10 righe; stessa conferma di sostituzione della KB;
//   avviso (mai blocco) se ogni documento spuntato è «nessun testo estratto» e manca il sito.
// [FIX-v196] Testi: `progress.keepWorking` senza «più di 30 minuti»; l'esito del banner dice linee guida
//   + voce soltanto; il pannello completato aggiunge la riga sull'indicizzazione KB del sito dopo il primo
//   run; `stages.INGESTING` → «lettura del sito e dei documenti».
// [FIX-v196] SOLO IL PULSANTE AVVIA LA PERSONALIZZAZIONE. Il dialogo «Sostituire il documento?» del
//   `DocumentPicker` sta dentro il <form> e `AdminModal` non usa un portal: i pulsanti di `ConfirmDialog` e la
//   × di `AdminModal`, senza `type`, erano pulsanti SUBMIT — Annulla / Sostituisci / × avviavano la run (con un
//   sito compilato, nessuna conferma: su un piano a run singola, l'unica). Ora i tre pulsanti sono
//   `type="button"` (nessun altro dei 19 usi sta dentro un form: markup diverso, comportamento identico) e
//   `PersonalizationForm` blocca l'invio implicito con Invio da ogni <input> (nome, settore, sito, ricerca del
//   picker). Test: `admin/components/__tests__/ConfirmDialog.test.jsx` + 3 nuovi in `PersonalizationForm.test.jsx`.
// [FEAT-v196] Brand Voice → chip FISSO «Non scritto dall'IA» (lucchetto `Lock`, tooltip) sulle tre liste
//   «da evitare» E su «Claim verificati»: un run non le scrive mai (`fieldRules.isNeverAIWritten`, chiave
//   `neverAI` in `OwnerChip`), quindi niente Blocca / Sblocca. La frase «può riaggiungere le voci guardrail
//   del settore» è TOLTA (falsa: il D-seed non esiste più); restano la riga Guardrail e il bordo.
//   `unstampedPaths` salta anche i claims → nessun «Risalva» sui claims, e la logica che bloccava solo le
//   categorie inviate è rimossa da `useBrandSaveActions`. Il salvataggio sparso per categoria resta.
// [ARCH-v196] Codice del form 1 eliminato (`getOnboardingQuestions` / `submitOnboardingForm`, faccette,
//   docs gate e le loro chiavi i18n). Estratto `context/documentUpload.js` (estensioni, limite, controllo
//   file, nomi da sostituire, upload sequenziale che si ferma al primo rifiuto di credito): `DocumentsView`
//   lo usa con comportamento IDENTICO e perde le prop opzionali della v191 (callback lista + token di
//   ricarica), rimaste senza utenti. Tolte le ricariche post-run di `PersonasView` e `useContextOptions`:
//   il run non tocca più personas, obiettivi né toni. Restano quelle di Brand Voice e SiteConnectorCard
//   (il BE avvia un reindex KB dopo il primo run con sito).
// [FEAT-v195] «Buyer Personas» → LA LISTA SI LEGGE A COLPO D'OCCHIO. In `PersonasView`: l'«Attiva /
//   Disattiva» è un INTERRUTTORE (traccia + pomello, `personaStyles.toggleTrack` / `toggleKnob`) —
//   stesso `role="switch"` / `aria-checked` / `aria-label`, le parole solo nel tooltip; in sola
//   lettura è un `role="img"` non cliccabile. Il chip «Non aggiornabile dall'AI» è un'icona LUCCHETTO
//   (`Lock`, `personaStyles.lockBadge`, `role="img"` con nome e tooltip); gli altri due chip restano
//   testo. «Modifica» è una MATITA (`Pencil`, `personaStyles.editIconBtn`), con `aria-label` /
//   `title` «Modifica»/«Chiudi», `aria-expanded`, piena di accento a editor aperto.
// [FIX-v195] «Buyer Personas» → PAIN & GAIN PIÙ LARGO. Niente più «Riga N» visibile (resta nel nome
//   accessibile del gruppo); la × è fissata nell'angolo della scheda (`pgRemove`); Pain e Gain
//   affiancati a metà scheda ciascuno (`pgPair` / `pgPairCell`, a capo sotto ~600px), Indicatori a
//   tutta larghezza sotto (`pgStack`). Il vecchio grid a 3 colonne lasciava viva una terza colonna
//   vuota e stringeva Pain e Gain in due terzi. Padding di sezione/editor ridotti.
// [FIX-v194] «Buyer Personas»: L'EDITOR SI APRE SOTTO LA RIGA. `PersonasView` montava
//   `PersonaEditor` una volta sola, DOPO tutti i gruppi: aprendo una riga in cima a una lista di
//   13 il modulo finiva sotto la piega e sulla riga restava solo un «Chiudi» che sembrava non
//   fare nulla. Ora l'editor è reso dentro la lista, subito sotto la riga che modifica (un
//   `Fragment` per riga), con la prop `embedded` di `PersonaEditor` → `personaStyles.editorEmbedded`
//   (niente bordo/raggio esterno — li disegna già la lista — una riga sopra e una barra accento a
//   sinistra che lo lega alla riga evidenziata). Nessuna chiamata cambia. Un test fissa la posizione.
// [FEAT-v194] «Knowledge Base» → «Sito aziendale»: RICARICA vs REINDICIZZA SPIEGATI. I due pulsanti
//   si somigliano e vengono confusi: ora ognuno porta un tooltip nativo (`title`) con la differenza
//   in una riga, le due conferme di spesa la ripetono («a differenza di…») e un pulsante «?» accanto
//   apre un `AdminModal` con `role="alertdialog"` — intro, una scheda per operazione (cosa fa, quando
//   usarla) e la regola in breve — che non avvia nulla. `AdminModal` prende una prop OPZIONALE `role`
//   (aria-modal + aria-labelledby sul titolo); senza, il markup è identico a prima. Chiavi
//   `site.modal.reloadHint` / `reindexHint` / `help.*` in it+en. Un test fissa tooltip e dialog.
// [FEAT-v194] «Buyer Personas» → L'EDITOR È LEGGIBILE. `PersonaHalfForm` riscritto: ogni casella è
//   una `GrowingTextarea` che va a capo e cresce col testo (niente più <input> che tronca «risponde a
//   soci, famiglia e banche…»); i campi a riga singola restano tali SUL FILO — Invio bloccato, un
//   a-capo incollato diventa spazio — perché `checkHalf` rifiuta un newline lì (`oneLine`), che resta
//   come rete. Tre SEZIONI a scheda (chi è · pain & gain · linguaggio, le due liste affiancate su
//   schermo largo) e, nel formato a righe, UNA SCHEDA NUMERATA per riga di Pain & Gain (`role=group`
//   «Riga n», × per rimuovere, le tre celle affiancate e impilate sotto ~800px) con un suggerimento che
//   spiega la riga. Nome in una casella più grande in testa; barra Salva/Annulla `position: sticky` in
//   fondo all'editor. Stili nuovi in `personaStyles.js` (solo token); tre chiavi FE
//   `personas.fields.rowLabel` / `painGainHint` / `languageTitle` in it+en. Due test nuovi.
// [FEAT-v193] UNA SOLA TESTATA per le pagine di amministrazione del workspace: la fascia bianca di
//   «Gestione Workspace» diventa `components/ui/PageBand.jsx` (titolo <h1>, badge accanto, controllo a
//   destra, sottotitolo sotto, schede sotto ancora) ed è usata anche da Knowledge Base (admin e membro),
//   Brand Voice e Buyer Personas. Via la testata «Brian Cortex» di Brand Voice (`GroupPageHeader`
//   eliminato: il nome del gruppo resta solo nella sidebar); Brand Voice ha ora un sottotitolo. Buyer
//   Personas: l'<h1> passa nella fascia, la card tiene un <h2> («Le personas del workspace»). Il badge
//   della personalizzazione compare anche su Knowledge Base e Buyer Personas, dove quindi il banner non
//   ripete le righe fisse. Brand Voice: via il riquadro «Identità» (settore, nome breve e anno di
//   fondazione non compaiono più); le sei sezioni salgono nella fascia come le schede della console —
//   restano PULSANTI (la guardia sulle modifiche non salvate intercetta i link), con
//   `SegmentedTabs variant="band"`. Schede della fascia più visibili, in un'unica classe CSS
//   (`PAGE_BAND_TAB`): 15px, peso 500, hover, sottolineatura attiva di 3px, focus visibile. Infine la
//   testata NON è più una fascia bianca: `PageBand` la porta via portal nello slot della Header della
//   shell (`PAGE_HEADER_SLOT_ID`, ex `cg-header-slot`) come fa il Content Generator — titolo sulla riga
//   dell'avatar, sfondo grigio, fissa mentre la pagina scorre — con lo stesso stile di titolo condiviso
//   (`PAGE_TITLE`, 26px / 800); le schede poggiano su una linea grigia sottile. La stessa testata va anche
//   su «Report Attività» (/dashboard, titolo = voce di menu), «Storico Generazioni» (la card non ripete
//   più il titolo) e «Guida alla Piattaforma». «Report Attività»: il contenuto sta in UNA card arrotondata
//   nella colonna centrata da 1280px, con la riga dei filtri nello stile di «Storico Generazioni»
//   (`components/ui/filterFields.jsx`, condiviso). [ZERO-BREAK]
// [FEAT-v192] PERSONALIZZAZIONE: il FE smette di indovinare (BE 178d473). La lettura di stato ora
//   dice `last_attempt` (l'ultimo run, qualunque esito: un re-run fallito dopo un completed si vede
//   anche dopo un reload), `last_start_error` (un avvio rifiutato o crashato DOPO il 202) e
//   `allows_reruns`. `detectOutcome` decide dai campi del BE: il marker di avvio salva il run_id e
//   l'`at` dell'errore di PRIMA della POST, e un loro CAMBIO decide (mai l'orologio del browser); resta
//   solo una rete di sicurezza di 5 minuti ("avvio non confermato"). ⛔ `allows_reruns` è del PIANO: nasconde
//   SOLO i controlli del secondo run ("Esegui di nuovo", "Riprova" dopo un re-run fallito), mai il primo
//   run né il riprova dopo un primo run fallito. L'errore di avvio è una riga datata sopra ogni pannello
//   del wizard; il RunRefusalNotice completo solo subito dopo il proprio avvio. Badge
//   "Personalizzato · ultimo tentativo non riuscito". Include anche le modifiche di efe0a57 (testi di
//   form 1 / form 2, niente logo/favicon nel form 1, banner nascosto dove c'è il badge).
// [FEAT-v191] PERSONALIZZAZIONE DEL WORKSPACE AL PRIMO ACCESSO (`src/onboarding/`). Un poller
//   app-wide (montato da AppShell, solo per l'admin del workspace ATTIVO, mai un superadmin) legge
//   GET /brand-identity/onboarding in uno store di modulo: 10 s mentre un run è in corso, 30 s se
//   degradato, 5 min altrimenti, solo a scheda visibile. Un gate reindirizza UNA volta per
//   (workspace, login) — e SOLO da /, /content-generator, /dashboard — al wizard
//   /tenant-admin/personalization: form 1 (nome, settore, domande servite dal BE, logo/favicon;
//   one-shot) → documenti (DocumentsView, attesa max 5 min) + form 2 (il sito: avvia un run di 30+
//   minuti) → avanzamento «fase k di 5». Banner sottile permanente finché il workspace non è
//   personalizzato; badge accanto al titolo di Gestione Workspace e di Brand Voice. Workspace mai
//   personalizzabili (unlock_effective false / default / senza file) letti in modo PIGRO dal
//   documento: niente prompt né banner. A fine run: epoch «run finished» → Brand Voice si sblocca DA
//   SOLA (addio "niente polling"), PersonasView / useContextOptions / SiteConnectorCard rileggono,
//   refreshEntitlements(). Esiti che il BE non dice (avvio perso dopo il 202, re-run fallito dopo un
//   completed) dedotti lato FE. ⛔ Niente copy sui costi; ⛔ mai err.message.
// [FEAT-v190] «Brand Voice», passo 8 (l'ultimo): LA SCHEDA «PERSONALITÀ DEL BRAND» È
//   MODIFICABILE. `context/brandVoice/ui/VoiceTab.jsx` — il blocco/sblocco della voce su UNA
//   riga di `FieldRow` (la voce non è un campo del documento, ma nel registro ha la sua riga,
//   `'voice'`, e quindi la stessa pastiglia del proprietario e gli stessi `fieldRules`),
//   l'interruttore Italiano / English col pallino per lingua, le note per lingua — più
//   `ui/VoiceForm.jsx` («Nome», che ⛔ non arriva agli agenti, e una casella per asse: esattamente
//   gli assi restituiti dal server, nel suo ordine, ⛔ nessuno aggiunto o tolto, Invio bloccato e
//   un ritorno a capo incollato che diventa spazio) e `voiceModel.js` (le regole pure: le chiavi
//   `voice.<lingua>.<chiave>`, il seme vuoto dell'inglese quando il file non c'è, i controlli del
//   browser, il rifiuto «prima l'italiano», il corpo del PUT).
//   ⭐ Una TERZA lettura, la voce inglese: ⛔ il suo 404 NON è un errore, vuol dire «nessuna
//   versione inglese» — il backend non ricade sull'italiano — e allora il modulo inglese si semina
//   con le CHIAVI e le ETICHETTE italiane, tutto vuoto, così un modulo mai toccato non è una
//   modifica. Ogni lingua ha la sua bozza, il suo etag e il suo pallino; «Annulla» le lascia cadere
//   entrambe.
//   ⭐⭐ Il salvataggio è in TRE parti (documento → voce italiana → voce inglese), ciascuna col suo
//   etag, il suo esito e la sua frase: un RUN_ACTIVE sul documento salta ENTRAMBE le voci, e
//   l'inglese si salta anche quando l'italiano non è stato salvato su un workspace che non
//   possedeva ancora il file italiano (il backend risponderebbe 409 CONTEXT_BASE_REQUIRED). Lo
//   stesso caso, con la sola modifica inglese, è rifiutato NEL BROWSER: non si manda niente.
//   ⚠️⚠️ IL PUT DELLA VOCE LA BLOCCA (timbro `human`: l'IA smette di aggiornarla) e la risposta
//   non lo dice — lo dice la rilettura del documento: dopo il salvataggio italiano, se il blocco
//   non risulta `human`, compare l'avviso di sempre con «Risalva», che congela `['voice']`.
//   ⛔ `'voice'` muove SOLO la riga italiana (limite del backend), per questo la vista inglese dice
//   sempre che un inglese salvato a mano l'IA non lo aggiornerà più. ⛔ Mai `/completeness` (può
//   far partire un aggiornamento a pagamento) e nessun DELETE.
//   ⭐ Con questo passo TUTTA la schermata è modificabile: resta la verifica finale dell'operatore
//   (roadmap § 6).
// [FEAT-v189] «Brand Voice», passo 7: I TRE CAMPI DI TESTO DI «MESSAGING» SONO MODIFICABILI
//   (`context/brandVoice/widgets/ScalarEditor.jsx`, registrato per `scalar`): UNA casella che si
//   allarga col testo, con Invio bloccato e un ritorno a capo incollato che diventa spazio — il
//   backend riduce comunque ogni sequenza di spazi bianchi a uno, quindi un capoverso salvato non
//   cambierebbe niente e mentirebbe su quanto è stato scritto. ⛔ L'editor non valida NIENTE: il
//   controllo su `positioning` (l'unico campo obbligatorio del documento) resta al salvataggio,
//   dove `FieldRow` già dice «Questo campo è obbligatorio.»; `problems` serve solo per
//   `aria-invalid`. Il nome accessibile della casella è l'etichetta stessa della riga, dalla
//   stessa chiave i18n, così casella ed etichetta non possono divergere.
//   ⭐ `usp` / `uvp` stanno nel blocco «AVANZATE» in FONDO alla scheda (`ui/DocFields.jsx`,
//   `ADVANCED_PATHS`): chiuso di default, un `<button>` con `aria-expanded` e `aria-controls`
//   (⛔ mai un link — la guardia d'uscita sorveglia i link), l'intestazione «Avanzate · USP, UVP»
//   costruita dalle etichette dei campi presenti e la pastiglia «compilati» quando uno dei due
//   contiene testo: l'IA li scrive e il Writer li legge, quindi si mettono da parte ma
//   ⛔ non si nascondono in silenzio. Il contenitore del pannello c'è SEMPRE (è il bersaglio di
//   `aria-controls`), le righe solo da aperto.
//   ⭐⭐ SI RIAPRE DA SOLO quando l'ELENCO dei problemi di un campo avanzato CAMBIA e non è vuoto
//   (ogni salvataggio fallito crea elenchi nuovi → si riapre a ogni tentativo; fra un salvataggio
//   e l'altro sono stabili → chi lo chiude lo ritrova chiuso), o quando compare un conflitto.
//   ⛔ Non un sì/no «ha un problema»: lo stesso errore che sopravvive a un secondo tentativo
//   lascerebbe il blocco chiuso sopra un errore invisibile.
//   Più la riga d'introduzione della scheda. ⭐ Ora OGNI campo del documento ha un editor: resta
//   solo il form della «Personalità del brand».
// [FEAT-v188] «Brand Voice», passo 6: LA SCHEDA «CLAIM VERIFICATI» È MODIFICABILE
//   (`context/brandVoice/widgets/ClaimsEditor.jsx`, registrato per `claims`): CINQUE SEZIONI in
//   colonna nell'ordine del wireframe — Metriche · Fatti · Credenziali · Clienti · Case study —
//   ognuna un `role="group"` con il titolo, il conteggio delle righe SALVATE (non della bozza) e
//   un `RecordListEditor` con le COLONNE prese da `claim_fields` del payload, ⛔ mai scritte a
//   mano: una categoria che il payload non dichiara non si mostra, una che dichiara e noi non
//   conosciamo va in fondo con la sua chiave grezza. ⭐ La `note` non è una colonna ma
//   SOPRAVVIVE: l'editor spande la riga a ogni modifica, e una categoria si sostituisce intera.
//   ⛔⛔ IL SALVATAGGIO MANDA SOLO LE CATEGORIE CAMBIATE (`draftModel.changedClaims`): ogni
//   categoria inviata il backend la BLOCCA (timbro `human`, l'IA smette di aggiornarla), la
//   RITRADUCE a pagamento e ne SOVRASCRIVE l'inglese, mentre quelle omesse le riporta intatte
//   (`_merge_claims`). Modificare una metrica avrebbe congelato e rifatturato le altre quattro.
//   Una categoria svuotata si manda come `[]`, cioè un azzeramento; una assente dalla bozza
//   ⛔ non è mai un azzeramento; una differenza vuota non manda niente, nemmeno `{}`.
//   ⛔ «Risalva» blocca SOLO le categorie che il salvataggio ha inviato (`sentRows`, letto dal
//   payload COSTRUITO e non dai campi sporchi, perché il campo può essere sporco senza che
//   nessuna categoria cambi): bloccarne cinque congelerebbe categorie mai toccate. Blocca /
//   Sblocca della riga restano su tutte e cinque — è un'azione esplicita sull'intero campo.
//   ⭐ Righe del tutto vuote SCARTATE e valori vuoti TOLTI per categoria (la regola di v187):
//   una riga aggiunta e mai compilata non è una modifica, non fa pallino e non si invia.
//   ⭐ I messaggi di riga nominano la CATEGORIA («Metriche — La riga 2 non ha il campo
//   obbligatorio Valore»), perché i numeri di riga ripartono in ogni categoria; più i nomi e i
//   segnaposto dei campi dei claim nella mappa condivisa `brandVoice.recordField`, il
//   suggerimento per il caso anonimo sotto Case study e la riga d'introduzione della scheda.
// [FEAT-v187] «Brand Voice», passo 5: LA SCHEDA «TERMINOLOGIA» È MODIFICABILE
//   (`context/brandVoice/widgets/RecordListEditor.jsx`, registrato per `record_list`): una riga
//   per voce, con le COLONNE prese da `record_fields` del payload — ⛔ mai scritte a mano —
//   così UN solo editor serve «Termini preferiti» (Termine + Nota), «Termini da evitare»
//   (Termine + Motivo) e i «Claim da non fare mai» di Messaging (Affermazione + Motivo), che
//   diventano modificabili con la stessa registrazione. La prima chiave è in grassetto su una
//   riga sola, le altre si allargano da sole; ⭐ una modifica SPANDE la riga, quindi ogni altra
//   chiave sopravvive al giro completo.
//   ⭐ I NOMI DEI CAMPI NELLE NOSTRE PAROLE, da UNA sola mappa (`brandVoice.recordField`):
//   «Termine» / «Nota» / «Motivo» / «Affermazione», con i segnaposto memorizzati PER INTERO
//   perché il genere italiano sia giusto («Nota (facoltativa)», «Motivo (facoltativo)»); una
//   chiave sconosciuta resta grezza. Valgono per le etichette dell'editor E per i messaggi di
//   riga, che fino a ieri stampavano la chiave del backend («term»).
//   ⭐ I PROBLEMI SONO PER LINGUA sulle liste bilingui «da evitare»: al salvataggio `onSave`
//   marca quelli della metà inglese (`params.lang: 'en'`), `DocFields` li instrada alla SUA
//   colonna e `FieldRow` aggiunge « (inglese)» alla frase. ⚠️ Un 422 del backend invece non si
//   può dividere — gli errori dell'inglese tornano sotto lo stesso `field_path` dell'italiano
//   — quindi resta la riga generica; i controlli del client applicano comunque le stesse
//   regole prima di qualunque richiesta.
//   ⭐ Righe del tutto vuote SCARTATE da `wireShape.toWire` (una riga aggiunta e mai compilata
//   non è una modifica: nessun pallino, nessun conteggio, nessun avviso d'uscita) e valori
//   vuoti TOLTI da ogni riga prima dell'invio: il PUT porta `{term: 'x'}` e non
//   `{term: 'x', note: ''}` — il contratto legge `""` e `null` come assenti, e mandare solo
//   valori veri toglie ogni dubbio alla scrittura del backend.
//   ⛔ Nessun riordino, come in ogni altro elenco. Elenco vuoto = solo il pulsante
//   «+ Aggiungi riga», senza frase; più la riga d'introduzione della scheda.
// [FEAT-v186] «Brand Voice», passo 4: LA SCHEDA «ESEMPI DI STILE» È MODIFICABILE
//   (`context/brandVoice/widgets/StrListEditor.jsx`, registrato per `str_list`): un elenco
//   piatto di frasi, una casella per voce, × per togliere, «+ Aggiungi». ⛔ Una voce non si
//   divide MAI — «Il digitale: una leva, non una vetrina» è UNA frase sola. Registrare
//   `str_list` rende modificabili anche «Messaggi chiave» e «Differenziatori» di Messaging.
//   ⭐⭐ L'INVOLUCRO BILINGUE (`ui/BilingualColumns.jsx`), generico e deciso in UN solo posto
//   (`DocFields.editorFor`): ogni campo «da evitare» (`bucket_d`) che ha un editor si mostra
//   in DUE COLONNE INDIPENDENTI Italiano / English — righe, × e «+ Aggiungi» propri, anche di
//   lunghezza diversa, perché l'API prende due elenchi separati e svuotare l'italiano non
//   svuota l'inglese. ⛔ Non sono le righe appaiate del disegno. ⛔ L'inglese lo SCRIVE
//   l'utente: questi guardrail non si traducono mai da soli. ⛔ Colonna inglese NASCOSTA dove
//   il workspace non ha la metà inglese: lì il backend scarta `fields_en` in SILENZIO, quindi
//   sarebbe testo che svanisce al salvataggio.
//   ⭐ Le voci VUOTE di un elenco le scarta `wireShape.toWire`: una riga aggiunta e mai
//   compilata non è una modifica (nessun pallino, nessun conteggio, nessun avviso d'uscita) e
//   non si invia; svuotarle tutte manda `[]`, cioè l'azzeramento fatto sullo schermo.
//   ⛔ Nessun riordino in nessun elenco — deciso qui una volta per tutti i widget.
//   ⭐ I tre elenchi «da evitare» sono GUARDRAIL, non contenuto: riga «Guardrail · livello ·
//   letto da: …» (un livello o un lettore sconosciuto si mostra grezzo, ⛔ mai lasciato
//   cadere), bordo sinistro d'attenzione e la nota che ⚠️ un aggiornamento dell'IA può
//   RIAGGIUNGERE le voci guardrail del settore anche dopo che le hai tolte. Per questo su di
//   loro ⛔ niente chip del proprietario, niente Blocca/Sblocca e niente avviso «Risalva»
//   (`fieldRules.isGuardrail`, `unstampedPaths(res, fields)`): l'IA non li sovrascrive mai,
//   quindi «Non modificabile dall'IA» sarebbe falso e sbloccare non farebbe niente.
//   Casella di testo e stili degli elenchi ora condivisi (`ui/GrowingTextarea.jsx`,
//   `widgets/listStyles.js`); più la riga d'introduzione della scheda.
// [FEAT-v185] «Brand Voice», passo 3: LA SCHEDA PRINCIPI È LA PRIMA MODIFICABILE
//   (`context/brandVoice/widgets/PairListEditor.jsx`, registrato per `pair_list` — la
//   registry non è più vuota): una riga per principio, NOME in grassetto su una riga sola,
//   DESCRIZIONE che si allarga da sola, × per togliere, «+ Aggiungi principio».
//   ⭐ La bozza tiene RIGHE `{name, description}`, non le stringhe archiviate: il nuovo
//   modulo PURO `brandVoice/wireShape.js` (`fromWire` / `toWire`, identità per ogni altro
//   widget) converte nelle due direzioni — divisione sul PRIMO «: », unione con «: » e le
//   due parti ripulite, descrizione vuota → SOLO il nome (un «: » finale tornerebbe dentro
//   la casella del nome), righe del tutto vuote SCARTATE (una riga aggiunta e mai compilata
//   non è una modifica e non si invia; svuotarle tutte salva `[]`, cioè un azzeramento).
//   ⛔⛔ Un editor controllato sulla stringa unita rispezzerebbe il testo a ogni tasto: il
//   resto del nome salterebbe nella descrizione appena si digita «: », e l'unione ripulita
//   si mangerebbe lo spazio appena battuto. ⚠️⚠️ Il backend NON sa accorgersi di una
//   divisione sbagliata — nessun 422, il confine si sposta in silenzio al caricamento dopo
//   (così andarono perse 12 descrizioni su due workspace): i test del giro completo su dati
//   veri sono obbligatori.
//   I controlli del nome girano SOLO al salvataggio, come tutti gli altri: nome obbligatorio
//   se la riga non è vuota, e niente «: » nel nome a spazi COLLASSATI (il server collassa
//   ogni spaziatura, quindi un tab o un a capo dopo i due punti sposterebbe il confine).
//   ⛔ Niente a capo veri (Invio bloccato, un a capo incollato diventa spazio) e ⛔ nessun
//   riordino: si decide una volta per tutti gli elenchi con «Esempi di stile».
//   ⭐ I problemi di un campo spariscono appena si modifica QUEL campo, e con l'ultimo se ne
//   va anche la riga «Alcuni campi non sono validi» della barra — ⚠️ non quella di un 422 che
//   non ha nominato nessun campo, dove è l'unico indizio che resta.
// [FIX-v185] La chip «Sbloccato» non compare più dove sbloccare non ha effetto
//   (`unlock_effective: false`): prometteva un aggiornamento dell'IA che non arriverà mai.
// [FIX-v185] «Risalva» ora BLOCCA i campi (POST /document/lock) invece di risalvarli: un
//   salvataggio timbra solo ciò che scrive davvero, quindi rimandare un campo SVUOTATO — già
//   vuoto sul server — non scriveva niente e non poteva registrarne il proprietario (e un
//   usp/uvp svuotato torna `null`, che il PUT rifiuta). Nessun etag, nessuna traduzione,
//   nessun credito; l'IA decide sulla riga italiana, quindi il blocco solo IT protegge tutto.
//   Frase di esito sua (`brandVoice.save.resaved`), etichetta «Risalva» invariata.
// [FEAT-v184] «Brand Voice», passo 2: LE PARTI COMUNI. La schermata smette di essere un
//   guscio: le righe dei campi sono visibili su OGNI scheda del documento, la barra di
//   salvataggio è attiva e la guardia d'uscita avvisa davvero. ⛔ Nessun widget ancora: la
//   casella dell'editor legge «editor in arrivo» (`context/brandVoice/widgets/index.js` è
//   vuota per scelta) — segue un piano per scheda, il prossimo è Principi.
//   ⭐ LE SCRITTURE (`context/brandIdentityApi.js`): `putBrandDocument` (PUT /document con
//   If-Match, corpo SPARSO `{fields, fields_en?, translate}`) — ⛔⛔ il backend NON
//   confronta: tutto quello che riceve lo scrive E lo timbra `human`, cioè l'IA non lo
//   aggiornerà più, quindi ⛔ MAI inviare un campo non cambiato; `fields_en` solo per i tre
//   percorsi bucket-D e omesso del tutto quando è vuoto. `lockFields` / `unlockFields`
//   (POST /document/lock|unlock, senza If-Match: non scrivono testo, l'etag del documento
//   non si muove) e ⚠️ `ledgerPaths`, perché il registro ragiona per RIGHE e non per
//   widget: `verified_claims` è UN widget ma CINQUE righe
//   (`verified_claims.{metrics,credentials,clients,case_studies,facts}`) e la chiave nuda
//   tornerebbe in `skipped`. `contextApi.putBrandVoice` (PUT /context/brand-voice) ha il
//   SUO etag — ⛔ mai condiviso con quello del documento — e ⚠️ su quella rotta il backend
//   NON controlla `RUN_ACTIVE`: è la schermata che blocca anche la voce durante un
//   aggiornamento dell'IA.
//   LA LOGICA PURA (`context/brandVoice/`): `fieldValue.js` («è lo stesso valore?» per i
//   cinque widget: `null` ≡ `""`, categoria di claim assente ≡ `[]`, valori vuoti di un
//   record ≡ assenti, stringhe confrontate senza spazi doppi come le normalizza il server)
//   e `draftModel.js` (`dirtyPaths` / `buildDocumentPayload` / `conflictsAfterReload` /
//   `tabHasChanges`): ⛔⛔ «modificato» vuol dire DIVERSO DAL VALORE CARICATO, mai
//   «toccato» — un campo scritto e poi rimesso com'era non viene inviato, altrimenti lo
//   timbreremmo `human` per niente — e di un campo bucket-D si manda solo la METÀ cambiata.
//   `validateField.js` rispecchia le regole del backend (`_validate_field` / `_row_error`)
//   e ⛔ restituisce CHIAVI, non frasi: i 422 che arrivano comunque diventano una NOSTRA
//   riga sotto il campo giusto, presa da `details.errors[].field_path` — ⛔ il `message`
//   inglese del server non si mostra mai, qui come altrove. `fieldRules.js` tiene TUTTE le
//   regole di visibilità di una riga (chip, Blocca, Sblocca, badge inglese, «Traduci ora»,
//   suggerimento di completezza) e `copy.js` TUTTE le frasi dei rifiuti (le tre della
//   lettura spostate dalla pagina, più `saveErrorCopy` / `actionErrorCopy`), scelte da
//   `err.code` / `err.status`; un 5xx con `request_id` mostra il riferimento per l'assistenza.
//   LO STATO: `useBrandIdentity.js` tiene le due letture con stati separati e `refreshing`,
//   così una rilettura NON svuota la scheda che si sta guardando e una rilettura fallita
//   conserva il dato precedente (⛔ un errore al posto di tutta la scheda per un battito di
//   rete è peggio del dato vecchio); le risposte in ritardo le scarta un biglietto di
//   sequenza PER LETTURA. `useBrandDraft.js` tiene le bozze SPARSE e nessuna copia dello
//   stato del server, quindi una bozza sopravvive a una rilettura e si confronta con il
//   valore FRESCO. `useBrandSaveActions.js` è dove vivono tutte le scritture della pagina,
//   che resta impaginazione e niente altro.
//   IL SALVATAGGIO (`saveBrandIdentity.js`) è UNO per chi lo usa ma DUE scritture senza
//   transazione: prima il documento, poi la voce, ciascuna con il suo esito — ⛔ mai un
//   verdetto unico — TRANNE un 409 RUN_ACTIVE sul documento, che SALTA la voce (un
//   aggiornamento dell'IA riscrive anche quella). Un 412 dà «Ricarica», che rilegge tenendo
//   le bozze e segnala i campi cambiati nel frattempo da qualcun altro («il tuo testo lo
//   sostituirà»); un 422 dà la nostra frase per percorso; `stamped: false` vuol dire testo
//   salvato ma NON registrato come tuo, quindi l'IA potrebbe sovrascriverlo: avviso con
//   «Risalva». `refreshEntitlements()` dopo un salvataggio che ha davvero speso in
//   traduzione (la barra dei crediti tiene una copia sua).
//   LE PARTI VISIVE: `ui/OwnerChip.jsx` (quattro stati distinti per PAROLA e riempimento,
//   non per tinta; `state: null` → nessun chip), `ui/FieldRow.jsx` (⛔ non decide niente,
//   ogni regola arriva da `fieldRules.js`; ⛔ il `field_path` non si mostra mai),
//   `ui/DocFields.jsx` (le righe della scheda attiva nell'ordine del payload, più la
//   conferma di Blocca/Sblocca) e `ui/SaveBar.jsx` (contatore, interruttore inglese
//   NASCOSTO se il workspace non ha la metà inglese, Annulla che chiede conferma perché le
//   bozze sono l'unica copia del testo). `components/ui/SegmentedTabs.jsx` guadagna un
//   PALLINO sulle schede con modifiche: decorativo (`aria-hidden`, un colore non è un
//   messaggio), il significato sta nel nome accessibile come `dirtyLabel`.
//   ⚠️ LE REGOLE NON OVVIE: «Traduci ora» compare SOLO sui campi bloccati
//   (`state: 'human'`, `type_c`, non claims, inglese non aggiornato, nessuna modifica in
//   sospeso, la metà inglese esiste) e rimanda il valore GIÀ SALVATO con `translate: true`,
//   quindi lo RITIMBRA; ⚠️ su `terminology.preferred` un `instead_of` ripiegato viene
//   riscritto come `note`. Blocca e Sblocca agiscono subito dopo una conferma breve, poi
//   rileggono tenendo le bozze, e un `skipped` non vuoto è un avviso, mai un successo;
//   ⛔ Sblocca NON è un «annulla»: c'è solo su un campo bloccato e solo se
//   `unlock_effective !== false` (altrimenti una riga a livello di schermata spiega perché
//   non c'è). Il badge «crediti esauriti» è una FRASE SENZA LINK: chi amministra un
//   workspace non è detto che possa comprare. ⛔ NESSUN polling: un aggiornamento dell'IA
//   in corso (`run_active` dalla lettura, o un 409 RUN_ACTIVE da qualunque scrittura) alza
//   uno striscione con «Controlla di nuovo». ⛔ Mai legata ai crediti: modificare è gratis.
//   RINVIATI il montaggio del superadmin, la bozza in `sessionStorage` e il polling.
// [FIX-v184] Via la chiave orfana `brandVoice.runActive` (IT + EN): era lo striscione del
//   guscio, sostituito da `brandVoice.runLocked`.
// [FEAT-v183] «Brand Voice», passo 1: IL GUSCIO. Nuova voce in «Brian Cortex» tra Knowledge
//   Base e Buyer Personas (icona `Speech`, chiave `nav.tenant-admin-brand-voice`) e nuova rotta
//   /tenant-admin/brand-voice dentro il gruppo senza percorso di `RequireTenantAdmin`: la vede
//   SOLO chi amministra il WORKSPACE ATTIVO (`tenantAdminView`, come Knowledge Base e Buyer
//   Personas), un membro non ha la voce e digitando l'URL finisce su /dashboard. Il montaggio
//   del superadmin è RIMANDATO.
//   La pagina (`tenantAdmin/pages/BrandVoicePage.jsx`) ha l'intestazione di gruppo «Brian
//   Cortex» / «Brand Voice» (nuovo `GroupPageHeader` in `components/ui/SectionCard.jsx`: il nome
//   del gruppo è la riga più grande ma è un'ETICHETTA, l'unico titolo è l'<h1> con il nome della
//   pagina), la striscia identità in SOLA LETTURA (nome da `identity.name`, altrimenti il
//   workspace attivo; poi sito · settore · nome breve · fondata nel — ⛔ solo stringhe e numeri,
//   un oggetto o un array viene SALTATO, mai stampato) e SEI schede come PULSANTI (nuovo
//   `components/ui/SegmentedTabs.jsx`: l'aspetto di `PlanAxisToggle` con la semantica
//   `role="tablist"`, tabIndex mobile, frecce che girano): Personalità del brand · Principi ·
//   Terminologia · Esempi di stile · Claim verificati · Messaging, e una scheda ignota inserita
//   PRIMA di Messaging con la sua chiave grezza, mai scartata (`context/brandVoice/tabs.js`).
//   ⛔ PULSANTI E NON LINK: la guardia d'uscita intercetta i clic sui link, quindi una
//   scheda-link avrebbe fatto comparire l'avviso a ogni cambio di scheda. La scheda attiva è
//   rispecchiata in `?tab=` con `replace` — quella d'ingresso non porta il parametro, un valore
//   ignoto ricade su di lei — così un ricaricamento o un URL condiviso riaprono la stessa scheda.
//   ⭐⭐ DUE LETTURE IN PARALLELO CHE FALLISCONO CIASCUNA PER CONTO SUO: GET
//   /api/v1/brand-identity/document (nuovo `context/brandIdentityApi.js`) per la striscia, le
//   cinque schede del documento e lo stato di blocco della voce; GET /api/v1/context/brand-voice
//   (`contextApi.getBrandVoice`) per la scheda d'ingresso. Un 404 RESOURCE_NOT_FOUND — il
//   workspace non ha ancora le linee guida del brand — lo spiegano le schede del documento e
//   «Personalità del brand» continua a funzionare, perché le schede si costruiscono da
//   `buildTabs`, che le cinque note restituisce SEMPRE: nessuna sparisce per una lettura
//   rifiutata. ⚠️ Un workspace senza voce propria NON è un errore: è un 200 con
//   `source: 'global'` (la voce predefinita della piattaforma), quindi lo stato si deduce da
//   `source` e ⛔ mai da `id`. Ogni rifiuto è una frase NOSTRA scelta da `err.code` /
//   `err.status` (⛔ mai il testo inglese del server; un 5xx con `request_id` mostra il
//   riferimento per l'assistenza) e «Riprova» NON compare su 404 e 422, dove riprovare non
//   cambierebbe la risposta.
//   L'area di salvataggio (contatore, interruttore «Aggiorna anche l'inglese», Annulla e Salva
//   modifiche) è già nella forma definitiva ma DISATTIVATA: qui non si modifica ancora nulla. E
//   `context/brandVoice/useLeaveGuard.js` è collegato con `dirty = false`, quindi INERTE — a
//   regime avvisa con `beforeunload` più un ascoltatore in fase di CATTURA sui clic dei link
//   (react-router 6.30 offre `useBlocker` solo con un data router, e migrare è fuori ambito);
//   ⛔ la navigazione decisa dal codice (uscita, riautenticazione, ritorno forzato al selettore)
//   NON è coperta, scelta accettata.
//   ⛔ Mai legata ai crediti: modificare è gratis, la schermata non legge né saldo né
//   entitlement. RINVIATI anche l'intestazione «Brian Cortex» su Knowledge Base e Buyer Personas
//   e la bozza in `sessionStorage`. Seguono, come piani separati, le parti condivise (riga di
//   campo, tracciamento delle modifiche, barra di salvataggio con i due PUT e i loro esiti) e
//   poi un piano per ciascuna scheda.
// [ARCH-v182] (segue) RIMOSSA la pagina «Configurazione» degli amministratori di workspace
//   (/tenant-admin/context-settings, `TenantContextSettingsPage`): modificare direttamente
//   i file di configurazione del workspace non è più consentito a loro. Via la rotta, la
//   voce icona orfana della barra laterale e le chiavi i18n `tenantContextSettings.*` e
//   `nav.tenant-admin-ctx`; il vecchio URL ricade nel catch-all (→ «/»). Resta solo
//   l'editor del superadmin (/admin/context-settings). ⚠️ Il backend accetta ancora le
//   scritture da un amministratore di workspace: va chiuso anche lì.
// [ARCH-v182] (segue) Knowledge Base e Buyer Personas adottano lo stesso aspetto, su TUTTI i punti di
//   montaggio (membro, tenant-admin, superadmin). `SectionCard` guadagna `PageHeader`
//   (l'<h1> da 18px + sottotitolo + controllo a destra, per le pagine con PIÙ card) e la
//   prop `as` (una card può restare <section>). Knowledge Base: colonna da 1280px +
//   `PageHeader`; le due card del corpo (Connettori, Libreria documenti) usano
//   `SectionCard`. Personas: UNA card con l'<h1> e `PersonasView` (elenco + editor in
//   linea) come corpo, invariato. Superadmin: il menu a tendina del tenant passa nella
//   testata (a destra). [ZERO-BREAK] solo layout: nessuna chiamata, gate o logica toccati.
// [ARCH-v182] Le quattro pagine del menu avatar (Crediti, Piani, Profilo, Dati di
//   fatturazione) adottano l'aspetto delle schede di Gestione Workspace. Nuovo
//   `components/ui/SectionCard.jsx` (card di sezione: icona tonda + titolo + sottotitolo
//   + azione) con `PAGE_COLUMN` (colonna centrata da 1280px) e `CARD_BODY`; il titolo
//   della pagina è l'<h1> dentro la card (h2 nelle schede, dove l'h1 è del layout).
//   Crediti: una card con saldo, «Piani disponibili», utilizzo e ripartizione; avvisi di
//   ritorno dal pacchetto sopra la card, invito a riaccedere sotto. Piani: stessa
//   colonna e titolo da 18px della scheda (nessuna card esterna, come nella scheda).
//   Profilo: una card con l'email come sottotitolo e i due moduli affiancati. Dati di
//   fatturazione: `CompanyBillingBody` rende la card in entrambe le varianti (cambia
//   solo il livello del titolo), con il modulo `embedded`; il sottotitolo è ora l'intro
//   del modulo (chiave `billing.pageSubtitle` rimossa). Usata anche dalla scheda Crediti
//   e da Dati azienda. [ZERO-BREAK] solo layout: nessuna rotta, gate, API o flusso Stripe.
// [FIX-v181] Dati di fatturazione, allineamento al backend dbd8a73: un errore inatteso
//   del server ora arriva come 500 JSON `INTERNAL_ERROR` CON le intestazioni CORS e un
//   `request_id` (prima era un 500 illeggibile che il browser riportava come errore di
//   rete), e un valore troppo lungo è un 422 `CUSTOMER_INVALID` (o `INVALID_INPUT`), mai
//   più un 500. `CustomerBillingForm` mostra il riferimento da comunicare all'assistenza
//   (`billing.errors.server` / `loadServer`, ⛔ mai il messaggio del server) e la frase
//   di «rete» non attribuisce più il problema alla provincia. I `maxLength` restano,
//   come chiede la guida: i limiti coincidono con quelli ora imposti dal backend.
//   Stessa regola per Gestione Workspace: `userActionError.js` (e quindi ogni scheda, i
//   dialoghi e il ripiego del dialogo Aggiungi utente) su un 5xx con `request_id` mostra
//   `tenantUsers.serverError` con il riferimento al posto del solo codice.
// [FEAT-v181] Crediti e Piani come schede aziendali di «Gestione Workspace»: chi amministra
//   l'azienda vede due schede nuove, in coda a Dati azienda — /tenant-admin/manage/credits e
//   /tenant-admin/manage/plans, entrambe dietro `RequireCustomerAdmin` — così il portafoglio
//   e il piano si gestiscono dalla console, senza passare dal menu dell'avatar. Le sei schede
//   sono ora Utenti · Workspace · Membri azienda · Dati azienda · Crediti · Piani.
//   ⛔⛔ LE DUE SCHEDE AGISCONO SUL WORKSPACE ATTIVO, non su quello che il selettore
//   dell'azienda mostra: le API di crediti e di fatturazione chiavano ogni chiamata sul
//   workspace attivo, e anche i ritorni da Stripe. Da qui la guardia `ActiveCompanyGuard`,
//   che mostra il contenuto SOLO se l'azienda del workspace attivo è quella della console;
//   altrimenti una card con il nome dell'azienda e «Cambia workspace» (→ /select-tenant).
//   ⚠️ «Non ancora saputo» è uno stato a sé — `activeCompanyId` è null sia durante la lettura
//   sia su un vero disallineamento — quindi `useManagedCompany` pubblica anche
//   `activeCompanyResolved`, messo a true nel `.then`, nel `.catch` E sull'uscita anticipata:
//   una lettura fallita si risolve come «sconosciuto», mai come «in attesa», e senza il flag
//   la guardia avrebbe lampeggiato il messaggio a ogni montaggio. La vera scoperta per
//   azienda (opzione B, per chi amministra due aziende) è RINVIATA.
//   ⭐ CREDITI (`CompanyCreditsPage`) = saldo dell'azienda + ripartizione della spesa per
//   WORKSPACE: `CreditBalanceCard` e `CreditUsageTable` con `groupBy="tenant"`, i nomi dei
//   workspace presi dall'elenco dell'azienda (`listCompanyWorkspaces`, che include i ritirati)
//   e solo in seconda battuta dalle rivendicazioni di accesso. ⛔ Nessuna tabella per utente
//   (resta la domanda di /credits) e ⛔ `showMoney={false}` fisso su entrambi i componenti: il
//   costo in dollari è un diritto del superadmin, che in questa console non entra.
//   ⚠️ Gestione degli errori ASIMMETRICA: il saldo È la pagina, quindi una lettura fallita
//   mostra una frase NOSTRA; la ripartizione è un extra, quindi qualunque errore (403 su
//   rivendicazioni stantie compreso) nasconde solo la tabella, senza avvisi.
//   ⭐ PIANI (`CompanyPlansPage`) = lo STESSO `sections/Piani.jsx`, con tre proprietà nuove
//   che valgono di default esattamente il comportamento di oggi (`variant='page'`,
//   `basePath='/billing'`, `billingDetailsTo='/billing-details'`), tanto che la suite della
//   pagina autonoma non è stata toccata: in scheda diventano `variant="tab"` (titolo <h2> in
//   TUTTI i rami — principale, caricamento, errore e «non per te» — su colonna da 1280px),
//   `basePath="/tenant-admin/manage/plans"` e `billingDetailsTo="/tenant-admin/manage/company"`.
//   Seguono `basePath` i soli ritorni «non è successo niente» (annullamento del checkout, del
//   pacchetto e chiusura del portale), mentre ⛔ i due ritorni di SUCCESSO restano assoluti su
//   /billing/return e /credits?topup=done, che sono le pagine che fanno il polling; la pulizia
//   di `?checkout=` / `?portal=` naviga sul percorso CORRENTE, quindi un annullamento riporta
//   dove si era. Ogni link ai dati di fatturazione (avviso d'azione, cancello fatturazione,
//   PlanGrid → PlanCard, riga non acquistabile) punta alla scheda Dati azienda.
//   ⚠️ UNICA differenza visibile sulla pagina autonoma /billing: il pannello «non per te» ora
//   passa da `Shell`, quindi mostra anche il sottotitolo «Il piano è dell'azienda e vale per
//   tutti i suoi workspace.» sotto il titolo. Accettata: un solo punto dove ramificare i
//   quattro percorsi di rendering vale più di due copie di markup.
//   ⭐ Link interni alla console: la fatturazione incompleta porta a Dati azienda, i posti
//   esauriti portano alla scheda Piani (`SeatTile` prende `billingTo`, la pagina Utenti decide
//   se mostrarlo). ⛔ Nessun link per chi amministra solo il workspace e non l'azienda del
//   workspace attivo: non ha la scheda Piani e la pagina autonoma gli risponderebbe solo «non
//   per te» — collegare dove l'utente non può agire è peggio che non collegare. La frase del
//   rimedio resta comunque (nomina anche la disattivazione di una persona). Il limite di
//   workspace su «Workspace» punta alla stessa scheda, alla stessa condizione.
// [FEAT-v180] Invitati «spariti»: adeguamento al backend 7c5dc05. Rimuovere una persona
//   «Invitato» che non appartiene a nessun altro workspace o azienda ora ELIMINA l'account
//   e il suo link (prima restava un account orfano, invisibile e non più invitabile): la
//   risposta di DELETE /tenant-admin/users/{id} porta `account_deleted: true` → la scheda
//   Utenti dice «Invito a … ritirato» (non «rimosso») e la riga sparisce con la rilettura;
//   la pagina superadmin del dettaglio utente torna a /admin/users, perché l'utente non
//   esiste più. `AUTH_USER_DEACTIVATED` ora significa SOLO «disattivato da un
//   amministratore» (copia `tenantUsers.accountInactive` ristretta di conseguenza) e il
//   nuovo 409 `AUTH_USER_PENDING_ONBOARDING` — invitato altrove, password mai impostata —
//   ha una frase sua (`tenantUsers.pendingOnboarding`, che rimanda a «Reinvia invito»)
//   sia nel dialogo Aggiungi utente sia in «Aggiungi membro» di Membri azienda.
// [FIX-v179] Dati di fatturazione: il salvataggio con «modena» come provincia mostrava
//   «NetworkError when attempting to fetch resource». Causa BACKEND: la colonna
//   `billing_province` è CHAR(2) e il modello del PATCH /admin/customers/{id} non ha
//   limiti di lunghezza, quindi il valore arriva al database, fallisce lì e torna come
//   500 non gestito SENZA intestazioni CORS — che il browser riporta come errore di rete.
//   (Correzione lato backend richiesta.) Nel FE, `CustomerBillingForm`: ogni campo ha il
//   `maxLength` della sua colonna (MAX_LENGTH, da src/auth/db.py del backend), la
//   provincia è una sigla di 2 lettere maiuscole con suggerimento «es. MO» e viene
//   rifiutata PRIMA della richiesta se non lo è, e ⛔ nessun errore del modulo è più
//   `err.message` (era il testo inglese del browser o del server): trasporto fallito →
//   `billing.errors.network` / `loadNetwork`, `CUSTOMER_VAT_EXISTS`, `CUSTOMER_INVALID`/422,
//   ogni altro codice → `billing.errors.generic` con il codice. Vale per entrambi i punti
//   di montaggio (scheda «Dati azienda» / /billing-details e il TenantCreditsSection del
//   superadmin).
//   ⭐ Scheda «Dati azienda» allineata alle schede sorelle di Gestione Workspace:
//   `CompanyBillingBody` passa da `headingLevel` a `variant` ('page' | 'tab'); 'tab' è la
//   colonna da 1280px con UNA card di sezione (icona tonda + <h2> + intro nell'intestazione)
//   e il modulo `embedded` dentro — niente seconda card né secondo titolo, campi da 46px,
//   etichette maiuscole da 11px, pulsante da 46px. /billing-details e il superadmin
//   restano identici.
// [FEAT-v178] «Gestione utenti» diventa «Gestione Workspace»: una console a schede per chi
//   amministra un workspace o l'azienda che lo possiede. Vive su /tenant-admin/manage/*
//   (guardia `RequireWorkspaceAdmin` + `TenantAdminLayout`), e /tenant-admin come
//   /tenant-admin/users REINDIRIZZANO lì, così nessun vecchio link o segnalibro si rompe;
//   Knowledge Base, personas, Configurazione e Storico restano ai loro percorsi, sotto una
//   `RequireTenantAdmin` senza path. ⛔ Le due guardie rispondono a domande DIVERSE:
//   `RequireTenantAdmin` chiede «il workspace ATTIVO è mio da amministrare?» — giusto per
//   KB e personas, che agiscono solo su quello — mentre `RequireWorkspaceAdmin` chiede
//   «amministro QUALCHE workspace, o l'azienda?», cioè il nuovo `canManageWorkspaces`, che
//   è anche ciò che legge la voce di menu: un amministratore del workspace B che ha attivo
//   A (dove è editor) prima veniva rimbalzato via dalla sua stessa console.
//   ⭐ UTENTI agisce sul workspace SCELTO, non su quello attivo: `WorkspaceSelector` sugli
//   `adminTenants`, con la scelta DERIVATA a ogni render (⛔ mai congelata in stato: un
//   claims che toglie un workspace lascerebbe la pagina puntata a un id che risponde 403),
//   congelata mentre un dialogo è aperto — la scrittura deve atterrare sul workspace che
//   si sta guardando — e al cambio si azzerano ricerca, offset, righe e posti.
//   `useTenantUsers` porta un biglietto di sequenza per entrambe le letture: una risposta
//   in ritardo del workspace precedente non atterra più sotto il nome del nuovo (la
//   risposta lenta non è sempre la più vecchia). Le righe `via:'customer'` escono dalla
//   tabella e finiscono in un blocco di SOLA lettura: non hanno riga di appartenenza,
//   quindi ogni rotta per-utente risponderebbe 404, e un comando che può solo fallire è
//   peggio di nessun comando. ⚠️ Il backend le accoda a OGNI pagina, non le conta nel
//   totale e ignora la ricerca, perciò il blocco si mostra solo a pagina 1 e senza filtro.
//   ⭐ I COMANDI DI RIGA LI SCEGLIE LO STATO, uno solo per riga: attivo → Disattiva;
//   inattivo con invito pendente → Reinvia invito; inattivo senza invito → Riattiva. Il
//   backend rifiuta l'offerta sbagliata con due 409 diversi (`USER_NEVER_ONBOARDED` /
//   `USER_NOT_PENDING_INVITE`), quindi offrirle entrambe è un comando che può solo
//   fallire. La targhetta ha tre stati e distingue Invitato (tono info: niente è rotto,
//   la persona non ha ancora accettato) da Disattivato — «Inattivo» faceva leggere le due
//   cause di `is_active:false` come una sola. Riattiva è disabilitata solo a un tetto
//   NOTO: ⛔ posti sconosciuti la lasciano abilitata, perché un comando grigio per dato
//   mancante è indistinguibile da uno grigio per rifiuto vero. «Correggi email» non c'è
//   sulla PROPRIA riga (la si cambia da Profilo; il 409 resta mappato come rete).
//   `resendThrottle.js` conta gli invii per INDIRIZZO (3 in 10 minuti) PRIMA del confirm,
//   perché dopo un 429 la frase «il link precedente smette di funzionare» non è vera:
//   ⛔ può solo rifiutare in anticipo, mai concedere un invio che il server rifiuterà, e
//   uno store bloccato o pieno non gli toglie il conteggio della sessione.
//   ⭐ RINOMINA (nella scheda WORKSPACE, un pulsante per riga — ⛔ non più in Utenti, e
//   quindi non per chi amministra un workspace senza essere admin d'azienda: scelta di
//   prodotto): abilitata solo per i workspace nei claims (`adminTenants`), perché la rotta
//   li verifica sul token; uno ritirato non ha il pulsante, uno appena creato lo ha
//   disabilitato fino al prossimo accesso. Prima il PATCH, poi `renameTenantLocally` — nuova
//   azione `TENANT_RENAMED`, ⛔ deliberatamente NON `TENANTS_REFRESHED`, che sostituisce
//   l'elenco e, se il workspace attivo non c'è, lo annulla espellendo l'utente — e solo su
//   200. La copia dice che il nome nuovo si vede ovunque dal PROSSIMO ACCESSO: i claims si
//   coniano al login.
//   ⭐ TRE SCHEDE per l'amministratore d'azienda. WORKSPACE: elenco con targhetta
//   «Ritirato» (⛔ mai filtrati via — un workspace ritirato occupa ancora un posto, e
//   nasconderlo farebbe sembrare sbagliato il conteggio), posti-workspace stampati solo se
//   noti (⛔ ignoto non è zero), e creazione: sul 201 la frase dice di ACCEDERE DI NUOVO e
//   il bottone lo fa, ⛔ mai noi — un'espulsione automatica subito dopo una scrittura
//   riuscita si legge come un errore. Il 409 `SEAT_LIMIT_REACHED` si biforca su
//   `err.details.source` (⛔ non `err.source`, che sarebbe `undefined` e prenderebbe sempre
//   il ramo sbagliato): 'plan' rimanda ai piani, ogni altro valore no — e il link a
//   /billing compare SOLO se l'azienda mostrata è quella del workspace ATTIVO
//   (`useManagedCompany().activeCompanyId`): /billing agisce su quella, e a un admin di due
//   aziende aprirebbe i piani dell'altra. Ignota → nessun link. MEMBRI AZIENDA:
//   vocabolario admin | viewer reso a PAROLE e non a slug (le altre tabelle parlano di
//   admin/editor/member, ed è un altro insieme), guardia sull'ultimo admin ATTIVO e sulla
//   propria riga, ⛔ e solo uno `attached` esplicito dichiara un'appartenenza — ogni altro
//   esito, ignoto compreso, è «invito inviato», perché promettere un'appartenenza che non
//   esiste è la bugia senza rimedio. ⛔ `USER_NOT_FOUND` è intercettato qui: su questa
//   rotta significa «non esiste ancora un account», non «utente non più disponibile».
//   DATI AZIENDA: il modulo di fatturazione, estratto in `CompanyBillingBody` e condiviso
//   con /billing-details, che ⛔ NON diventa un reindirizzamento alla scheda — sta dietro
//   un'altra guardia, e un amministratore d'azienda i cui workspace non sono quello attivo
//   verrebbe cacciato dal proprio record di fatturazione.
//   ⛔⛔ Le tre schede d'azienda sono NASCOSTE a chi non amministra l'azienda: eccezione
//   dichiarata alla regola «voci in grigio, mai nascoste». Quella regola serve a non far
//   rimescolare un menu per ruolo; queste non sono voci di menu ma sezioni di DATI che non
//   si possono leggere affatto, e una «Dati azienda» in grigio nominerebbe un'azienda con
//   cui l'utente non ha alcun rapporto. Due test la fissano, così riaggiungerle in grigio
//   rompe la suite invece di passare in revisione.
//   ⛔ `tenantAdminApi` esige ora il tenant come PRIMO argomento di OGNI export (TypeError
//   prima di qualunque richiesta) e lo manda in `?tenant=` con l'header soppresso: con un
//   selettore in pagina, una chiamata fatta guardando B avrebbe scritto su A. Nuovi
//   wrapper `resendTenantInvite`, `activateTenantUser`, `correctTenantUserEmail`,
//   `renameTenant`; nuovo `companyApi.js` per le 7 rotte /admin/customers/{cid}… che un
//   NON superadmin può chiamare, più il paio del record di fatturazione RI-ESPORTATO da
//   `admin/adminApi.js` (⛔ non spostato, e un test lo fissa). ⛔ Ogni percorso passa da
//   `isCustomerAdminOf(cid)` PRIMA della richiesta: un id estraneo o sconosciuto risponde
//   403 e mai 404, e quel 403 alza il banner «i tuoi permessi sono cambiati» — cioè
//   dichiara un cambio di diritti quando l'id sbagliato era il NOSTRO.
//   TEST: 126 → 140 suite, 1465 → 1614 test. `TenantUserListPage.jsx` è rinominato
//   `ManageUsersPage.jsx` e la sua suite da 906 righe è divisa in tre, più una quarta
//   sorella per i comandi nuovi. 67 chiavi i18n per lingua (il blocco `manage.*`), una
//   cancellata (`nav.tenant-admin-users`) e sei valori riscritti da «tenant» a
//   «workspace», perché con un selettore in pagina quella era l'ultima parola che il
//   prodotto aveva smesso di usare.
//   ⛔ Fuori portata: un amministratore d'azienda senza nessun workspace attivo (solo un
//   messaggio dedicato su /no-access), la persistenza del nome rinominato prima del
//   prossimo accesso, ritiro e cancellazione di un workspace (sul backend attivo sono da
//   superadmin), il registro delle modifiche dell'azienda e l'amministrazione dei piani.
//   ⚠️ Resta aperto: il link ai piani su `atCapPlan` è incondizionato, ma /billing risolve
//   l'azienda dal workspace ATTIVO, quindi chi amministra due aziende e sta guardando
//   l'altra arriva sulla pagina piani sbagliata (`SeatTile` trattiene il suo link proprio
//   per questo — serve una decisione di prodotto); ~55 righe di preambolo ripetute nelle
//   tre suite di ManageUsersPage, perché CRA tratta ogni file sotto __tests__/ come una
//   suite e un helper condiviso lì fallirebbe; e le due frasi del server ancora rese
//   da `PersonasView.jsx` (caricamento dell'elenco e 409 dell'interruttore).
//   ⛔ NON è [ZERO-BREAK]: la pipeline non cambia, ma la gestione degli utenti è un'altra.
// [FEAT-v177] Le personas si modificano a CAMPI, non più come file markdown: l'editor
//   passa a GET|PUT /personas/{id}/sections (corpo `{market, it, en|null}`) e il nuovo
//   `src/context/persona/` porta cinque moduli — `personaModel.js` (PURO: forma della
//   metà vuota, controlli lato client con le STESSE rotte d'errore del backend, corpo da
//   inviare, mappatura dei due dialetti 422 sulle NOSTRE chiavi di motivo, ⛔ mai un
//   carattere della prosa del server), `personaStyles.js` (i soli stili, condivisi fra
//   elenco ed editor), `PersonaHalfForm.jsx` (i campi di UNA metà; intestazioni e
//   sotto-etichette dalle `labels` servite dal backend, ⛔ mai scritte a mano; la forma di
//   Pain & Gain la decide il DATO, e non c'è alcun comando per cambiarla),
//   `PersonaEditor.jsx` e `NewPersonaPanel.jsx`. `PersonasView.jsx` torna a essere il
//   solo ELENCO: 1134 → 319 righe.
//   ⛔⛔ IL SALVATAGGIO SONO DUE RICHIESTE E NON È ATOMICO: il PUT delle sezioni congela
//   SEMPRE la persona (`human`), quindi «lascia che l'AI continui ad aggiornarla» è una
//   seconda POST …/unlock (e …/lock per ricongelare). Se quella fallisce dopo una
//   scrittura buona il testo È salvato e la persona resta bloccata: lo diciamo con
//   queste parole e offriamo il ritentativo del solo sblocco — ⛔ mai «salvataggio
//   fallito», o l'utente riscrive lavoro che il server ha già. Un 200 dello sblocco che
//   non elenca entrambe le metà vale come lo stesso esito. ⭐ Spostare SOLO il radio è
//   una modifica vera: abilita Salva e invia solo /unlock o /lock, nessun PUT.
//   ⛔ E una sola chiamata muove ENTRAMBE le metà: `unlockPersona` / `lockPersona` non
//   ricevono più una lingua e non si sparano più due volte.
//   ⛔ Via il tab «Testo» per tutti — il PUT dell'intero file (`{raw}`) è riservato ai
//   superadmin sul backend attivo: cancellati `personaMarkdown.js` e il suo test, le due
//   funzioni che lo chiamavano, `personaTemplate` e 20 chiavi i18n per lingua.
//   ⭐ La metà INGLESE è tutto-o-nulla: tutta vuota → `en: null`, riempita a metà →
//   rifiutata prima di ogni richiesta; e una metà che la GET ha restituito viene sempre
//   rinviata, così modificando l'italiano non la si può cancellare. Senza inglese
//   l'opzione «lascia che l'AI…» è DISABILITATA — il motore aggiorna solo le personas
//   scrivibili in ENTRAMBE le metà — ed è anche il terzo stato, neutro, della targhetta
//   («Non aggiornata dall'AI», accanto ad «Aggiornabile» e «Non aggiornabile»).
//   ⭐ CREAZIONE = il modulo completo: nome (→ id PERMANENTE) e mercato (fissa la forma di
//   Pain & Gain), poi lo stesso editor in modalità creazione. ⛔ Nulla è scritto finché
//   non si salva — una persona segnaposto è una persona che il motore usa volentieri — e
//   l'id è controllato DUE volte (elenco + una GET di sondaggio): in strict mode l'elenco
//   nasconde le personas globali che invece la scrittura risolve, e non esiste
//   If-None-Match, quindi un PUT su un id vivo è una sovrascrittura silenziosa.
//   ⛔ RIGHE LEGACY: `market == null` è una persona nel vecchio formato (in locale tutte
//   quelle di 10 tenant su 14) — la riga dice «Va ricostruita» e non offre Modifica,
//   perché la GET risponderebbe soltanto 409 PERSONA_LEGACY_FORMAT. Ricostruirla è una
//   riscrittura di CONTENUTO, quindi lavoro di BACKEND, richiesto a parte.
//   TEST: tre suite nuove (modello, form di una metà, editor) per 27 casi;
//   PersonasView.test.jsx 51 → 18 e la suite delle personas in contextApi 13 → 7, perché
//   descrivevano l'editor raw. Totale 126 suite / 1465 test.
//   ⛔ Fuori portata: il DELETE della persona (rinviato), l'editor raw per i superadmin
//   (rimosso, resta la CLI del backend) e le due frasi ancora prese dal server
//   nell'elenco (caricamento della lista e 409 dell'interruttore).
//   ⛔ NON è [ZERO-BREAK]: la pipeline non cambia, ma l'editor delle personas è un altro.
// [FIX-v176] Gestione utenti parla solo la nostra lingua: caricamento dell'elenco,
//   cambio ruolo, disattivazione (dopo `membershipRefusalCopy`) e rimozione passano da
//   `tenantAdmin/userActionError.js` — `userActionErrorCopy(t, err)`: codice → copia
//   nostra, ⛔ mai la frase inglese del server. ⭐ La rimozione è tradotta NELLA PAGINA
//   e ri-lanciata come nuovo Error, perché il ConfirmDialog è condiviso da sette
//   schermate: resta intatto e mostra la NOSTRA frase senza sapere nulla di questi
//   codici. Il reset della PROPRIA password è disabilitato sulla propria riga (campo e
//   bottone, come già il ruolo) con il rimando a Profilo → Cambia password, e
//   `passwordChanged` diventa `!isSelf && …`, così quella riga non può nemmeno
//   tentarlo; il 409 CANNOT_RESET_OWN_PASSWORD resta mappato come rete di sicurezza.
//   Una sola chiave i18n nuova: `tenantUsers.cannotResetOwnPassword`.
//   AssignTenantModal (superadmin) passa a errori con chiave tramite un
//   `assignErrorCopy` LOCALE al file e ⛔ non l'aiutante di sopra: quella rotta
//   (POST /admin/tenants/{tid}/users) ha un vocabolario diverso — ⚠️ «nessun account
//   con questo indirizzo» è 404 RESOURCE_NOT_FOUND, non USER_NOT_FOUND — e conosce
//   CANNOT_ATTACH_SUPERADMIN e USER_TENANT_ASSIGNMENT_EXISTS, mentre non ha alcun
//   codice sui posti. Nessuna chiave i18n aggiunta, e la prima suite di test per quel
//   componente.
//   CODICE MORTO: via `state.suggestProgress`, sempre null dalla v175 perché nessuno lo
//   scriveva più — la dichiarazione in `createInitialState()`, la guardia di
//   `formVisible` (che non poteva più essere falsificata) e il ramo «Suggerisci
//   loading» del ternario dello Step 1.
//   IGIENE DEI TEST: un'asserzione VACUA in TenantCreateUserModal.test.jsx (cercava una
//   frase che non esiste più in nessuna lingua, quindi non poteva fallire) ora legge un
//   frammento di `seats.rule` dal file di lingua; e via «(Phase 7b)» da due intestazioni.
//   ⛔ Restano fuori portata, e ancora con la prosa del server: il caricamento di
//   TenantRunListPage e il ConfirmDialog condiviso.
//   ⛔ NON è [ZERO-BREAK]: la copia degli errori di Gestione utenti cambia, e da quel
//   dialogo non si reimposta più la propria password.
// [ARCH-v175] Pulizia dei residui del ramo backend `stripe-payments`, ABBANDONATO e
//   mai unito: il backend attivo è `dev`, e tutto ciò che il FE chiamava e che solo
//   quel ramo serviva è stato rimosso o ri-originato.
//   ⛔ Niente più re-mint delle claim: quella POST non esiste su `dev` (404 a ogni
//   boot e a ogni focus, ignorato in silenzio). Via `refreshClaims`, il re-mint al
//   boot e quello sul focus; resta il solo GET /auth/me. ⭐ E lì c'era un BUG VERO:
//   `is_superadmin` arriva dalla riga utente (quindi fresco dal DB) ma nessuno lo
//   applicava, perché il commento lo dava «già applicato» dalla chiamata che
//   rispondeva 404 — una concessione o una revoca di superadmin a sessione aperta non
//   veniva MAI raccolta. Ora `refreshMe` la applica con il nuovo
//   `applySuperadminChange`, lo stesso ramo che usa `applyClaims`, e ⛔ con l'elenco
//   VIVO dei tenant: quelli di /me sono il token riletto e non toccano mai la logica
//   delle claim. `reauthenticate` è diventata una disconnessione — unico rimedio
//   onesto quando le claim si coniano solo al login, ed è ciò che la copia dice già.
//   ⛔ `applyClaims` RESTA: è l'aiutante di `applySession` (gli inviti v174).
//   POSTI ri-originati: il contatore legge `user_seats_used` / `user_seat_limit` /
//   `user_seat_source` dalla BUSTA di GET /tenant-admin/users (`countTenantUsers` →
//   `fetchTenantSeats`), e `maxUsers` sparisce da useEntitlements — /credits/balance
//   non ha mai servito quel campo su `dev`, quindi il riquadro non mostrava alcun
//   tetto. ⭐ Un posto è una PERSONA dell'AZIENDA (persone distinte in tutti i suoi
//   workspace, più gli amministratori della fatturazione), non un'iscrizione al
//   workspace: disattivare LIBERA il posto. La copia diceva l'esatto contrario ed è
//   riscritta. Tre risposte distinte: tutto null = non si sa (nessun riquadro),
//   'unlimited' = nessun tetto, 'plan' | 'customer' = tetto vero; e il rimedio si
//   ramifica su `source` ('plan' → /billing, 'customer' → assistenza, nessun link:
//   un piano più grande non alza un tetto imposto all'azienda). ⛔⛔ Il bottone
//   «Aggiungi» NON si disabilita più a posti esauriti: lo stesso dialogo collega anche
//   un collega già dell'azienda, che il backend accetta ANCHE a tetto pieno; il 409
//   USER_SEAT_LIMIT_REACHED dentro al dialogo è la guardia.
//   CODICE MORTO: via `services/api/sseClient.js`, `handleSuggest` e tutto il flusso
//   «Suggerisci» (POST /briefs/generate non esiste più su NESSUN ramo dal 2026-05-28,
//   ed era già irraggiungibile: Step1Setup destrutturava `onSuggest` senza mai
//   chiamarlo), `SUGGEST_SLOTS` / `mapSuggestEvent`, il parametro `fact_check` di
//   startPipelineRun, il ramo USER_LIMIT_REACHED di AssignTenantModal (codice mai
//   emesso — quella rotta superadmin non ha alcun controllo sui posti) e sei chiavi
//   i18n orfane. ⛔ Restano `buildPipelineSlots` / `mapPipelineStatus` e il
//   `b.fact_check?.enabled` di BriefPreview, che legge un campo del brief e non il
//   parametro. ⚠️ `state.suggestProgress` resta nello store, ora sempre null.
//   ⛔ NON è [ZERO-BREAK]: comportamento e copia del riquadro posti cambiano.
// [FEAT-v174] Inviti agli account: nessuno entra più in un workspace senza averlo
//   accettato. Nuova pagina /invitations/accept (fuori da AppShell e ⛔ NON in
//   PUBLIC_RECOVERY_PATHS: a differenza del recupero password questa rotta HA
//   BISOGNO della sessione, è `phase` a dirle se accettare o chiedere l'accesso).
//   Il token vive in sessionStorage PER SCHEDA (`pending_invitation`): da
//   disconnessi la pagina lo parcheggia e rimanda al login con il suo banner, e
//   `login()` riprende da lì. ⛔ Una sola POST per tentativo, fermata da un ref e
//   non dallo stato: il token è monouso e StrictMode rimonta gli effetti. Al 200
//   nessun salto automatico — un pannello di esito con un bottone esplicito, e il
//   workspace da aprire si trova DIFFERENZIANDO gli id dei tenant prima/dopo
//   (TenantInfo non porta `customer_id`, quindi «l'unico tenant» aprirebbe uno
//   spazio estraneo). Ogni pannello d'errore offre «Continua senza accettare», che
//   pulisce il token: uno scaduto non deve intrappolare un accesso successivo.
//   ⛔ Nessun `err.message`: si ramifica su `err.code` (+ `err.reason`) e un codice
//   non mappato mostra IL CODICE, mai la frase inglese del server.
//   AuthContext guadagna `applySession(data)` (adotta la sessione restituita da un
//   endpoint che non è il login — ⚠️ la risposta di accept NON porta
//   `is_superadmin`, e `applyClaims` leggerebbe l'assenza come una revoca),
//   `selectTenant(oggetto|id, {to})` e `logout(opts)`: un `logout()` semplice
//   pulisce l'invito parcheggiato, solo `logout({notice})` lo conserva.
//   «Gestione utenti»: aggiungere una persona è ora INVITARLA — email, nome e
//   ruolo, nessuna credenziale. TRE esiti distinti da una sola submit e nominati
//   come tali: «creato e invitato» (201 create), «aggiunto subito» (201 attached —
//   collega già dell'azienda, lo vede al suo prossimo accesso, e funziona ANCHE a
//   posti esauriti) e «invito inviato» (202 invitation_sent — nulla è cambiato,
//   nessuna riga in elenco), più la variante «non consegnato» quando `email_sent`
//   è false. Uno `status` sconosciuto degrada a «invitato»: dichiarare
//   un'iscrizione che non esiste è la bugia peggiore. ⛔ Il `warning` del server
//   (prosa inglese fissa) non è mai reso.
//   Nuovo `tenantAdmin/membershipRefusal.js`: i 409 USER_HAS_OTHER_MEMBERSHIPS
//   (controllato PRIMO, come fa il backend) e USER_HAS_OTHER_TENANTS hanno una
//   nostra copia PER AZIONE (disattiva / reimposta password / modifica profilo) —
//   il rimedio è proprietà dell'azione, non del codice; un'azione senza voce
//   restituisce null invece di un rimedio plausibile e sbagliato. ⛔ Gli id in
//   `other_tenants` / `other_customers` non si rendono mai.
// [FIX-v174] «Gestione utenti» era ROTTA su `dev`: il dialogo inviava `password` a
//   POST /tenant-admin/users, che dal 2026-09-03 è `extra="forbid"` → OGNI
//   aggiunta rispondeva 422 e il ripiego create→attach non partiva nemmeno. Ora il
//   corpo è `{email, role}`. Corretto il nome del codice posti in src/tenantAdmin
//   (era USER_LIMIT_REACHED; il backend emette solo USER_SEAT_LIMIT_REACHED) e
//   tutti i wrapper di tenantAdminApi.js lanciano buildApiError, così `code`,
//   `status` e `retry_after_seconds` sopravvivono fino al chiamante.
// [FEAT-v173] Piani: le card dei piani sono RAGGRUPPATE. Due toggle globali
//   (periodicità e workspace per licenza) sopra UNA card per famiglia: 13 card
//   diventano 3 più la prova. ⛔⛔ Il toggle SELEZIONA una riga del server, non
//   ne costruisce una: prezzo, crediti, limiti, `action`, `reason` e `disclosure`
//   vengono tutti dalla stessa riga di `options[]`, e il `plan_id` inviato è il
//   suo. ⛔ Nessuna cifra derivata (niente «risparmi il 20 %»: i prezzi annuali
//   sono arrotondati a monte). Gli assi si costruiscono DAI DATI, mai 2×2 fisso.
//   Due ripieghi perché il layout non nasconda mai un piano acquistabile: righe
//   in collisione su una cella → famiglia piatta; cella mancante → placeholder.
//   La posizione iniziale segue il piano in vigore ed è DERIVATA a ogni render.
//   ⭐ Corretto «0 EUR / mese» su Free: il suffisso di periodo sparisce quando
//   `billing_interval` è null (i 14 giorni non sono un intervallo di fatturazione).
// [FEAT-v172] Navigazione e CTA: «Crediti» e «Piani» lasciano la sidebar e
//   raggiungono Profilo e Dati di fatturazione nel menu dell'avatar (pagine di
//   lettura sopra il divisore, account sotto). La rail crediti resta in sidebar e
//   ora è un link a /credits — ⚠️ è una comodità, non un ripiego: non compare in
//   admin mode, senza tenant, su fetch fallito o su un tenant senza allowance.
//   /credits guadagna «Piani disponibili» accanto al saldo. ⛔ Le CTA di rifiuto
//   non puntano più a /credits, che dal v171 non vende nulla: CREDITS_EXHAUSTED,
//   TRIAL_EXPIRED e «posti esauriti» vanno a /billing; FEATURE_NOT_IN_PLAN e il
//   402 generico perdono il link e restano frasi — non sappiamo QUALE piano
//   includa quel formato, e indovinare il rimedio è l'errore che NO_ALLOWANCE ha
//   già pagato una volta.
// [FEAT-v171] Piani: la schermata piani/abbonamento (/billing) RISCRITTA sul nuovo
//   contratto. ⭐ UNA sola lettura costruisce la pagina: GET /billing/subscription porta
//   il piano in vigore, ogni piano come riga con prezzo e con l'AZIONE da offrire, il
//   cambio in sospeso o la disdetta programmata, i pacchetti in vendita e la completezza
//   dei dati di fatturazione. ⛔ /billing/plans non esiste più. Il BACKEND decide
//   (`action` / `reason_code`), il FE si limita a disegnare: mai dedurre un bottone da
//   prezzo, id o date. Il piano corrente si marca dal `plan_id` di PRIMO livello (il
//   piano free/special del cliente è tra le righe nascoste). Prezzi NETTI di IVA
//   («+ IVA»): il FE non calcola mai l'IVA. ⛔ Prima di ogni acquisto e di ogni cambio si
//   mostra la `disclosure` del server e si chiede conferma. `/cancel` ha DUE esiti
//   (fine periodo o immediato): si decide sullo `status` della risposta, mai su
//   `cancel_at_period_end`, che ha TRE valori (null ≠ «non in disdetta»). I pacchetti
//   si SOMMANO in un unico `purchased_remaining` e dal checkout si torna su /credits.
//   Nuovi componenti PlanCard / CurrentPlanPanel / PacksPanel / ConfirmDisclosure.
//   ⛔ Eliminati il flag `BILLING_ENABLED` (/billing e /billing/return sempre montate:
//   il server risponde 503 STRIPE_NOT_CONFIGURED per richiesta), Pricing.jsx,
//   SubscriptionCard, TopUpCard (via da /credits) e billingFixtures.js; ritirati dal
//   runRefusal i codici SUBSCRIPTION_ENDED / SUBSCRIPTION_INACTIVE.
// [FEAT-v170] Account: due nuove pagine raggiunte dal menu avatar. «Dati di
//   fatturazione» (/billing-details) esce da /credits — non è mai stata roba del
//   wallet ma l'identità fiscale dell'azienda; il customer viene risolto dal TENANT
//   ATTIVO perché `customers[]` è un ARRAY e scegliere «il primo» sarebbe sbagliato in
//   silenzio. «Profilo» (/profile) fonde i due modali (dati + password) e riusa
//   auth/passwordPolicy.js: prima la stessa password era rifiutata dal recupero e
//   accettata dal cambio. ⛔ Sparisce «Impostazioni», che prometteva impostazioni e
//   apriva un solo campo password. La lingua resta UNA sola voce nel menu e ora scrive
//   ANCHE `users.locale` (la lingua di tutte le email transazionali), con seeding al
//   boot dall'account quando il browser non ha una scelta propria — prima il campo era
//   di sola scrittura per un setter locale che ombreggiava quello importato.
//   ⚠️ Perché il seeding possa scattare, il language detector non scrive più
//   `app_locale` da solo (`caches: []` in i18n/index.js): la chiave la scrive SOLO un
//   click esplicito IT/EN. I browser che avevano già una `app_locale` auto-scritta la
//   tengono finché l'utente non cambia lingua dal menu.
//   ⭐ Una voce riservata resta VISIBILE e disabilitata: il menu non si riordina per ruolo.
// [FEAT-v169] Crediti: il saldo racconta i DUE POTS. Il BE ha rinominato
//   `monthly_credits` in `allowance_credits` e aggiunto `allowance_remaining` (l'allowance
//   del periodo, che si azzera al grant successivo) e `purchased_remaining` (acquistati,
//   non scadono mai, ⚠️ può essere NEGATIVO = deficit). Il totale spendibile resta
//   `remaining_credits` e ora non ha più denominatore: il pot acquistato non ha un tetto,
//   quindi il gauge misura solo l'allowance. ⛔ Rimossi perché il BE li ha ritirati:
//   `subscription_ended`, `expiring_credits`/`expires_at`, `licenses` (badge bundle in DUE
//   punti) e lo stato `noGauge`, irraggiungibile. La card passa da SEI stati a QUATTRO.
//   ⚠️ La rail crediti in sidebar era sparita del tutto (denominatore null → return null):
//   ora torna. `NO_ALLOWANCE` ha finalmente la sua copy e NON offre più "Aggiorna piano":
//   il piano è sano, il periodo crediti non è mai stato aperto — nuova CTA `contactSupport`.
// [FEAT-v168] Entitlements: i tipi di output disponibili arrivano da
//   GET /api/v1/entitlements (`variants[]`), non più da `allowed_formats` sul saldo
//   crediti — campo ritirato dal BE il 2026-09-20. La griglia mostra sempre tutti i
//   formati e disabilita quelli fuori piano; `reason` (NO_PLAN / FEATURE_NOT_IN_PLAN /
//   APP_NOT_ASSIGNED) spiega perché, e APP_NOT_ASSIGNED NON offre l'upgrade (lo risolve
//   un operatore, non un pagamento). Un 503 mantiene l'ultimo stato noto: «non
//   verificabile» non è «non hai nulla». Sul run, 403 FORMAT_NOT_IN_PLAN è sostituito da
//   402 FEATURE_NOT_IN_PLAN e 403 APP_NOT_ASSIGNED, che rileggono /entitlements invece di
//   fidarsi di `details.granted` (id con prefisso, wildcard non espansa).
// [FEAT-v167] Knowledge Base: gestione completa di documenti e sito (issue "KB - docs and
//   website management"). La pagina diventa due card — «Connettori» (sito collegato, chip di
//   stato, «Gestisci») sopra e la Document Library sotto — con lo stesso corpo
//   (context/KnowledgeBaseView) per i tre mount; la card del sito compare solo a un
//   tenant-admin perché TUTTI i nove endpoint del Site Manager, GET compresi, lo richiedono.
//   Documenti: download (blob via apiFetch, un <a href> non porta il bearer), drop zone con
//   selezione multipla (UNA richiesta per file, esiti per file, stop al primo 402/503), conferma
//   prima di sovrascrivere un nome già presente (il BE sostituisce in silenzio), badge
//   «nessun testo estratto» su `ready` con chunk_count 0, `stale` = «da indicizzare», 402/503
//   parlati da RunRefusalNotice come una generazione rifiutata, paginazione lato client.
//   Sito: modale con tabella URL (Mantieni/Escludi), modifiche accumulate per URL e salvate in
//   UNA PATCH sotto If-Match (site/urlDelta.js: `add` non pinna, le regole `…/*` sono in sola
//   lettura, `applied` si legge al passato), ricarica/reindicizza con conferma e con il
//   409 SITE_APEX_CHANGED reso come conferma distruttiva prima del secondo POST, «Needs
//   review» con Accetta (nascosto a shadow_pending 0) e Annulla, chip a cinque stati con
//   polling illimitato e consapevole della scheda (site/useKbStatus.js). Il lock durante un
//   job è solo UX: il 409 KB_JOB_ACTIVE resta gestito su ogni scrittura.
// [FEAT-v166] Personas: due flag al posto di quattro stati, e creazione.
//   La badge non nomina più `seeded|machine|human|unlocked` ma risponde all'unica
//   domanda che la schermata pone: l'ottimizzazione automatica aggiorna questa persona
//   o no. Quattro nomi per due risposte obbligavano il lettore a tradurre `seeded` e
//   `machine` in "sì" ogni volta. ⛔ `seeded` mappa su "sì" con UNA eccezione che il
//   filo non sa esprimere: `may_overwrite` legge una riga seeded come scrivibile solo
//   finché i byte coincidono con `base_content`, quindi un file modificato a mano PRIMA
//   che esistesse lo stamp legge `seeded` e viene saltato lo stesso. Irraggiungibile per
//   tutto ciò che si scrive da ora (ogni PUT marchia), quindi il flag è esatto per ogni
//   file toccato da questo editor e sbagliato solo sulle modifiche pre-2026-09-14 — cioè
//   esattamente il bug che questa funzione ha chiuso. `null` resta senza badge: tre cause
//   indistinguibili, nessuna delle quali è "non bloccata".
//   NUOVA PERSONA: due soli campi, il nome e quel flag. L'id è DERIVATO dal nome (mostrato,
//   non digitato: è l'indirizzo permanente del file e non si rinomina) e il mercato è
//   preimpostato nel template, dove si vede e si cambia nella schermata successiva.
//   ⛔ Il template non è decorativo: `validate_persona_shape` confronta l'H1 e le quattro
//   intestazioni ESATTE e nell'ordine, e una sezione senza corpo conta come `empty_section`,
//   quindi ogni segnaposto occupa più di una riga — uno scheletro vuoto verrebbe rifiutato
//   con 422 al primo Crea. Verificato contro il validatore vero, non dedotto.
//   ⛔ La rotta di scrittura non ha una precondizione "solo creazione" (If-Match confronta
//   un etag, If-None-Match non esiste), quindi una PUT su un id vivo è una sovrascrittura
//   ordinaria: il controllo sugli id già presenti nella lista è l'unica difesa e sta qui.
//   ⭐ Il flag in creazione parte su "aggiornabile dall'AI", al CONTRARIO del default
//   dell'editor e del backend: ciò che il pannello scrive è uno scheletro di segnaposto, e
//   uno scheletro bloccato alla nascita è una persona che si tiene i TODO per sempre mentre
//   ogni run riporta successo. Un testo scritto davvero è un altro gesto, e si salva
//   dall'editor, che infatti difende la versione dell'utente.
//   GUARD 2 vale anche in creazione: su un tenant che non possiede nessun file persona il
//   primo write attiva la strict mode e ne nasconde 13, quindi il bottone non c'è.
//   [ZERO-BREAK] nessuna modifica a pipeline, prompt o rendering degli output.
// [FEAT-v165] Provenance e unlock delle personas. Il salvataggio non è più una porta a
//   senso unico scoperta dopo: putPersona manda `engine_may_update` ESPLICITO (false =
//   "mantieni la mia versione" → stamp `human`, true = "lascia che l'AI continui ad
//   aggiornarla" → stamp `unlocked`), così una correzione di forma e una riscrittura
//   finalmente si distinguono. Il BE ha default false, ma lo mandiamo comunque: nessuno
//   deve bloccare una persona per non aver notato un controllo.
//   ⚠️ Lo STAMP è per metà, il MOTORE valuta la COPPIA. `may_overwrite` gira su metà
//   italiana E inglese e salta la persona se anche solo una è bloccata, e una `_ENG` non
//   marcata che differisce di un byte dalla gemella globale legge già come bloccata.
//   Conseguenze visibili nella UI: un solo controllo governa entrambe le tab (non si
//   resetta al cambio tab) e lo sblocco fa DUE chiamate, base + ?language=en. Un 404 sulla
//   metà inglese è lo stato ordinario "mai tradotta" e vale come successo; qualunque altro
//   rifiuto è uno sblocco PARZIALE e viene detto, perché un "sbloccata" verde su una
//   persona che il motore continua a saltare è esattamente il silenzio che questa schermata
//   esiste per evitare.
//   La copy del blocco ha DUE formulazioni scelte da `unlock_effective`: dove è true si
//   promette il ritorno, dove è false (i quattro tenant legacy mai marcati, dove POST
//   /unlock risponde 200 e non cambia nulla) resta quella permanente. Ammorbidirle entrambe
//   sarebbe una bugia su quei quattro, indurirle entrambe su tutti gli altri.
//   Badge di stato per riga su `state` (seeded|machine|human|unlocked). ⛔ `null` NON
//   significa "non bloccata": ha tre cause indistinguibili sul filo (chiamante non admin
//   qui, ledger irraggiungibile, riga mai scritta), quindi nessun badge e nessuna
//   inferenza. Stessa logica per `provenance_state: null` nella risposta al PUT, che non è
//   una scrittura fallita ma uno stamp perso DOPO che i byte sono atterrati: i byte ci
//   sono, la scelta no, e il messaggio è l'unico posto in cui l'utente lo scopre.
//   La coppia (`state`, `unlock_effective`) arriva sia dalla LISTA sia dal GET di
//   dettaglio, e l'editor preferisce la seconda: l'avviso sul blocco si legge PRIMA
//   del salvataggio, su una lista caricata al mount, ed è l'unica frase della
//   schermata che lo sblocco di un collega o un cambio tenant in un'altra scheda
//   può rendere falsa senza che nulla si muova. Il default del controllo segue lo
//   stato più fresco, ma solo finché l'utente non l'ha toccato: una scelta vale per
//   entrambe le metà e non deve resettarsi al cambio tab.
//   Due rifiuti del salvataggio hanno finalmente copy propria invece del testo
//   inglese del server, e dicono cose OPPOSTE: 422 CONTEXT_ENTITY_INVALID (la
//   validazione della forma persona ora gira sulla scrittura) è un esito ordinario
//   di editing — il file non è stato salvato, le sezioni mancanti sono elencate
//   sotto, si corregge e si risalva; 503 SERVICE_UNAVAILABLE significa che NON è
//   stato scritto NULLA, perché il ledger viene acquisito PRIMA dei byte proprio
//   perché una modifica non possa mai atterrare senza autore — il contrario di
//   `provenance_state: null`, dove il testo è salvato e si è persa solo la scelta.
//   GUARD 2 (riga `source: "global"` non modificabile) RESTA, ma per l'altra metà del suo
//   motivo: ora un file creato via API porta la sua riga di provenance, quindi copiarne 13
//   non ne bloccherebbe più 13 — però la prima delle 13 scritture attiva comunque la strict
//   mode, e senza transazione dietro le altre 12 un fallimento a metà lascia il picker in
//   strict mode su un set parziale. Serve un endpoint di scaffold lato server, non un loop
//   in una tab del browser: resta lavoro da CLI operatore.
//   [ZERO-BREAK] nessuna modifica a pipeline, prompt o rendering degli output.
// [FEAT-v164] Gestione Personas (work item #38). Nuova PersonasView montata su
//   /tenant-admin/personas e /admin/personas (dropdown tenant per i SA), scritta sui tre
//   endpoint già esistenti: GET /context/personas?include_disabled=true (il flag porta con
//   sé il gate admin — senza, il BE filtra e ogni `enabled` legge true), PUT
//   /context/personas/{id}/enabled (una chiamata per persona, niente bulk, niente ETag) e
//   GET|PUT /context/personas/{id}?language=it|en per il contenuto delle due metà.
//   Raggruppamento su `market`, che è language-INVARIANT: un tenant vecchio formato non ne
//   dichiara nessuno e la lista resta piatta invece di mostrare un'unica intestazione
//   "senza mercato". Il 409 CANNOT_DISABLE_LAST_PERSONA è un MESSAGGIO, non uno stato: il
//   toggle non si muove.
//   ⛔ Due porte a senso unico, entrambe sbarrate nella UI e non nel backend, che non le
//   conosce: (1) il salvataggio BLOCCA la persona — putPersona non scrive provenance e il
//   gate `may_overwrite` è file-granulare, quindi da lì in poi `tenant-personalize` la
//   salta in silenzio con la run che riporta comunque successo; non esiste una rotta di
//   unlock per le personas (l'unica accetta field path di brand-guidelines più il
//   sentinel `voice`), perciò lo diciamo a ogni salvataggio invece di scoprirlo mesi dopo.
//   (2) una riga ancora `source: "global"` NON è modificabile: il primo file persona di un
//   tenant attiva la strict mode e fa sparire dal picker tutte le altre, senza ritorno via
//   API. In pratica non dovrebbe mai capitare (l'onboarding ne materializza 13), e quando
//   capita il rimedio è la CLI operatore, non un editor di testo.
//   Due modifiche di contorno che il toggle stesso rende necessarie: 422
//   BRIEF_VALIDATION_FAILED con field "persona" ora è parlato come "ricarica la pagina"
//   (il picker si aggiorna una volta per lingua e non rivalida, quindi una persona
//   disattivata resta offerta nelle tab aperte) e PERSONA_OPTIONS torna allineato al set
//   globale corrente (9 B2B + 4 B2C) dopo essere rimasto ai 6 pre-2026-09-06.
//   [ZERO-BREAK] nessuna modifica a pipeline, prompt o rendering degli output.
// [FEAT-v163] Recupero password self-service (issue #34). Tre nuove rotte pubbliche fuori
//   da AppShell: /forgot-password (POST /auth/password-reset, sempre 202 — copy neutra,
//   mai "email inviata", per non trasformare l'endpoint in un oracolo di esistenza
//   account), /password-reset?token= e /set-password?token= (un solo
//   TokenPasswordScreen con variant, 400 ramificato su reason UNKNOWN|EXPIRED|
//   ALREADY_USED letto dal TOP LEVEL dell'envelope, non da detail). /set-password fa
//   parte di #34 perché lo stesso POST /auth/password-reset invia il link di onboarding
//   quando l'utente non ha mai completato l'attivazione ("one button, two mails").
//   LoginScreen guadagna il link "Password dimenticata?" e la notice post-reset;
//   AuthContext.login mappa RATE_LIMITED e riformula AUTH_USER_NOT_FOUND in "account
//   disattivato, contatta un amministratore" (dopo un reset riuscito su un account
//   disattivato la password È corretta). Requisiti password lato client (8–128 +
//   Upper/Lower/SpecialChar) sono SOLO UX: il backend valida solo 8–128.
//   [ZERO-BREAK] nessuna modifica a pipeline, prompt o rendering degli output.
// [FEAT-v162] Tono servito dal backend — il dropdown legge GET /api/v1/context/tone-presets
//   (per-tenant, label localizzate via ?language) invece dell'array hardcoded TONE_OPTIONS,
//   che resta come fallback offline. useContextOptions espone toneOptions; l'opzione
//   "custom" resta solo FE e viene appesa in coda. Nuovo registro moduli in toneMigration
//   (registerTonePresets) così toneStateFromParams riconosce gli slug specifici del tenant
//   invece di scambiarli per testo libero; l'effetto di reconcile ripara i run ricaricati
//   prima che i preset arrivino. Nuovo resolveToneLabel in optionLabels: per il tono la
//   label del BE vince sull'i18n (options.tone.* è stale by construction) ma solo per le
//   voci source:'backend', così il fallback resta localizzato. [ZERO-BREAK] brief.tone_hint
//   invariato.
// [FIX-v161] Review Content Generator (feedback 17/06/2026).
//   (1) Le etichette di persona/obiettivo/tono passano da un unico helper i18n
//   (utils/optionLabels.js) in Parametri, Riepilogo di input, riepilogo di output E
//   BriefPreview (Storico Generazioni / Examples): prima lo stesso valore usciva con
//   tre testi diversi (traduzione i18n nel form, label del backend nel Riepilogo, slug
//   di wire nell'output). Ordine di risoluzione unico: options.<group>.<value> →
//   label backend → '—' (o il valore grezzo, dove serve non perdere informazione).
//   (2) Riepilogo input: aggiunta la riga Argomento; il tono "custom" mostra il testo
//   personalizzato; il chip "Fonti prioritarie" richiede ora toggle acceso E almeno una
//   fonte reale (prima restava acceso sia togliendo gli URL sia spegnendo il toggle).
//   (3) Label dei Parametri normalizzate a un solo stile tipografico (fieldLbl, Title
//   Case dall'i18n); lo stile `lbl` resta rimosso perché diventato orfano — con CI=true
//   una const inutilizzata rompe la build. Helper del tono: 'Custom' → 'Personalizzato'.
//   (4) Blog SEO: blocco keywords riallineato — Principale a piena larghezza, tre
//   Secondarie affiancate sotto (auto-fit, così vanno a capo sotto i 980px).
//   (5) Output: header dell'entry ridotto a icona + "Contenuto" (via reviewId e badge di
//   formato); rimossi i bottoni Copia/Scarica **page-level** di CgOutputHeader e tenuti
//   quelli per-entry, che sono gli unici a coprire anche le generazioni non più recenti;
//   riepilogo ridotto a Argomento/Tipo/Formato/Persona/Obiettivo/Tono, metriche
//   Fact-Check/Style/QA Score in un blocco proprio.
//   (6) Tabella Verifica (ex "Verifica Claim") a 3 colonne Frase/Stato/Fonte, senza i
//   badge sommativi nel titolo; Fonti di ricerca a 2 colonne Fonte/Passaggi Estratti,
//   con il tipo di fonte come badge dentro la colonna Fonte e i passaggi accanto alla
//   loro fonte (base di source_index dedotta dai dati + blocco "orfani" di sicurezza).
//   (7) Avviso curator: localizzato **solo il nome dell'agente** ("Revisione editoriale"
//   / "Editorial review"). Il testo del warning di densità keyword resta in inglese
//   tecnico: serve il warnings[].code dal backend — punti 9.3/9.4 del piano aperti.
//   (8) Breadcrumb di Input e Output condividono ora un unico BreadcrumbTrail; sulla
//   vista Output i chip di sezione sono disabilitati, "Output" è attivo ma non
//   cliccabile e il ritorno al form è agganciato al primo chip.
//   [ZERO-BREAK] pipeline, prompt, forma del brief e chiamate al backend invariati.
// [ARCH-v160] Frontend-wide Brian UI 1.0 harmonization. Every surface outside the
//   already-restyled shell/wizard/tenant-admin console now reads from
//   constants/theme.js instead of hard-coded values: admin primitives + all 14 admin
//   pages, context/ views, the three remaining dark auth screens (TenantPicker,
//   NoAccessScreen, BootSpinner → light card on `bg`, matching LoginScreen), sections/,
//   components/ui, components/credits, components/charts and all 18 output renderers.
//   Files on tokens: 15 → 100. The legacy ESC red accent (#E8002D) folds into
//   COLORS.accent, the olive/slate neutrals into the ink/testo ramp, raw Tailwind status
//   hexes into SEMANTIC pairs, and DM Sans into FONT_SANS (dropped from index.html).
//   New tokens: FONT_MONO, SEMANTIC.neutro, VERDE_DARK, CHART_SERIES, CHART.
//   Charts get a validated categorical palette (lightness band / chroma floor / CVD
//   separation / contrast all checked) assigned in fixed order; status colours stay
//   reserved and the ActivityHeatmap ramp is now single-hue light→dark.
//   Platform brand colours in components/outputs (LinkedIn, Instagram, YouTube…) and the
//   per-mode accents in constants/modes.js are deliberately untouched — they carry
//   channel identity, not product styling.
// [ARCH-v160] Output renderers share one style vocabulary. components/outputs/
//   OutputPrimitives.jsx extracts the LinkedIn house style — SectionLabel, ContentBlock,
//   Field, TagChips, Callout, CopyBtn, MetaFooter — and every channel renders through it.
//   Before: Instagram/Facebook/YouTube/Pinterest each carried a byte-identical private
//   SectionLabel while LinkedIn and Social inlined theirs with a hard-coded #555568, so
//   the channels had drifted on label spacing (6 vs 8px), block tint (w .03/.04/.06) and
//   chip treatment (brand-tinted pills vs neutral squares on Pinterest). Channel identity
//   now travels only through the `color` prop; geometry and type scale are constant.
//   Also fixes a latent bug present since before this change: in LinkedInResultEntry the
//   metadata row's `display: 'flex'` and `gap: '12px'` were swallowed INSIDE the
//   fontFamily string literal and silently dropped.
// [FIX-v160] Removed the notched wheel scroll added in v159. The `wheel` listener on
//   .app-main intercepted every gesture and animated to the next/previous section
//   behind a 650ms lock, so scrolling the Step-1 form stalled at each section card
//   instead of running continuously. Scrolling is now plain native scroll; the
//   breadcrumb keeps its scroll-spy (passive `scroll` listener) and clicking a chip
//   still animates via scrollToId, since that is an explicit navigation action.
//   Drops lockRef / activeIdRef / the prefers-reduced-motion branch, which existed
//   only to serve the snap.
//   [ZERO-BREAK] — no pipeline, prompt or output-format change; 733 tests green throughout.
// [FEAT-v159] Content Generator page header + breadcrumb + notched scroll, and Fonti 4→3.
//   (1) "Content Generator" title + breadcrumb (CgBreadcrumb) portalled INTO the shell Header
//   (left of the profile chip) via #cg-header-slot — matches Figma's integrated header band;
//   Header grows to fit. Chips Tipo di contenuto / Brief / Parametri / Fonti (anchor-scroll to
//   the section cards via id #cg-tipo/#cg-brief/#cg-parametri/#cg-fonti) + Output (disabled
//   until outputHistory has an entry, then jumps to wizardStep 2; its icon mirrors the
//   selected platform via MODE_ICONS[activeMode]). Active chip tracked by a scroll-spy over
//   the .app-main container. (2) Notched wheel scroll on .app-main: one wheel
//   gesture snaps to the next/previous section (650ms lock), with a tall-section escape hatch
//   (native scroll until the section edge) and prefers-reduced-motion opt-out; active only on
//   the plain Step-1 view (no modal / loading). (3) Section + platform glyphs extracted to
//   constants/sectionIcons.jsx (incl. MODE_ICONS), reused by Step1Setup headers/cards AND the
//   breadcrumb. (4) Fonti
//   section 4→3 rows: "Documenti caricati" + "URL di riferimento" merged into one "Fonti
//   prioritarie" row (single toggle drives both userKbEnabled + refsEnabled — wire flags kept,
//   ZERO-BREAK), KB → "Knowledge Base Aziendale", web → "Abilita Ricerca web"; Riepilogo
//   "Fonti attive" chips collapsed to 3. (5) Output view (wizardStep 2): the shell Header now
//   shows a CgOutputHeader (portalled) — "Content Review" + platform badge, "Genera › Output"
//   breadcrumb (Genera → back to the form), and page-level Copia tutto / Scarica tutto (▾ md/
//   docx/pdf) acting on the latest output entry; the old "Torna alla generazione" / "Nuova
//   generazione" nav buttons removed. [ZERO-BREAK] pipeline, prompts, brief, and wire values
//   untouched (buildBriefRequest reads userKbEnabled/refsEnabled independently with empty-filters).
// [FEAT-v158] LoginScreen restyled to Brian UI 1.0 (light card, purple accent, Wix Madefor,
//   theme tokens + focus ring). TenantPicker/NoAccessScreen/BootSpinner still on legacy dark.
// [FEAT-v157] User profile fields (first_name/last_name/locale/last_login_at): self-service
//   edit via PATCH /auth/me (now the /profile page; sends only changed keys; blank→null),
//   userLabel/userInitial fallback to email, read-only Nome column in admin/tenant-admin user
//   lists + name/locale/last-login in UserDetailPage. Step1 Punti chiave/Indicazioni Editoriali:
//   dropped placeholders, inputs sized to match Argomento.
// [ARCH-v132] BE-served tenant logo + favicon; removed dead header block and showHeader prop.
// [ARCH-v133] Migrate tone to backend's new tone_hint field
//   - Drop tone_overrides; send top-level tone_hint: string | null instead
//   - brand-voice sent as literal (distinct from null per backend semantics)
//   - Regenerate-from-entry restores historical tone via toneStateFromParams
//   - New shared helper: src/utils/toneMigration.js
// [FEAT-v134] Step1 UX rifinitura — TASK→ARGOMENTO/TEMA/SOGGETTO; FOCUS+KEY POINTS riordinati e
//   rinominati in PUNTI CHIAVE (prima) + CONTESTO E ANGOLO (dopo); TUTTI i tooltip ⓘ
//   sostituiti da HelperLine sempre visibili (incluse PERSONA/OBIETTIVO/TONE/MODALITÀ
//   CONTENUTO/PARAMETRI MODALITÀ); rinomina sub-blocchi Ricerca (DOCUMENTI CARICATI, URL DI
//   RIFERIMENTO, RICERCA WEB); placeholder uniformati; dead-code IIFE "Suggerisci" e
//   componente Tooltip rimossi da Step1Setup. [ZERO-BREAK] pipeline e contract backend
//   invariati.
// [FEAT-v135] Examples Library Phase 1 integration — terzo bottone "Vedi esempi compilati"
//   in Step1Setup (gated dal content_format risolto), ExamplesPanel inline che fetcha
//   GET /api/v1/examples?tenant=…&content_format=… (lista con BriefEnvelope inlined per
//   item → hover-preview e load-on-click serviti da una sola round-trip), helper
//   briefEnvelopeToFormState che inverte resolvePlatformAndFormat e delega a
//   paramsToFormState. [ZERO-BREAK] pipeline invariata.
// [FEAT-v136] Blog-SEO keywords structured schema — split single "Keywords SEO" input
//   into "Keyword principale" + dynamic list of "Keyword secondarie" rows with optional
//   per-row vol/mese (cap 8, default 3 empty rows). New helpers serializeKeywords
//   (backendClient) + deserializeKeywords (paramsToFormState, accepts both new object
//   and legacy comma-string for backward-compat with stale localStorage). Export
//   formatter useHistory.collectInputRows special-cases the new shape so MD/PDF/DOCX
//   downloads render "primary; secondary (vol/mese); …" instead of [object Object].
//   State default DEFAULT_BLOG_PARAMS.keywords becomes {primary, secondary[]}.
//   [ZERO-BREAK] BE accepts both shapes during rollout; pipeline, prompts, and output
//   renderers unchanged.
// [FEAT-v137] Gestione Run admin section — new /admin/runs (list) and /admin/runs/:taskId
//   (detail) pages, gated by RequireSuperadmin. List view supports tenant selection (SA),
//   status chip filter, date range (default last 7 days, EXCLUSIVE upper bound), and
//   secondary filters (user/platform/content_format). Detail view fetches /status +
//   /content in parallel, renders metadata + result/research/reviews/sources panels via
//   JsonBlock, plus a Langfuse trace deep link (REACT_APP_LANGFUSE_URL). Back-button
//   preserves list filters via location.state.from.
// [FEAT-v137] apiFetch.suppressTenantHeader — new option that skips the X-Tenant-Id
//   header injection. Used by the admin runs API client so an explicit ?tenant= query
//   param always wins over any stale tenant context cached in localStorage.
// [FEAT-v138] Tenant-admin console — new /tenant-admin/users route (gated by RequireTenantAdmin)
//   lets users with user_tenants.role='admin' manage members of their active tenant: list (with
//   email filter + pagination), atomic create (POST /api/v1/tenant-admin/users with 409→attach
//   fallback), inline role select, deactivate (with USER_HAS_OTHER_TENANTS surfacing), and remove
//   from tenant via ConfirmDialog. New isTenantAdmin derived boolean on AuthContext. Separate BE
//   router /api/v1/tenant-admin/* — not piggybacking on /admin/*. SA actions and the detail page
//   (email/password edit, activate, GET-by-id) intentionally omitted pending BE additions.
//   [ZERO-BREAK] pipeline, prompts, and content-generator UX unchanged.
// [FEAT-v139] Landing input parameters wired end-to-end (GitLab issue "Input parameters
//   per 'Landing' mancanti"). resolvePlatformAndFormat now emits content_format:'landing'
//   (fixed). buildContentParams gains a landing case → headline_formula (always) +
//   social_proof (trimmed, omitted when blank). Step1Setup: landing removed from the
//   SPECIFICHE TECNICHE exclusion → new "Formula Headline" Sel (LANDING_HEADLINE_OPTIONS)
//   + "Social Proof (opzionale)" textarea; CTA testo/URL CTA inputs now also shown for
//   landing (intended). paramsToFormState reconstructs landingParams on run reload.
//   [ZERO-BREAK] pipeline, prompts, and output rendering unchanged (formatters switch on
//   mode, not content_format).
// [FEAT-v140] Cancel running pipeline: POST /pipeline/run/{id}/cancel (soft-cancel).
//   New cancelGeneration() in useGeneration; 'cancelled' terminal status → cancelled
//   history entry (no content); two-step confirm button in Step2Generate (pipeline
//   stepper only, not Suggerisci); PipelineStepper isCancelled state; styling = 409
//   non-cancellable. [ZERO-BREAK] for completed/failed paths and output rendering.
// [FEAT-v141] Instagram-post dedicated renderer: new InstagramResultEntry covers
//   QA bar, "anteprima feed" hook box, body paragraphs, CTA highlight, hashtag
//   chips (caption-placed 2-4), non-clickable "Link in bio" pointer for cta_url,
//   character-count budget bar (5 tiers up to ≤2200 IG hard cap), and FONTI
//   CITATE via SourcesCitedBlock. Dispatched in renderResultEntry by
//   r.platform === 'instagram' (content_format='post' is shared across
//   linkedin/facebook/instagram so platform is the discriminator). [ZERO-BREAK]
//   pipeline, prompts, formatters, and other variant renderers unchanged.
// [FEAT-v142] Landing-page dedicated renderer: new LandingResultEntry consumes
//   the structured content_format='landing' shape (7 blocks: HERO, PROBLEM,
//   SOLUTION, FEATURES, SOCIAL_PROOF, FAQ, FINAL_CTA + FONTI CITATE). Adds QA
//   bar (qa_score → style_compliance fallback), fixed Italian anchor IDs
//   (#hero, #problema, #soluzione, #caratteristiche, #social-proof, #faq,
//   #cta-finale), inline-HTML sanitization via sanitizeHtml, single
//   source-of-truth CTA URL (content.cta_url, disabled buttons when empty),
//   green HERO + FINAL_CTA CTA buttons, optional-block hide rules
//   (features.items/social_proof.bullets/faq empty → entire section hidden).
//   Dispatched in renderResultEntry by r.contentFormat === 'landing'.
//   Landing warnings (LANDING_REQUIRED_BLOCK_EMPTY,
//   LANDING_OPERATOR_SOCIAL_PROOF_DROPPED) get friendly Italian copy via the
//   existing outer chrome WarningBanner — extended in friendlyWarningCopy
//   (Step3History.jsx) with a consolidation helper that collapses multiple
//   per-field required-block warnings into one banner. Replaces a 22-line
//   dead stub that read a stale (pre-spec) field shape and was never wired
//   into the dispatcher. [ZERO-BREAK] pipeline, prompts, formatters, and
//   other variant renderers unchanged.
// [FEAT-v145] Pinterest-post dedicated renderer: new PinterestResultEntry
//   consumes the Path B typed shape (<BACKEND_FOLDER>/docs/frontend/pinterest-post-rendering.md
//   — pin_title, pin_description, board_suggestion, hashtags, cta_url,
//   full_text). Covers QA bar, bold pin title, plain description, "Board
//   consigliato:" line with bookmark icon, hashtag chips, destination
//   URL link, character-count budget bar (4 tiers up to ≤500 hard cap),
//   and FONTI CITATE via SourcesCitedBlock. Dispatched in
//   renderResultEntry by r.platform === 'pinterest'. Replaces the broken
//   fallback path that previously rendered Pinterest runs through the
//   generic structured branch (which reads empty hook/body/cta for the
//   Path B shape and shows nothing). [ZERO-BREAK] pipeline, prompts,
//   formatters, and other variant renderers unchanged.
// [FEAT-v144] YouTube long-form dedicated renderer: rewrites the stale
//   YouTubeResultEntry to consume the documented spec shape
//   (<BACKEND_FOLDER>/docs/frontend/youtube-post-rendering.md). Covers QA bar, bold title,
//   ALT 1/2 chips for title_variants, HOOK DESCRIZIONE pink-bordered box,
//   description prose (no label), CAPITOLI two-column block, TAG VIDEO
//   chips, THUMBNAIL + CTA SCRIPT side-by-side, SEO KEYWORDS 3-tier
//   (primary highlighted / secondary plain / long_tail italic-dashed),
//   hashtag chips, and FONTI CITATE via SourcesCitedBlock. Wired into
//   renderResultEntry by r.platform === 'youtube' — previously the
//   component was dead code (defined but never imported). [ZERO-BREAK]
//   pipeline, prompts, formatters, and other variant renderers unchanged.
// [FEAT-v143] Renderer label alignment + Facebook-post dedicated renderer:
//   (1) SourcesCitedBlock heading renamed globally from "PRINCIPALI FONTI DA
//   INCLUDERE" to "FONTI CITATE" (shared by Instagram/Newsletter/Landing).
//   (2) InstagramResultEntry hashtag block label renamed to "PRIMO COMMENTO
//   — HASHTAG (N)" to reflect IG first-comment best practice (channels.js
//   policy: "20-30 hashtag (nel primo commento)"). (3) New
//   FacebookResultEntry covers QA bar, hook box (FB blue), body paragraphs,
//   CTA highlight, hashtag chips (0-2 per channels.js policy), and FONTI
//   CITATE via SourcesCitedBlock. Dispatched in renderResultEntry by
//   r.platform === 'facebook'. [ZERO-BREAK] pipeline, prompts, formatters,
//   and other variant renderers unchanged.
// [FEAT-v146] Run Detail v2 — unified GET /pipeline/run/{id} fetch, full
//   brief + result rendering on /admin/runs/:taskId and /tenant-admin/runs/:taskId.
//   New: BriefPreview (extracted from ExamplesPanel), renderResultEntry (extracted
//   from this file), Disclosure-collapsible drafts/reviews/style/research/sources,
//   light theme constants, and tenant-admin "Ricarica nel Content Generator"
//   button that hands off brief_json + synthetic history entry via
//   location.state so the form pre-populates AND the output appears in History
//   without re-running the pipeline. [ZERO-BREAK] pipeline, prompts, output
//   renderers, and SA/TA gating semantics unchanged.
// [FEAT-v147] Dashboard reorganized into 3 narrative sections (Utilizzo & adozione /
//   Salute della pipeline / Qualità & efficienza). ChartCard gains a per-card
//   reliability badge (green "Tutto il periodo" vs amber "Campione: ultimi N");
//   replaces the inline withSampleDisclosure title suffix. Presentation-only —
//   no data fetching, chart math, or component internals changed. [ZERO-BREAK]
// [FEAT-v148] Tenant Credits dashboard — new /credits route (sections/Credits.jsx)
//   with a balance gauge (CreditBalanceCard, has-plan vs no-plan/untracked) and
//   per-user usage table (CreditUsageTable; email folds to short id for members,
//   $ column superadmin-only). New services/api/creditsApi.js (GET /credits/balance
//   + /credits/usage?group_by=user) + utils/creditsFormat.js (Decimal-string
//   parsing, it-IT credit formatting, USD, Rome-month label). Superadmin plan
//   settings: /admin/plans tab (PlanListPage + PlanModal CRUD) and per-tenant
//   balance/$ spend/subscription assignment on the tenant detail
//   (TenantCreditsSection in TenantManagementPage), backed by new adminApi plan/
//   subscription calls. Display-only — nothing gates a run on balance. [ZERO-BREAK]
//   content pipeline, prompts, and renderers untouched.
// [FEAT-v149] Storico Generazioni for plain members — new member-facing /runs (list)
//   and /runs/:taskId (detail) routes, ungated beyond AppShell auth. Reuses
//   TenantRunListPage + RunDetailPage (now path-aware: row-click/back paths derive
//   from location.pathname instead of a hardcoded /tenant-admin/ prefix). Sidebar
//   gains a "Storico Generazioni" entry for non-SA, non-tenant-admin users
//   (tenant-admins/SAs keep their console entries — no duplicate). FE-only: BE
//   /pipeline/runs is already tenant-scoped (not admin-only) and nulls creator PII
//   for non-admins, so members see the full tenant set and can "Ricarica nel
//   Content Generator" (button already gated !isSuperadmin && brief_json).
//   [ZERO-BREAK] content pipeline, prompts, and renderers untouched.
// [FEAT-v150] Knowledge Base documents corpus UI (tenant-admin + SA selector +
//   member read-only) — new src/context/ module (contextApi.js for /api/v1/context/*,
//   parseApiError.js error-envelope mapper, DocumentStatusBadge.jsx, reusable
//   DocumentsView.jsx keyed on an explicit tenantId). Mounted three ways: member
//   /knowledge-base (read-only; write affordances only for tenant admins), SA
//   /admin/knowledge-base (tenant dropdown, last-tenant remembered per-user),
//   tenant-admin /tenant-admin/knowledge-base. apiFetch now skips its JSON
//   Content-Type for FormData bodies so multipart uploads keep the browser
//   boundary. Sidebar + AdminLayout gain "Knowledge Base" entries.
//   [ZERO-BREAK] content pipeline, prompts, and renderers untouched.
// [FEAT-v151] Context config editor (website-urls / internal-links / tenant-settings /
//   tenant-profile) — raw text editor with ETag concurrency, PUT { raw } to preserve
//   comments; admin-only (tenant-admin + SA selector). New src/context/ContextConfigView.jsx
//   (4-item selector + monospace raw textarea, dirty gate, 412 reload-with-notice, 422
//   details.errors[] kept-draft) plus getSingleton/putSingleton/getTenantProfile/
//   putTenantProfile in contextApi.js (GET returns raw+etag, always PUT { raw } + If-Match).
//   Two surfaces: tenant-admin /tenant-admin/context-settings (canWrite=isTenantAdmin) and
//   SA /admin/context-settings (tenant dropdown). Sidebar + AdminLayout gain a
//   "Configurazione" entry; NO member surface. [ZERO-BREAK] content pipeline, prompts,
//   and renderers untouched.
// [FEAT-v152] Newsletter (linkedin-newsletter) setup UX — replace the "Genera
//   Companion Post" checkbox with a "STILE ARTICOLO" dropdown (helper "Struttura
//   dell'articolo") surfacing the dormant DEFAULT_EMAIL_PARAMS.articleStyle field
//   (thought-leader / how-to / trend-analysis / storytelling) via new
//   ARTICLE_STYLE_OPTIONS. Wired article_style into buildBriefRequest and restored
//   in paramsToFormState; companion post now always-on (include_companion_post:true
//   default still sent). [ZERO-BREAK] content pipeline, prompts, and renderers untouched.
// [FEAT-v153] Email-classic (newsletter email) setup UX — surface the dormant
//   DEFAULT_EMAIL_PARAMS.subjectStyle field via a new "STILE SUBJECT" dropdown
//   (curiosity / urgency / personal / value) gated on emailChannel==='email-classic',
//   backed by new SUBJECT_STYLE_OPTIONS. Wired subject_style into buildBriefRequest
//   (email-classic branch) and restored in paramsToFormState. [ZERO-BREAK] content
//   pipeline, prompts, and renderers untouched.
// [FEAT-v154] Interface i18n (Asse A) — IT+EN UI localization via react-i18next
//   (synchronous bundled resources, default+fallback 'it', localStorage 'app_locale',
//   IT/EN toggle in Header). All UI chrome resolves through t()/i18n.t() across 10
//   namespaces (common/errors/auth/shell/wizard/outputs/admin/context/dashboard/credits);
//   'it' values byte-identical so the existing suite passes unchanged. Enum values,
//   warning/error codes, and landing anchor IDs are never translated; option/mode/channel
//   labels kept in constants as fallback. Locale-aware number/month formatting
//   (creditsFormat) with USD currency + Europe/Rome billing month held fixed. Output/
//   generation language (Asse B) explicitly out of scope. [ZERO-BREAK] pipeline, prompts,
//   brief, and output rendering untouched.
// [FEAT-v155] Brian UI Phase-4 section polish — repaint the Content Generator Step-1
//   form (Step1Setup.jsx) to the Brian design: 36px section cards with circular-icon
//   headers, accent-selected format cards + check badge, segmented Post/Carosello,
//   post-length slider (Breve/Medio/Lungo), "Includi CTA" toggle (clears ctaText/ctaUrl
//   + resets ctaType on OFF), Argomento maxLength=200 + n/200 counter, and full-width
//   Fonti source rows with semantic tiles + 44×24 toggles. Rewrote Step-1 i18n section
//   copy (it+en, key-symmetric) to noun titles/subtitles + italianized options.postLength.
//   Reconciled two prior-phase divergences vs the delivered PNGs: removed the invented
//   cost-estimate aside badge and switched the sidebar brand to the "brian" wordmark
//   (dropped the legacy version pill). [ZERO-BREAK] pipeline, prompts, brief, wire values,
//   and output rendering untouched (slider maps the same short/medium/long; CTA absent
//   when the toggle is OFF).
// [FEAT-v156] Wizard navigation: removed the "1. Genera / 2. Output" stepper; the Output
//   view now has "Torna alla generazione" (preserves the brief) + "Nuova generazione"
//   (RESET_FORM — clears the brief/params + current outputs, keeps tenant + theme) and the
//   Anteprima view has "Torna all'output". Nav buttons use COLORS.accent (not the mode
//   color) and are disabled while a generation is in flight. [ZERO-BREAK] pipeline, prompts,
//   brief, and output rendering untouched.
// Target: ~200 lines.

import React, { useReducer, useRef, useEffect, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sparkles, ClipboardList, ChevronRight } from 'lucide-react';
import {
  ContentTypeIcon,
  BriefIcon,
  ParametriIcon,
  FontiIcon,
  OutputIcon,
  MODE_ICONS,
} from './constants/sectionIcons.jsx';

// Store
import { appReducer }         from './store/reducer.js';
import { createInitialState } from './store/initialState.js';

// Hooks
import { useGeneration }    from './hooks/useGeneration.js';
import { useHistory }       from './hooks/useHistory.js';
import { useClipboard }      from './hooks/useClipboard.js';
import { useContextOptions } from './hooks/useContextOptions.js';

// Utils
import { briefEnvelopeToFormState } from './utils/briefEnvelopeToFormState.js';
import { translateOptionLabel, resolveToneLabel, MISSING_LABEL } from './utils/optionLabels.js';

// Step components
import Step1Setup    from './components/steps/Step1Setup.jsx';
import Step2Generate from './components/steps/Step2Generate.jsx';
import Step3History  from './components/steps/Step3History.jsx';
import Step4Publish  from './components/steps/Step4Publish.jsx';

import { getModeConfig, ESC_ACCENT } from './constants/modes.js';
import { COLORS, FONT_SANS, RADII, SEMANTIC, SHADOW } from './constants/theme.js';
import { POST_LENGTH_OPTIONS, BLOG_LENGTH_OPTIONS, EMAIL_LENGTH_OPTIONS, CAROUSEL_SLIDE_OPTIONS } from './constants/options.js';
import { getBundle } from './services/api/uploadClient.js';
import renderResultEntry from './components/outputs/renderResultEntry.jsx';
import useRunGate from './hooks/useRunGate.js';
import { refusalFromBlockReason } from './utils/runRefusal.js';
import RunRefusalNotice from './components/credits/RunRefusalNotice.jsx';
import { PAGE_HEADER_SLOT_ID, PAGE_TITLE } from './components/ui/PageBand.jsx';
import { useContentInset } from './components/ui/modalArea.js';

// ─── Error Modal ─────────────────────────────────────────────────────────────

const ErrorModal = ({ message, onClose, t }) => {
  // Centred in the page's content area (beside the sidebar), like every app modal — components/ui/modalArea.js.
  const insetLeft = useContentInset(Boolean(message));
  if (!message) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px',
        ...(insetLeft ? { paddingLeft: `${insetLeft + 24}px` } : null),
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: t.inputBg || '#1a1a2e', borderRadius: RADII.control,
          border: `1.5px solid ${SEMANTIC.errore.bg}`,
          padding: '28px 28px 24px',
          maxWidth: '420px', width: '100%',
          boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
          <span style={{ fontSize: '20px' }}>⚠️</span>
          <span style={{ fontSize: '15px', fontWeight: 700, color: SEMANTIC.errore.fg }}>Errore</span>
        </div>
        <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.6, color: t.text, wordBreak: 'break-word' }}>
          {message}
        </p>
        <button
          onClick={onClose}
          style={{
            marginTop: '20px', width: '100%', padding: '10px',
            borderRadius: RADII.control, border: `1px solid ${SEMANTIC.errore.bg}`,
            background: SEMANTIC.errore.bg, color: SEMANTIC.errore.fg,
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Chiudi
        </button>
      </div>
    </div>
  );
};

// ─── Modal shell ─────────────────────────────────────────────────────────────
// Overlay chrome only — used by the run-refusal surface, whose body is the same
// RunRefusalNotice drawn inline beside the Generate button, so the pre-flight
// lock and the server's refusal read identically.
const ModalShell = ({ children, onClose }) => {
  // Centred in the page's content area (beside the sidebar), like every app modal — components/ui/modalArea.js.
  const insetLeft = useContentInset(true);
  return (
  <div
    onClick={onClose}
    style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
      ...(insetLeft ? { paddingLeft: `${insetLeft + 24}px` } : null),
    }}
  >
    <div onClick={e => e.stopPropagation()} style={{ maxWidth: '440px', width: '100%' }}>
      {children}
    </div>
  </div>
);
};

// ─── Leave-guard Modal ──────────────────────────────────────────────────────

const LeaveGuardModal = ({ type, onConfirm, onCancel, t }) => {
  // Centred in the page's content area (beside the sidebar), like every app modal — components/ui/modalArea.js.
  const insetLeft = useContentInset(true);
  return (
  <div
    onClick={onCancel}
    style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
      ...(insetLeft ? { paddingLeft: `${insetLeft + 24}px` } : null),
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: t.inputBg || '#1a1a2e', borderRadius: RADII.control,
        border: `1.5px solid rgba(245,158,11,0.4)`,
        padding: '28px 28px 24px',
        maxWidth: '420px', width: '100%',
        boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
        <span style={{ fontSize: '20px' }}>⚠️</span>
        <span style={{ fontSize: '15px', fontWeight: 700, color: SEMANTIC.attenzione.fg }}>Output presente</span>
      </div>
      <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.6, color: t.text }}>
        {type === 'generate'
          ? 'Hai output generati che verranno sovrascritti dalla nuova generazione. Copia i contenuti che vuoi conservare prima di procedere.'
          : 'Hai output generati che andranno persi. Copia i contenuti che vuoi conservare prima di procedere.'}
      </p>
      <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <button
          onClick={onCancel}
          style={{
            flex: 1, padding: '10px', borderRadius: RADII.control,
            border: `1px solid ${t.border || 'rgba(255,255,255,0.1)'}`,
            background: 'transparent', color: t.text,
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Resta qui
        </button>
        <button
          onClick={onConfirm}
          style={{
            flex: 1, padding: '10px', borderRadius: RADII.control,
            border: `1px solid ${SEMANTIC.attenzione.bg}`,
            background: SEMANTIC.attenzione.bg, color: SEMANTIC.attenzione.fg,
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Genera comunque
        </button>
      </div>
    </div>
  </div>
);
};

// ─── Content Generator breadcrumb ───────────────────────────────────────────
// "Content Generator" title + step chips rendered INTO the shell Header (left of
// the profile chip) via a portal — see the PAGE_HEADER_SLOT_ID target in Header.jsx.
// Section chips anchor-scroll to their card (#cg-*); the Output chip is disabled
// until an output exists, then jumps to the Output view. Active chip driven by
// the caller's scroll-spy. Uses shell theme tokens (COLORS) so it always matches
// the light header chrome regardless of the CG page's own light/dark theme.
// [FIX-v161] La riga di chip è ora un componente unico, condiviso dall'header
// della vista Input (CgBreadcrumb) e da quello della vista Output
// (CgOutputHeader): prima erano due markup distinti e potevano divergere.
// `isStepDisabled(step, index)` spegne i singoli chip di sezione — un chip
// disabilitato riceve l'attributo nativo `disabled` E nessun onClick, quindi
// non può navigare in nessun caso. `stepTitle(step, index)` alimenta il tooltip.
const BreadcrumbTrail = ({ steps, activeId, onSelectSection, isStepDisabled, stepTitle, output }) => {
  // `interactive` è separato da `disabled`: il chip Output della vista Output è
  // attivo (colore accent) ma non cliccabile — è la pagina corrente.
  const chipStyle = (active, disabled, interactive) => ({
    display: 'inline-flex', alignItems: 'center', gap: '8px',
    padding: '4px 8px', border: 'none', background: 'transparent',
    fontFamily: FONT_SANS, fontSize: '15px', fontWeight: 600,
    borderRadius: RADII.control, whiteSpace: 'nowrap',
    cursor: interactive ? 'pointer' : 'default',
    color: disabled ? COLORS.textTertiary : (active ? COLORS.accent : COLORS.textSecondary),
    transition: 'color 0.15s',
  });
  const chipColor = (active, disabled) =>
    (disabled ? COLORS.textTertiary : (active ? COLORS.accent : COLORS.textSecondary));
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '2px' }}>
      {steps.map((s, i) => {
        const active = s.id === activeId;
        const disabled = isStepDisabled ? Boolean(isStepDisabled(s, i)) : false;
        return (
          <React.Fragment key={s.id}>
            {i > 0 && <ChevronRight size={16} color={COLORS.textTertiary} style={{ flexShrink: 0 }} />}
            <button
              type="button"
              disabled={disabled}
              title={stepTitle ? stepTitle(s, i) : undefined}
              style={chipStyle(active, disabled, !disabled)}
              onClick={disabled ? undefined : () => onSelectSection(s.id)}
            >
              <s.Icon size={17} color={chipColor(active, disabled)} />
              {s.label}
            </button>
          </React.Fragment>
        );
      })}
      <ChevronRight size={16} color={COLORS.textTertiary} style={{ flexShrink: 0 }} />
      <button
        type="button"
        disabled={!output.enabled}
        title={output.enabled ? undefined : output.disabledTitle}
        style={chipStyle(output.active, !output.enabled, Boolean(output.enabled && output.onSelect))}
        onClick={output.enabled && output.onSelect ? output.onSelect : undefined}
      >
        <output.Icon size={17} color={chipColor(output.active, !output.enabled)} />
        {output.label}
      </button>
    </div>
  );
};

const CgBreadcrumb = ({ title, steps, activeId, onSelectSection, output }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: 0, width: '100%' }}>
    <h1 style={PAGE_TITLE}>
      {title}
    </h1>
    <BreadcrumbTrail
      steps={steps}
      activeId={activeId}
      onSelectSection={onSelectSection}
      output={output}
    />
  </div>
);

// ─── Content Generator output header ────────────────────────────────────────
// Portalled into the shell Header on the Output view (wizardStep 2): "Content
// Review" title + platform badge and the SAME breadcrumb trail della vista
// Input. Replaces the old back / new-generation nav.
// [FIX-v161] Le azioni page-level (Copia tutto / Scarica tutto) sono state
// rimosse: erano cablate solo sulla entry più recente (primaryEntry) e
// duplicavano i bottoni per-entry, che invece funzionano su tutte le entry.
// [FIX-v161] Il breadcrumb non è più il "Genera › Output" a sé stante ma
// BreadcrumbTrail con gli stessi chip di sezione della vista Input: chip di
// sezione disabilitati (nessuna scroll-spy fuori dal form) e chip Output
// attivo. Il ritorno al form (ex chip "Genera", onGenera → goToStep(1)) è
// agganciato al PRIMO chip di sezione — l'unico abilitato — così le due trail
// hanno esattamente gli stessi chip e la stessa larghezza nell'header.
const CgOutputHeader = ({ badge, steps, outputIcon = OutputIcon, onGenera, tw }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', width: '100%', minWidth: 0 }}>
      {/* Left: title + platform badge + breadcrumb */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <h1 style={{ ...PAGE_TITLE, whiteSpace: 'nowrap' }}>
            {tw('step3.contentReview')}
          </h1>
          {badge && (
            <span style={{ padding: '4px 12px', borderRadius: RADII.pill, background: COLORS.accentTint, color: COLORS.accent, fontSize: '13px', fontWeight: 700, fontFamily: FONT_SANS, whiteSpace: 'nowrap' }}>
              {badge}
            </span>
          )}
        </div>
        <BreadcrumbTrail
          steps={steps}
          activeId={null}
          onSelectSection={onGenera}
          isStepDisabled={(s, i) => i > 0}
          stepTitle={(s, i) => (i === 0 ? tw('step3.backToGenerate') : undefined)}
          output={{
            enabled: true,
            active: true,
            label: 'Output',
            Icon: outputIcon,
            onSelect: undefined,
          }}
        />
      </div>
    </div>
  );
};

// ─── Main component ───────────────────────────────────────────────────────────

const EscContentCreatorPro = ({ tenantId = null }) => {
  const [state, dispatch] = useReducer(appReducer, null, createInitialState);
  const stateRef         = useRef(state);
  stateRef.current       = state;
  const contentMemoryRef = useRef([]);
  const { t: tw }        = useTranslation('wizard');

  const { activeMode, isDarkMode, wizardStep } = state;

  // ── Theme ──────────────────────────────────────────────────────────────────
  const w = useCallback((opacity) =>
    isDarkMode
      ? `rgba(255,255,255,${opacity})`
      : `rgba(0,0,0,${Math.min(opacity * 2.5, 0.2).toFixed(2)})`
  , [isDarkMode]);

  const t = useMemo(() => isDarkMode
    ? { bg: 'linear-gradient(175deg, #08080d 0%, #0e0e18 40%, #0a0a12 100%)', text: COLORS.borderStrong, textSoft: '#c0c0d0', textMuted: COLORS.textTertiary, textFaint: '#555568', textDim: '#484858', surface: 'rgba(255,255,255,0.02)', border: 'rgba(255,255,255,0.07)', inputBg: 'rgba(255,255,255,0.04)', inputBorder: 'rgba(255,255,255,0.08)', btnText: '#0a0a0f' }
    : { bg: COLORS.bg, text: COLORS.ink, textSoft: COLORS.ink, textMuted: COLORS.textSecondary, textFaint: COLORS.textTertiary, textDim: COLORS.textTertiary, surface: COLORS.surface, border: COLORS.border, inputBg: COLORS.field, inputBorder: COLORS.inputBorder, btnText: COLORS.surface }
  , [isDarkMode]);

  const c = wizardStep === 1 ? ESC_ACCENT : (getModeConfig(activeMode)?.color || COLORS.accent);

  // ── Hooks ──────────────────────────────────────────────────────────────────
  const { handleGenerate, regenerateFromEntry, cancelGeneration } =
    useGeneration({ dispatch, stateRef });

  const { deleteEntry, confirmOutput, exportEntry } =
    useHistory({ state, dispatch, contentMemoryRef });

  const { personaOptions, objectiveOptions, toneOptions } = useContextOptions();

  // Reconcile the selected persona/objective when the backend options load. The
  // hardcoded defaults (e.g. 'cmo-marketing-leader') may not exist in a tenant's
  // context list; without this the <select> falls back to showing its first option
  // while state keeps the stale id — so generation sent the wrong value and the
  // Riepilogo showed "—". Snap state to a valid option so form + summary agree.
  useEffect(() => {
    if (personaOptions.length && !personaOptions.some(o => o.value === stateRef.current.persona)) {
      dispatch({ type: 'SET_KEY', key: 'persona', value: personaOptions[0].value });
    }
  }, [personaOptions, dispatch]);
  useEffect(() => {
    if (objectiveOptions.length && !objectiveOptions.some(o => o.value === stateRef.current.objective)) {
      dispatch({ type: 'SET_KEY', key: 'objective', value: objectiveOptions[0].value });
    }
  }, [objectiveOptions, dispatch]);

  // Tone reconcile. Two cases:
  //  (a) tone === 'custom' — a FE-only value the BE never lists, so it is never
  //      "stale". But briefEnvelopeToFormState runs in the mount effects below
  //      (RunDetailPage handoff, Examples, file import) BEFORE this fetch lands,
  //      with an empty preset registry — a tenant slug it could not recognise was
  //      parked in customTone. If it matches a preset now, snap it back.
  //  (b) any other tone missing from the list is genuinely stale (preset rinominato
  //      o rimosso dal tenant). NON lo sostituiamo con la brand voice: il BE tratta
  //      uno slug sconosciuto come testo libero di passthrough, quindi rigenerare
  //      con lo slug originale riproduce il tono del run originale, mentre snapparlo
  //      alla brand voice cambierebbe il contenuto in silenzio. Lo spostiamo quindi
  //      in "Personalizzato" conservando lo slug come testo libero — che è anche il
  //      punto in cui l'utente lo vede e può cambiarlo. Solo se non c'è nulla da
  //      conservare (tone vuoto) ripieghiamo sulla brand voice, che il BE marca con
  //      is_brand_default e garantisce sempre presente.
  // Keyed on toneOptions only, so it never fires while the user is typing.
  useEffect(() => {
    if (!toneOptions.length) return;
    const { tone: current, customTone } = stateRef.current;
    if (current === 'custom') {
      const hint = (customTone || '').trim();
      if (!hint) return;
      const match = toneOptions.find(o =>
        o.value !== 'custom' &&
        (o.value === hint || String(o.label).toLowerCase() === hint.toLowerCase()));
      if (match) {
        dispatch({ type: 'SET_BATCH', payload: { tone: match.value, customTone: '' } });
      }
      return;
    }
    if (toneOptions.some(o => o.value === current)) return;
    if (current) {
      dispatch({ type: 'SET_BATCH', payload: { tone: 'custom', customTone: current } });
      return;
    }
    const brand = toneOptions.find(o => o.is_brand_default) || toneOptions[0];
    dispatch({ type: 'SET_KEY', key: 'tone', value: brand.value });
  }, [toneOptions, dispatch]);

  // ── Track saved entries ──────────────────────────────────────────────────
  // An entry counts as saved once «Copia tutto» put every piece on the
  // clipboard: the ready block's button id is "all-<entryId>" (pieces/
  // ReadyToPublish.jsx :: readyCopyId), and the card offers no download. The
  // leave-guard keeps warning for every other output.
  const downloadedIdsRef = useRef(new Set());
  const COPY_ALL_PREFIX = 'all-';

  const { copy } = useClipboard({
    onSuccess: (id) => {
      dispatch({ type: 'SET_KEY', key: 'copiedId', value: id });
      setTimeout(() => dispatch({ type: 'SET_KEY', key: 'copiedId', value: null }), 2500);
      if (typeof id === 'string' && id.startsWith(COPY_ALL_PREFIX)) {
        downloadedIdsRef.current.add(id.slice(COPY_ALL_PREFIX.length));
      }
    },
  });

  // Sync tenantId prop into reducer when mounted inside AppShell
  useEffect(() => {
    if (tenantId) dispatch({ type: 'SET_KEY', key: 'tenant', value: tenantId });
  }, [tenantId, dispatch]);

  // Fetch upload bundle on mount
  useEffect(() => {
    let cancelled = false;
    getBundle().then(bundle => {
      if (!cancelled) {
        const files = bundle.files || [];
        dispatch({ type: 'SET_UPLOAD_BUNDLE_FILES', files });
        if (files.length > 0) {
          dispatch({ type: 'SET_KEY', key: 'userKbEnabled', value: true });
        }
      }
    }).catch(() => {}); // 404 or error — treat as empty
    return () => { cancelled = true; };
  }, [dispatch]);

  // ── Shared renderer props ──────────────────────────────────────────────────
  const rendererProps = {
    copiedId: state.copiedId,
    onCopy: copy,
    w,
    t,
  };

  const dismissError = useCallback(() => dispatch({ type: 'SET_KEY', key: 'error', value: null }), [dispatch]);

  // ── Wizard back navigation (Anteprima → Output; Output back handled by header) ──
  const goToStep  = useCallback((n) => dispatch({ type: 'SET_KEY', key: 'wizardStep', value: n }), [dispatch]);
  const navBtnBase = {
    padding: '9px 16px', borderRadius: RADII.control, fontSize: '13px', fontWeight: 600,
    fontFamily: FONT_SANS, transition: 'all 0.15s',
  };
  // neutral back button
  const navBtn = { ...navBtnBase, border: `1px solid ${t.border}`, background: t.surface, color: t.textMuted };
  // disabled while a generation is in flight
  const navDisabledStyle = state.isLoading ? { opacity: 0.5, cursor: 'not-allowed' } : { cursor: 'pointer' };

  // ── Leave-guard: warn only if an output hasn't been copied whole ───────
  const hasUndownloadedOutput = useCallback(() => {
    const history = stateRef.current.outputHistory || [];
    return history.length > 0 && history.some(e =>
      e.results?.status !== 'cancelled' && !downloadedIdsRef.current.has(String(e.id)));
  }, [stateRef]);

  // ── Run gate: credit lock (PB4) + the leave-guard, one funnel ────────────
  // useRunGate owns both the Ctrl/Cmd+Enter listener and guardedGenerate, so
  // the button and the keyboard shortcut cannot diverge. The credit check runs
  // before the leave-guard: confirming an overwrite for a run that will be
  // refused would throw the user's output away for nothing.
  const {
    guardedGenerate, pendingAction, confirmAction, cancelAction,
    blocked: generationBlocked, blockReason, periodEnd,
  } = useRunGate({ dispatch, handleGenerate, hasUndownloadedOutput, downloadedIdsRef });

  // The lock the user must see BEFORE clicking (pre-flight), and the verdict
  // that arrived on the run itself, are the same component with the same copy.
  const preflightRefusal = generationBlocked ? refusalFromBlockReason(blockReason || 'BLOCKED') : null;
  const dismissRefusal = useCallback(
    () => dispatch({ type: 'SET_KEY', key: 'runRefusal', value: null }),
    [dispatch],
  );

  // ⛔ The Examples Library modal (#esempi) is gone: its backend route was
  // removed on 2026-08-04 (q@363f0d8). `location` and `navigate` stay — the
  // cross-route reload from RunDetailPage below is the remaining consumer.
  const location = useLocation();
  const navigate = useNavigate();

  // ── Cross-route reload from RunDetailPage ────────────────────────────────
  // RunDetailPage (run inspector) navigates here with brief + history entry in
  // location.state; we hydrate the form and prepend the historical output to
  // outputHistory so the user sees both inputs and outputs in one place.
  // Clearing state via navigate(replace) prevents re-import on page refresh.
  useEffect(() => {
    const preloaded = location.state?.preloadedBrief;
    if (!preloaded) return;
    const formState = briefEnvelopeToFormState(preloaded);
    const importedEntry = location.state.preloadedHistoryEntry;
    const prevHistory = stateRef.current.outputHistory || [];
    dispatch({ type: 'SET_BATCH', payload: {
      ...formState,
      wizardStep: 1,
      error: null,
      outputHistory: importedEntry ? [importedEntry, ...prevHistory] : prevHistory,
    }});
    // Clear navigation state so refresh doesn't re-import
    navigate(location.pathname, { replace: true, state: null });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  // ── Keyboard shortcut Ctrl+Enter ──────────────────────────────────────────
  // Lives inside useRunGate, beside guardedGenerate — the two call sites (this
  // shortcut and the Generate button) must share one gate, and keeping the
  // listener here made it possible to gate one and forget the other.

  // ── Breadcrumb scroll-spy (Step-1 only) ───────────────────────────────────
  // Scroll happens on the AppShell's `.app-main` container, not the window.
  // Scrolling itself is native and continuous: the wheel is NOT intercepted, so
  // the page never snaps or stalls between section cards. This effect only reads
  // the scroll position to light up the matching breadcrumb chip; clicking a chip
  // still animates to its section via scrollToId, which is an explicit navigation
  // action rather than something imposed on a free scroll gesture.
  const SECTIONS = useMemo(() => ([
    { id: 'cg-tipo',      label: tw('step1.platform.label'), Icon: ContentTypeIcon },
    { id: 'cg-brief',     label: tw('step1.topic.cardTitle'), Icon: BriefIcon },
    { id: 'cg-parametri', label: tw('step1.params.cardTitle'), Icon: ParametriIcon },
    { id: 'cg-fonti',     label: tw('step1.sources.title'), Icon: FontiIcon },
  ]), [tw]);

  const [activeId, setActiveId] = useState('cg-tipo');

  // The breadcrumb is portalled into the shell Header (PAGE_HEADER_SLOT_ID, shared with PageBand since v193).
  const [headerSlotEl, setHeaderSlotEl] = useState(null);
  useEffect(() => { setHeaderSlotEl(document.getElementById(PAGE_HEADER_SLOT_ID)); }, []);

  const outputAvailable = (state.outputHistory || []).length > 0;
  const formVisible = (wizardStep || 1) === 1
    && !(state.isLoading && state.pipelineProgress);
  const anyModalOpen = Boolean(state.error || state.runRefusal || pendingAction);
  const scrollNavEnabled = formVisible && !anyModalOpen;

  // Output view: header shows Content Review + actions on the latest entry.
  const primaryEntry = (state.outputHistory || [])[0];
  const outputVisible = wizardStep === 2 && Boolean(primaryEntry);

  // Header lives ABOVE the .app-main scroll area (no overlap) — a small gap suffices.
  const headerOffset = useCallback(() => 16, []);

  const scrollToId = useCallback((id) => {
    const container = document.querySelector('.app-main');
    const el = document.getElementById(id);
    if (!container || !el) return;
    const cRect = container.getBoundingClientRect();
    const top = container.scrollTop + (el.getBoundingClientRect().top - cRect.top) - headerOffset();
    container.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    setActiveId(id);
  }, [headerOffset]);

  useEffect(() => {
    if (!scrollNavEnabled) return;
    const container = document.querySelector('.app-main');
    if (!container) return;
    const ids = SECTIONS.map(s => s.id);
    const getEls = () => ids.map(id => document.getElementById(id)).filter(Boolean);
    let rafPending = false;

    const computeActive = () => {
      const els = getEls();
      if (!els.length) return;
      const cRect = container.getBoundingClientRect();
      const line = cRect.top + headerOffset() + 4;
      let cur = els[0].id;
      for (const el of els) { if (el.getBoundingClientRect().top <= line) cur = el.id; }
      setActiveId(cur);
    };
    const onScroll = () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => { rafPending = false; computeActive(); });
    };
    container.addEventListener('scroll', onScroll, { passive: true });
    computeActive();
    return () => {
      container.removeEventListener('scroll', onScroll);
    };
  }, [scrollNavEnabled, SECTIONS, headerOffset]);

  // Trailing space after the last section, so it can scroll up to the header line
  // like every other card. Shrinks to 0 once the section is taller than the viewport.
  const [tailSpace, setTailSpace] = useState(0);
  useEffect(() => {
    if (!scrollNavEnabled) { setTailSpace(0); return; }
    const container = document.querySelector('.app-main');
    const last = document.getElementById(SECTIONS[SECTIONS.length - 1]?.id);
    if (!container || !last) return;
    const recompute = () => {
      const free = container.clientHeight - last.offsetHeight - headerOffset() - 24;
      setTailSpace(Math.max(0, Math.round(free)));
    };
    recompute();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', recompute);
      return () => window.removeEventListener('resize', recompute);
    }
    const ro = new ResizeObserver(recompute);
    ro.observe(container);
    ro.observe(last);
    return () => ro.disconnect();
  }, [scrollNavEnabled, SECTIONS, headerOffset]);

  // ── Step-1 summary aside (presentational; Brian UI 1.0 §5 merged Riepilogo + Costo) ──
  //
  // [FIX-v161] Le label passano dallo stesso percorso i18n del form
  // (options.<group>.<value>). Prima il Riepilogo usava la label GREZZA del
  // backend mentre i Parametri traducevano: stesso valore, due testi diversi
  // ("Drive Traffic" nel form, "Aumentare il Traffico" nel Riepilogo).
  const optLabel = (group, val, opts) => translateOptionLabel(tw, group, val, opts);

  // Mirrors the length sliders in Step1Setup: whichever control the active channel
  // shows is the one reported here.
  //
  // Carousel is the case that used to read wrong. A carousel's length is its slide
  // count, not a post length — and reloading a run via "Modifica" restores
  // carouselParams WITHOUT linkedInParams (paramsToFormState branches on
  // content_format), so reading postLength showed a stale default that had nothing
  // to do with the reloaded run.
  //
  // Social / Landing / Case Study / Ads expose no length control at all, so they
  // report '—' — the same empty marker translateOptionLabel uses for any unset row.
  const lengthSummary = activeMode === 'linkedin-post'
    ? (state.contentFormat === 'carousel'
        ? optLabel('carouselSlide', state.carouselParams?.slideCount, CAROUSEL_SLIDE_OPTIONS)
        : optLabel('postLength', state.linkedInParams?.postLength, POST_LENGTH_OPTIONS))
    : activeMode === 'blog-seo'
      ? optLabel('blogLength', state.blogParams?.articleLength, BLOG_LENGTH_OPTIONS)
      : activeMode === 'email'
        ? optLabel('emailLength', state.emailParams?.emailLength, EMAIL_LENGTH_OPTIONS)
        : MISSING_LABEL;

  const riepilogoRows = [
    // [FEAT-v161] Argomento in testa: è il primo campo che l'utente compila e
    // mancava del tutto dal Riepilogo.
    [tw('step3.meta.topic'), state.taskText?.trim() || MISSING_LABEL],
    ['Tipo', getModeConfig(activeMode)?.name || activeMode],
    ['Formato', state.contentFormat === 'carousel' ? 'Carousel' : 'Post'],
    ['Persona', optLabel('persona', state.persona, personaOptions)],
    ['Obiettivo', optLabel('objective', state.objective, objectiveOptions)],
    ['Tono', state.tone === 'custom' && state.customTone?.trim()
      ? `${tw('step1.params.toneCustomPrefix')}${state.customTone.trim().length > 40
          ? state.customTone.trim().slice(0, 39) + '…'
          : state.customTone.trim()}`
      : resolveToneLabel(tw, state.tone, toneOptions)],
    // Length is per-mode — each channel stores its own. Reading the LinkedIn
    // postLength unconditionally showed the wrong value (and never changed)
    // whenever the active mode was Blog SEO or Email.
    ['Lunghezza', lengthSummary],
  ];
  // [FIX-v161] Il chip "Fonti prioritarie" era acceso da un OR fra il toggle e la
  // presenza di URL, quindi restava acceso in entrambe le direzioni: togliendo
  // gli URL (il toggle restava true) o spegnendo il toggle (gli URL restavano).
  // Ora richiede il toggle acceso E almeno una fonte reale — la stessa semantica
  // "un flag, un chip" che rende corretti KB e Ricerca web.
  const hasPriorityContent =
    (state.referenceUrls || []).some(u => u && u.trim()) ||
    (state.uploadBundle?.files || []).length > 0;
  const activeSources = [
    (state.userKbEnabled || state.refsEnabled) && hasPriorityContent
      && { label: 'Fonti prioritarie', sem: SEMANTIC.viola },
    state.kbSearch?.enabled && { label: 'Knowledge Base Aziendale', sem: SEMANTIC.verde },
    state.webSearch?.enabled && { label: 'Ricerca web', sem: SEMANTIC.info },
  ].filter(Boolean);
  // ⚠️ `generationBlocked` is `can_generate === false` and NOTHING else — never
  // a number. `remaining_credits` is null both for an unlimited plan (may run
  // forever) and for no plan at all (blocked), so only `can_generate` separates
  // them. The keyboard path is gated inside useRunGate, not here.
  const generateDisabled =
    state.isLoading || generationBlocked || !state.taskText || state.taskText.trim().length < 10;

  const summaryAside = (
    <aside style={{
      background: t.surface, border: `1px solid ${t.border}`, borderRadius: RADII.section,
      padding: '24px', boxShadow: SHADOW.card, fontFamily: FONT_SANS, alignSelf: 'start',
      position: 'sticky', top: '16px', display: 'flex', flexDirection: 'column', gap: '18px',
    }}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '40px', height: '40px', borderRadius: RADII.pill, flexShrink: 0,
            border: `1px solid ${t.border}`, background: t.surface,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <ClipboardList size={20} color={t.text} strokeWidth={1.8} />
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 700, color: t.text }}>Riepilogo</h3>
        </div>
        <div style={{ marginTop: '16px' }}>
          {riepilogoRows.map(([k, v], i) => (
            <div key={k} style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', padding: '8px 0', borderBottom: i < riepilogoRows.length - 1 ? `1px solid ${t.border}` : 'none' }}>
              <span style={{ fontSize: '12px', color: t.textFaint }}>{k}</span>
              <span style={{ fontSize: '12px', fontWeight: 600, color: t.text, textAlign: 'right' }}>{v}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div style={{ fontSize: '12px', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase', color: t.textFaint, marginBottom: '10px' }}>Fonti attive</div>
        {activeSources.length ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {activeSources.map(s => (
              <span key={s.label} style={{ background: s.sem.bg, color: s.sem.fg, borderRadius: RADII.source, padding: '4px 12px', fontSize: '12px', fontWeight: 600 }}>{s.label}</span>
            ))}
          </div>
        ) : (
          <span style={{ fontSize: '12px', color: t.textFaint }}>Nessuna fonte attiva</span>
        )}
      </div>

      <div style={{ borderTop: `1px solid ${t.border}`, paddingTop: '18px' }}>
        {/* The lock has to be legible where the user tries to act — a disabled
            button with no explanation reads as a bug. Same copy and same CTA
            the server would send, so a 402 that slips past the pre-flight
            (shared customer wallet, 60s cache) does not look like a new
            problem. */}
        {preflightRefusal && (
          <div style={{ marginBottom: '14px' }}>
            <RunRefusalNotice refusal={preflightRefusal} periodEnd={periodEnd} />
          </div>
        )}
        <button
          onClick={guardedGenerate}
          disabled={generateDisabled}
          style={{
            width: '100%', padding: '12px 24px', borderRadius: RADII.control, border: 'none',
            background: c, color: COLORS.surface, fontSize: '14px', fontWeight: 600, fontFamily: FONT_SANS,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            cursor: generateDisabled ? 'not-allowed' : 'pointer', opacity: generateDisabled ? 0.5 : 1, transition: 'all 0.2s',
          }}
        >
          <Sparkles size={16} />
          Genera contenuto
        </button>

        {/* TODO: wire draft save — inert placeholder per design */}
        <button
          type="button"
          disabled
          title="Presto disponibile"
          style={{
            width: '100%', marginTop: '10px', padding: '12px 24px', borderRadius: RADII.control,
            border: `1px solid ${t.inputBorder}`, background: t.surface, color: t.textMuted,
            fontSize: '14px', fontWeight: 600, fontFamily: FONT_SANS, cursor: 'not-allowed', opacity: 0.7,
          }}
        >
          Salva bozza
        </button>
      </div>
    </aside>
  );

  return (
    <div style={{ minHeight: '100vh', background: t.bg, color: t.text, fontFamily: FONT_SANS }}>
      <style>{`
        .cg-two-col { display: grid; grid-template-columns: minmax(0, 1fr) 280px; gap: 24px; align-items: start; }
        @media (max-width: 980px) { .cg-two-col { grid-template-columns: 1fr; } }
      `}</style>
      <ErrorModal message={state.error} onClose={dismissError} t={t} />
      {/* A refusal is a verdict, not a failure: it gets its own surface with a
          CTA rather than the generic error modal, and useGeneration keeps the
          two mutually exclusive so they can never stack. */}
      {state.runRefusal && (
        <ModalShell onClose={dismissRefusal}>
          <RunRefusalNotice
            refusal={state.runRefusal}
            periodEnd={periodEnd}
            onDismiss={dismissRefusal}
          />
        </ModalShell>
      )}
      {pendingAction && <LeaveGuardModal type={pendingAction.type} onConfirm={confirmAction} onCancel={cancelAction} t={t} />}
      {headerSlotEl && formVisible && createPortal(
        <CgBreadcrumb
          title="Content Generator"
          steps={SECTIONS}
          activeId={activeId}
          onSelectSection={scrollToId}
          output={{
            enabled: outputAvailable,
            active: false,
            label: 'Output',
            Icon: MODE_ICONS[activeMode] || OutputIcon,
            onSelect: () => goToStep(2),
            disabledTitle: tw('step3.empty'),
          }}
        />,
        headerSlotEl,
      )}
      {headerSlotEl && outputVisible && createPortal(
        <CgOutputHeader
          badge={primaryEntry?.modeConfig?.name || primaryEntry?.mode}
          steps={SECTIONS}
          outputIcon={MODE_ICONS[activeMode] || OutputIcon}
          onGenera={() => goToStep(1)}
          tw={tw}
        />,
        headerSlotEl,
      )}
      <div style={{ maxWidth: '1180px', margin: '0 auto', padding: '24px clamp(16px, 4vw, 48px)' }}>

        {/* ── Step 1: Genera ── */}
        {(wizardStep || 1) === 1 && (
          <>
            {/* Crea Contenuto loading → full stepper */}
            {state.isLoading && state.pipelineProgress ? (
              <Step2Generate
                progress={state.pipelineProgress}
                color={c}
                w={w}
                t={t}
                onCancel={cancelGeneration}
              />
            ) : (
              <div className="cg-two-col">
                <div style={{ minWidth: 0 }}>
                  <Step1Setup
                    state={state}
                    dispatch={dispatch}
                    color={c}
                    w={w}
                    t={t}
                    personaOptions={personaOptions}
                    objectiveOptions={objectiveOptions}
                    toneOptions={toneOptions}
                  />
                  <div aria-hidden="true" style={{ height: `${tailSpace}px` }} />
                </div>
                {summaryAside}
              </div>
            )}
          </>
        )}

        {/* ── Step 2: Output (title/breadcrumb/actions live in the shell header) ── */}
        {wizardStep === 2 && (
          <>
            <Step3History
              state={state}
              onRegenerate={regenerateFromEntry}
              onConfirm={confirmOutput}
              onDelete={deleteEntry}
              renderEntry={(entry) => renderResultEntry(entry, rendererProps)}
              color={c}
              w={w}
              t={t}
              tonePresets={toneOptions}
            />
          </>
        )}

        {/* ── Step 3: Anteprima ── */}
        {wizardStep === 3 && (
          <>
            <div style={{ marginBottom: '16px' }}>
              <button onClick={() => goToStep(2)} disabled={state.isLoading} style={{ ...navBtn, ...navDisabledStyle }}>
                ← {tw('step4.backToOutput')}
              </button>
            </div>
            <Step4Publish
              state={state}
              onExport={exportEntry}
              renderEntry={(entry) => renderResultEntry(entry, rendererProps)}
              color={c}
              w={w}
              t={t}
            />
          </>
        )}

      </div>
    </div>
  );
};

export default EscContentCreatorPro;
